/*
 * Ce fichier répertorie les composants de BI.
 * La page "jquery-bi.html" donne une idée du rendu mais ne permet pas d'interragir car il faut actuellement pour cela un serveur et des données.
 */
window.BI = (function($, moment, BaseAPI) {
"use strict";

var BI = {};

BI.buildElement = BaseAPI.buildElement;
BI.compareCaption = function(i1, i2) { return i1.caption.localeCompare(i2.caption); };
BI.getCaption = function(item) { return item.caption || item.defaultCaption || ''; };
BI.isFilteredLevel = function(level) { return level.defaultState !== 'Visible' || level.hasCustomStates; };
BI.isValue = function(value) { return value !== null && value !== undefined; };
BI.layoutRow = function() {
	var self = {
		tr: BI.buildElement('tr').attr('class', 'bbm-report-layout-row'),
		width: 0,
		add: function(width) {
			self.width += width;
			return BI.buildElement('td').css('width', width + 'px').appendTo(self.tr);
		}
	};
	return self;
};

/** Les options par défaut, afin de pouvoir les changer au niveau applicatif, comme pour le style des checkbox par exemple */
BI.options = {
	/** La langue à utiliser (les langues disponibles sont définies dans BI.langs) */
	lang: 'fr',
	/** Le contenu HTML à afficher pour indiquer un tri ascendant */
	templateSortAscending: $('<i class="material-icons material-icons-16" style="transform:rotate(-45deg); float: left; ">arrow_forward</i>')[0],
	/** Le contenu HTML à afficher pour indiquer un tri descendant */
	templateSortDescending: $('<i class="material-icons material-icons-16" style="transform:rotate(45deg); float: left; ">arrow_forward</i>')[0],
	/** Le contenu HTML à afficher pour les valeurs "true" */
	templateChecked: '<i class="material-icons material-icons-16">check_box</i>',
	/** Le contenu HTML à afficher pour les valeurs "false" */
	templateUnchecked: '',
	/** Le template HTML pour l'icone d'un noeud déployé */
	templateExpanded: $('<i class="material-icons material-icons-16" style="cursor: pointer; ">remove_circle</i>&nbsp;')[0],
	/** Le template HTML pour l'icone d'un noeud diminué */
	templateCollapsed: $('<i class="material-icons material-icons-16" style="cursor: pointer; ">add_circle</i>&nbsp;')[0],
	/** Le template HTML pour l'icone d'une feuille */
	templateLeaf: $('<i class="material-icons material-icons-16"></i>&nbsp;')[0],
	/** Le format "moment" pour les dates */
	dateFormat: 'L',
	/** Le format "moment" pour les heures */
	timeFormat: 'LT',
	/** Le format "moment" pour les dates+heures */
	datetimeFormat: 'L LT',
};

/** Liste des langues supportées par le BI */
BI.langs = {
	en: {
		locale: 'en',
		totals: 'TOTALS',
		yes: 'Yes',
		no: 'No',
		currency: 'EUR%VALUE%', // symbole monétaire moyen, avant et sans espace
		percent: '%VALUE%%', // symbole % après et sans espace
		kilograms: '%VALUE%kg',
		grams: '%VALUE%g',
		kilometers: '%VALUE%km',
		meters: '%VALUE%m',
		seconds: '%VALUE%s',
		searchPlaceholder: 'Search...',
		extraMeasuresLabel: 'Measures',
		extraLevelsLabel: 'Levels',
		rowLevelsLabel: 'Rows',
		colLevelsLabel: 'Columns',
		measureGroupsHeader: 'Groups',
		measureNamesHeader: 'Measures',
		paginationFirstPage: 'First page',
		paginationPreviousPage: 'Previous page',
		paginationNextPage: 'Next page',
		paginationLastPage: 'Last page',

		configurationCloseButton: 'Close',
		configurationValidateButton: 'Validate',
		configurationOptionsTab: 'Options',
		configurationLevelsTab: 'Levels',
		configurationMeasuresTab: 'Measures',
		configurationRowLevelsSection: 'Row levels',
		configurationColLevelsSection: 'Column levels',
		configurationExtraLevelsSection: 'Accessible levels',
		configurationFilteredLevelsSection: 'Filtered levels',
		configurationVisibleMeasuresSection: 'Visible measures',
		configurationExtraMeasuresSection: 'Accessible measures',
		configurationCalculatedMeasuresSource: 'Calculated measures',
		configurationAddButton: 'Add',
		configurationRemoveButton: 'Remove',
		configurationCustomizeButton: 'Customize',
		configurationAddGroupButton: 'Add a new measure group',
		configurationAddGroupCaption: 'New measure group',
		configurationAddCalculationButton: 'Add a new calculation',
		configurationAddCalculationCaption: 'New calculation',
		configurationOptionCaption: 'Report caption',
		configurationOptionMeasureOnCols: 'Display measures as columns',
		configurationOptionCalculate: 'Activate auto-calculation',
		configurationOptionCalculateOnlyVisibleMeasures: 'Calculate only visible measures',
		configurationOptionHideEmpty: 'Hide empty rows and columns',
		configurationOptionHideEmptyUsingVisibleMeasures: 'Consider empty using visible measures',
		configurationOptionHideFixedMeasures: 'Hide fixed measures',
		configurationOptionRowTotalsPosition: 'Row totals position',
		configurationOptionColTotalsPosition: 'Column totals position',

		filtersValidateButton: 'Validate',
		filtersCancelButton: 'Cancel',
		filtersAddButton: 'Add field',
		filtersRemoveButton: 'Remove field',
		filtersFieldHeader: 'Field',
		filtersOperatorHeader: 'Operator',
		filtersValueHeader: 'Value',
		filtersMinPlaceholder: 'Min',
		filtersMaxPlaceholder: 'Max',

		popoverTabRename: 'Rename',
		popoverTabAttributes: 'Attributes',
		popoverTabFilters: 'Filters',
		popoverTabFormat: 'Format',
		popoverTabColors: 'Colors',
		popoverTabFormula: 'Calculation',
		popoverButtonSortAscending: 'Sort ascending',
		popoverButtonSortDescending: 'Sort descending',
		popoverButtonMeasureSort: 'Change measure sort',
		popoverButtonExpandAll: 'Expand all',
		popoverButtonCollapseAll: 'Collapse all',
		popoverButtonShow: 'Show',
		popoverButtonShowInRows: 'Show in rows',
		popoverButtonShowInCols: 'Show in columns',
		popoverButtonHide: 'Hide',
		popoverButtonDelete: 'Delete',
		popoverButtonCancel: 'Cancel',
		popoverButtonValidate: 'Validate',
		popoverCaptionPlaceholder: 'Caption',
		popoverLevelAdvancedFiltersLabel: 'Advanced filters',
		popoverLevelSelectAllMembersTitle: 'Select all',
		popoverLevelUnselectAllMembersTitle: 'Unselect all',
		popoverLevelDefaultStateLabel: 'Default member state',
		popoverLevelApplyStateRadio: 'Apply to list',
		popoverLevelFilterStateRadio: 'Filter list',
		popoverLevelMemberSearchPlaceholder: 'Search',
		popoverLevelEmptyCaption: '<empty>',
		//popoverLevelRemoveHiddenMembers: 'Remove hidden members',
		popoverLevelCaptionHeader: 'Caption',
		popoverLevelCodeHeader: 'Code',
		popoverLevelStatusHeader: 'Status',
		popoverMeasureDecimalsLabel: 'Decimal(s)',
		popoverMeasureFormatLabel: 'Format',
		popoverMeasureHighlightMinPlaceholder: 'Min',
		popoverMeasureHighlightMaxPlaceholder: 'Max',
		popoverMeasureHighlightBackgroundColorPlaceHolder: 'Background: color',
		popoverMeasureHighlightFontColorPlaceHolder: 'Font: color',
		popoverCalculatedMeasureCalculations: 'Calculations',
		popoverCalculatedMeasureMeasures: 'Measures',
		popoverCalculatedMeasureNoSelection: 'No selection',
		popoverCalculatedMeasureNSelected: ' selected',
		popoverCalculatedMeasureMeasure1: 'Measure 1',
		popoverCalculatedMeasureMeasure2: 'Measure 2',
		popoverCalculatedMeasureValue: 'Value',
		popoverCalculatedMeasureReplaceNullByZero: 'Replace null by zero',
		popoverCalculatedMeasureAddition: 'Addition',
		popoverCalculatedMeasureSubstraction: 'Substraction',
		popoverCalculatedMeasureMultiplication: 'Multiplication',
		popoverCalculatedMeasureDivision: 'Division',
		popoverCalculatedMeasurePercentage: 'Percentage',
		popoverCalculatedMeasureFormula: 'Formula',
		popoverCalculatedMeasureFormulaPlaceholder: 'Formula',
		popoverNodeExpand: 'Expand this item',
		popoverNodeCollapse: 'Collapse this item',
		popoverNodeExclude: 'Exclude this item',

		rowTotalsPositions: {
			FixBefore: 'Fixed on top',
			Before: 'On top',
			Hidden: 'Hidden',
			After: 'On bottom',
			FixAfter: 'Fixed on bottom',
		},
		colTotalsPositions: {
			FixBefore: 'Fixed on left',
			Before: 'On left',
			Hidden: 'Hidden',
			After: 'On right',
			FixAfter: 'Fixed on right',
		},
		filterOperators: {
			NotFiltered: '',
			IsNull: 'Is empty',
			IsNotNull: 'Is not empty',
			IsTrue: 'Is true',
			IsNotTrue: 'Is not true',
			IsFalse: 'Is false',
			IsNotFalse: 'Is not false',
			Equal: 'Equals to',
			Different: 'Is different from',
			Like: 'Contains',
			NotLike: 'Does not contain'
		},
		levelFilterStates: {
			Visible: 'Visible',
			Included: 'Included',
			Filtered: 'Filtered',
			Inheritable: 'Filtered (unmodifiable)',
			Inherited: 'Filtered (locked)'
		}
	},
	fr: {
		locale: 'fr',
		totals: 'TOTAUX',
		yes: 'Oui',
		no: 'Non',
		currency: '%VALUE% €', // symbole monétaire court, après et avec espace
		percent: '%VALUE% %', // sympbole % après et avec espace
		kilograms: '%VALUE%kg',
		grams: '%VALUE%g',
		kilometers: '%VALUE%km',
		meters: '%VALUE%m',
		seconds: '%VALUE%s',
		searchPlaceholder: 'Rechercher...',
		extraMeasuresLabel: 'Mesures',
		extraLevelsLabel: 'Niveaux',
		rowLevelsLabel: 'Lignes',
		colLevelsLabel: 'Colonnes',
		measureGroupsHeader: 'Groupes',
		measureNamesHeader: 'Mesures',
		paginationFirstPage: 'Première page',
		paginationPreviousPage: 'Page précédente',
		paginationNextPage: 'Page suivante',
		paginationLastPage: 'Dernière page',

		configurationCloseButton: 'Fermer',
		configurationValidateButton: 'Valider',
		configurationOptionsTab: 'Options d\'affichage',
		configurationLevelsTab: 'Dimensions',
		configurationMeasuresTab: 'Mesures',
		configurationRowLevelsSection: 'Lignes',
		configurationColLevelsSection: 'Colonnes',
		configurationExtraLevelsSection: 'Accès rapide',
		configurationFilteredLevelsSection: 'Filtres actifs',
		configurationVisibleMeasuresSection: 'Mesures affichées',
		configurationExtraMeasuresSection: 'Accès rapide',
		configurationCalculatedMeasuresSource: 'Mesures calculées',
		configurationAddButton: 'Ajouter',
		configurationRemoveButton: 'Retirer',
		configurationCustomizeButton: 'Personnaliser',
		configurationAddGroupButton: 'Ajouter un groupe de mesure',
		configurationAddGroupCaption: 'Nouveau groupe de mesure',
		configurationAddCalculationButton: 'Ajouter une mesure calculée',
		configurationAddCalculationCaption: 'Nouvelle mesure',
		configurationOptionCaption: 'Intitulé du rapport',
		configurationOptionMeasureOnCols: 'Afficher les mesures en colonnes',
		configurationOptionCalculate: 'Activer le calcul des mesures',
		configurationOptionCalculateOnlyVisibleMeasures: 'Ne calculer que les mesures affichées',
		configurationOptionHideEmpty: 'Cacher les lignes/colonnes vides',
		configurationOptionHideEmptyUsingVisibleMeasures: 'Cacher en fonction des mesures affichées',
		configurationOptionHideFixedMeasures: 'Cacher les mesures répétitives',
		configurationOptionRowTotalsPosition: 'Position des totaux par ligne',
		configurationOptionColTotalsPosition: 'Position des totaux par colonne',

		filtersValidateButton: 'Valider',
		filtersCancelButton: 'Annuler',
		filtersAddButton: 'Ajouter un critère',
		filtersRemoveButton: 'Supprimer le critère',
		filtersFieldHeader: 'Champ',
		filtersOperatorHeader: 'Opérateur / min',
		filtersValueHeader: 'Valeur / max',
		filtersMinPlaceholder: 'Min',
		filtersMaxPlaceholder: 'Max',

		popoverTabRename: 'Renommer',
		popoverTabAttributes: 'Attributs',
		popoverTabFilters: 'Filtres',
		popoverTabFormat: 'Format',
		popoverTabColors: 'Couleurs',
		popoverTabFormula: 'Calcul',
		popoverButtonSortAscending: 'Trier dans l\'ordre ascendant',
		popoverButtonSortDescending: 'Trier dans l\'ordre descendant',
		popoverButtonMeasureSort: 'Modifier le tri sur mesure',
		popoverButtonExpandAll: 'Tout déployer',
		popoverButtonCollapseAll: 'Tout diminuer',
		popoverButtonShow: 'Afficher',
		popoverButtonShowInRows: 'Afficher en lignes',
		popoverButtonShowInCols: 'Afficher en colonnes',
		popoverButtonHide: 'Cacher',
		popoverButtonDelete: 'Supprimer',
		popoverButtonCancel: 'Annuler',
		popoverButtonValidate: 'Valider',
		popoverCaptionPlaceholder: 'Intitulé',
		popoverLevelAdvancedFiltersLabel: 'Recherche avancée',
		popoverLevelSelectAllMembersTitle: 'Tout sélectionner',
		popoverLevelUnselectAllMembersTitle: 'Tout désélectionner',
		popoverLevelDefaultStateLabel: 'Statut par défaut pour tous les éléments',
		popoverLevelApplyStateRadio: 'Appliquer à la liste',
		popoverLevelFilterStateRadio: 'Filtrer la liste',
		popoverLevelMemberSearchPlaceholder: 'Recherche',
		popoverLevelEmptyCaption: '<vide>',
		//popoverLevelRemoveHiddenMembers: 'Retirer les éléments filtrés',
		popoverLevelCaptionHeader: 'Intitulé',
		popoverLevelCodeHeader: 'Code',
		popoverLevelStatusHeader: 'Statut',
		popoverMeasureDecimalsLabel: 'Décimale(s)',
		popoverMeasureFormatLabel: 'Suffixe',
		popoverMeasureHighlightMinPlaceholder: 'Min',
		popoverMeasureHighlightMaxPlaceholder: 'Max',
		popoverMeasureHighlightBackgroundColorPlaceHolder: 'Fond: couleur',
		popoverMeasureHighlightFontColorPlaceHolder: 'Texte: couleur',
		popoverCalculatedMeasureCalculations: 'Calculs',
		popoverCalculatedMeasureMeasures: 'Mesures',
		popoverCalculatedMeasureNoSelection: 'Aucune sélection',
		popoverCalculatedMeasureNSelected: '  sélectionné(e)s',
		popoverCalculatedMeasureMeasure1: 'Mesure 1',
		popoverCalculatedMeasureMeasure2: 'Mesure 2',
		popoverCalculatedMeasureValue: 'Valeur',
		popoverCalculatedMeasureReplaceNullByZero: 'Remplacer vide par zéro',
		popoverCalculatedMeasureAddition: 'Addition',
		popoverCalculatedMeasureSubstraction: 'Soustraction',
		popoverCalculatedMeasureMultiplication: 'Multiplication',
		popoverCalculatedMeasureDivision: 'Division',
		popoverCalculatedMeasurePercentage: 'Pourcentage',
		popoverCalculatedMeasureFormula: 'Formule',
		popoverCalculatedMeasureFormulaPlaceholder: 'Formule',
		popoverNodeExpand: 'Déployer cet élément',
		popoverNodeCollapse: 'Diminuer cet élément',
		popoverNodeExclude: 'Exclure cet élément',

		rowTotalsPositions: {
			FixBefore: 'Figés en haut',
			Before: 'En haut',
			Hidden: 'Non affichés',
			After: 'En bas',
			FixAfter: 'Figés en bas',
		},
		colTotalsPositions: {
			FixBefore: 'Figés à gauche',
			Before: 'A gauche',
			Hidden: 'Non affichés',
			After: 'A droite',
			FixAfter: 'Figés à droite',
		},
		filterOperators: {
			NotFiltered: '',
			IsNull: 'Est vide',
			IsNotNull: 'N\'est pas vide',
			IsTrue: 'Est vrai',
			IsNotTrue: 'N\'est pas vrai',
			IsFalse: 'Est faux',
			IsNotFalse: 'N\'est pas faux',
			Equal: 'Est égal à',
			Different: 'Est différent de',
			Like: 'Contient',
			NotLike: 'Ne contient pas'
		},
		levelFilterStates: {
			Visible: 'Visible',
			Included: 'Inclus',
			Filtered: 'Exclus (modifiable)',
			Inheritable: 'Exclus (non modifiable)',
			Inherited: 'Exclus (hérité)'
		}
	},
	de: {
		locale: 'de',
		totals: 'SUMMEN',
		yes: 'Ya',
		no: 'Nein',
		currency: 'EUR %VALUE%', // symbole monétaire moyen, avant et avec espace
		percent: '%VALUE%%', // symbole % après et sans espace
		kilograms: '%VALUE%kg',
		grams: '%VALUE%g',
		kilometers: '%VALUE%km',
		meters: '%VALUE%m',
		seconds: '%VALUE%s',
		searchPlaceholder: 'Suchen...',
		extraMeasuresLabel: 'Messungen',
		extraLevelsLabel: 'Ebenen',
		rowLevelsLabel: 'Zeilen',
		colLevelsLabel: 'Spalten',
		measureGroupsHeader: 'Gruppen',
		measureNamesHeader: 'Messungen',
		paginationFirstPage: 'Erste Seite',
		paginationPreviousPage: 'Vorherige Seite',
		paginationNextPage: 'Nächste Seite',
		paginationLastPage: 'Letzte Seite',

		configurationCloseButton: 'Schließen',
		configurationValidateButton: 'Bestätigen',
		configurationOptionsTab: 'Optionen',
		configurationLevelsTab: 'Ebenen',
		configurationMeasuresTab: 'Messungen',
		configurationRowLevelsSection: 'Zeilen',
		configurationColLevelsSection: 'Spalten',
		configurationExtraLevelsSection: 'Anderen Ebenen',
		configurationFilteredLevelsSection: 'Filter',
		configurationVisibleMeasuresSection: 'Sichtbare Messungen',
		configurationExtraMeasuresSection: 'Anderen Messungen',
		configurationCalculatedMeasuresSource: 'Berechnete Messungen',
		configurationAddButton: 'Hinzufügen',
		configurationRemoveButton: 'Löschen',
		configurationCustomizeButton: 'Anpassen',
		configurationAddGroupButton: 'Einer Messunggruppe hinzufügen',
		configurationAddGroupCaption: 'neue Messunggruppe',
		configurationAddCalculationButton: 'Einer Berechnungs hinzufügen',
		configurationAddCalculationCaption: 'neue Berechnung',
		configurationOptionCaption: 'Titel des Berichts',
		configurationOptionMeasureOnCols: 'Messungen in Spalten anzeigen',
		configurationOptionCalculate: 'Berechnung der Messungen aktivieren',
		configurationOptionCalculateOnlyVisibleMeasures: 'Berechnung für angezeigte Messungen',
		configurationOptionHideEmpty: 'Leere Zeilen/Spalten verbergen',
		configurationOptionHideEmptyUsingVisibleMeasures: 'Im Verhältnis zu den angezeigten Messungen verbergen',
		configurationOptionHideFixedMeasures: 'Wiederholte Messungen verbergen',
		configurationOptionRowTotalsPosition: 'Zeilensummen anzeigen',
		configurationOptionColTotalsPosition: 'Spaltensummen anzeigen',


		filtersValidateButton: 'Bestätigen',
		filtersCancelButton: 'Abbrechen',
		filtersAddButton: 'ein Kriterium fügen',
		filtersRemoveButton: 'das Kriterium löschen',
		filtersFieldHeader: 'Kriterium',
		filtersOperatorHeader: 'Operator',
		filtersValueHeader: 'Wert',
		filtersMinPlaceholder: 'Min',
		filtersMaxPlaceholder: 'Max',

		popoverTabRename: 'Namensgebung',
		popoverTabAttributes: 'Attribute',
		popoverTabFilters: 'Filter',
		popoverTabFormat: 'Format',
		popoverTabColors: 'Farben',
		popoverTabFormula: 'Berechnung',
		popoverButtonSortAscending: 'Aufsteigende Sortierung',
		popoverButtonSortDescending: 'Absteigende Sortierung',
		popoverButtonMeasureSort: 'Sortierung ändern',
		popoverButtonExpandAll: 'Alles darlegen',
		popoverButtonCollapseAll: 'Alles verkleinern',
		popoverButtonShow: 'Anzeigen',
		popoverButtonShowInRows: 'Zeilenweise anzeigen',
		popoverButtonShowInCols: 'In Spalten anzeigen',
		popoverButtonHide: 'Verbergen',
		popoverButtonDelete: 'Löschen',
		popoverButtonCancel: 'Abbrechen',
		popoverButtonValidate: 'Bestätigen',
		popoverCaptionPlaceholder: 'Bezeichnung',
		popoverLevelAdvancedFiltersLabel: 'Erweiterte Suche',
		popoverLevelSelectAllMembersTitle: 'Alles auswählen',
		popoverLevelUnselectAllMembersTitle: 'Alle Auswahlen aufheben',
		popoverLevelDefaultStateLabel: 'Standardstatus',
		popoverLevelApplyStateRadio: 'Mehrfachaktualisierung',
		popoverLevelFilterStateRadio: 'Filter',
		popoverLevelMemberSearchPlaceholder: 'Suchen',
		popoverLevelEmptyCaption: '<leer>',
		//popoverLevelRemoveHiddenMembers: 'Gefilterte Elemente herausnehmen',
		popoverLevelCaptionHeader: 'Bezeichnung',
		popoverLevelCodeHeader: 'Code',
		popoverLevelStatusHeader: 'Status',
		popoverMeasureDecimalsLabel: 'Dezimalstellen',
		popoverMeasureFormatLabel: 'Format',
		popoverMeasureHighlightMinPlaceholder: 'Mindestens',
		popoverMeasureHighlightMaxPlaceholder: 'Höchstens',
		popoverMeasureHighlightBackgroundColorPlaceHolder: 'Hintergrundfarbe',
		popoverMeasureHighlightFontColorPlaceHolder: 'Textfarbe',
		popoverCalculatedMeasureCalculations: 'Berechnungen',
		popoverCalculatedMeasureMeasures: 'Messungen',
		popoverCalculatedMeasureNoSelection: 'Keine auswahl',
		popoverCalculatedMeasureNSelected: '  ausgewählte Messungen',
		popoverCalculatedMeasureMeasure1: 'Messung 1',
		popoverCalculatedMeasureMeasure2: 'Messung 2',
		popoverCalculatedMeasureValue: 'Wert',
		popoverCalculatedMeasureReplaceNullByZero: 'Leerstellen durch 0 ersetzen',
		popoverCalculatedMeasureAddition: 'Addition',
		popoverCalculatedMeasureSubstraction: 'Subtraktion',
		popoverCalculatedMeasureMultiplication: 'Multiplikation',
		popoverCalculatedMeasureDivision: 'Division',
		popoverCalculatedMeasurePercentage: 'Prozentsatz',
		popoverCalculatedMeasureFormula: 'Formel',
		popoverCalculatedMeasureFormulaPlaceholder: 'Formel',
		popoverNodeExpand: 'Darlegen',
		popoverNodeCollapse: 'Verkleinern',
		popoverNodeExclude: 'Ausschließen',

		rowTotalsPositions: {
			FixBefore: 'in den ersten Zeilen und feste',
			Before: 'in den ersten Zeilen',
			Hidden: 'versteckte',
			After: 'in den letzten Zeilen',
			FixAfter: 'in den letzten Zeilen und feste',
		},
		colTotalsPositions: {
			FixBefore: 'nach links und feste',
			Before: 'nach links',
			Hidden: 'versteckte',
			After: 'nach rechts',
			FixAfter: 'nach rechts und feste',
		},
		filterOperators: {
			NotFiltered: '',
			IsNull: 'ist leer',
			IsNotNull: 'ist nicht leer',
			IsTrue: 'ist wahr',
			IsNotTrue: 'ist nicht wahr',
			IsFalse: 'ist falsch',
			IsNotFalse: 'ist nicht falsch',
			Equal: 'ist gleich',
			Different: 'ist nicht gleich',
			Like: 'enthält',
			NotLike: 'enthält nicht'
		},
		levelFilterStates: {
			Visible: 'Sichtbar',
			Included: 'Eingeschlossen',
			Filtered: 'Ausgeschlossen (veränderbar)',
			Inheritable: 'Ausgeschlossen (nicht veränderbar)',
			Inherited: 'Ausgeschlossen (blockiert)'
		}
	}
};

/** Liste des formats possibles pour les nombres (voir aussi BI.langs.*.currency et BI.langs.*.percent) */
BI.numberFormats = {
	Number: {
		name: 'Number',
		getFormatString: function(_lang) { return '%VALUE%'; },
		getFormatValue: function(value) { return value; },
		formatNotEmpty: function(value, lang, decimals) { return BaseAPI.numberFormatFromLocale(value, decimals, lang.locale); }
	},
	Currency: {
		name: 'Currency',
		getFormatString: function(lang) { return lang.currency; },
		getFormatValue: function(value) { return value; },
		formatNotEmpty: function(value, lang, decimals) { return lang.currency.replace('%VALUE%', BaseAPI.numberFormatFromLocale(value, decimals, lang.locale)); }
	},
	// Demande de Nathalie le 02/02/2017, confirmée le 16/03 : multiplier les mesures "pourcentage" par 100
	// Ainsi, la valeur "0.9876" d'une mesure pourcentage avec 2 décimales apparaitra comme "98.76 %"
	Percent: {
		name: 'Percent',
		getFormatString: function(lang) { return lang.percent; },
		getFormatValue: function(value) { return value * 100; },
		formatNotEmpty: function(value, lang, decimals) { return lang.percent.replace('%VALUE%', BaseAPI.numberFormatFromLocale(value * 100, decimals, lang.locale)); }
	},
	Kilograms: {
		name: 'Kilograms',
		getFormatString: function(lang) { return lang.kilograms; },
		getFormatValue: function(value) { return value; },
		formatNotEmpty: function(value, lang, decimals) { return lang.kilograms.replace('%VALUE%', BaseAPI.numberFormatFromLocale(value, decimals, lang.locale)); }
	},
	Grams: {
		name: 'Grams',
		getFormatString: function(lang) { return lang.grams; },
		getFormatValue: function(value) { return value; },
		formatNotEmpty: function(value, lang, decimals) { return lang.grams.replace('%VALUE%', BaseAPI.numberFormatFromLocale(value, decimals, lang.locale)); }
	},
	Kilometers: {
		name: 'Kilometers',
		getFormatString: function(lang) { return lang.kilometers; },
		getFormatValue: function(value) { return value; },
		formatNotEmpty: function(value, lang, decimals) { return lang.kilometers.replace('%VALUE%', BaseAPI.numberFormatFromLocale(value, decimals, lang.locale)); }
	},
	Meters: {
		name: 'Meters',
		getFormatString: function(lang) { return lang.meters; },
		getFormatValue: function(value) { return value; },
		formatNotEmpty: function(value, lang, decimals) { return lang.meters.replace('%VALUE%', BaseAPI.numberFormatFromLocale(value, decimals, lang.locale)); }
	},
	Seconds: {
		name: 'Seconds',
		getFormatString: function(lang) { return lang.seconds; },
		getFormatValue: function(value) { return value; },
		formatNotEmpty: function(value, lang, decimals) { return lang.seconds.replace('%VALUE%', BaseAPI.numberFormatFromLocale(value, decimals, lang.locale)); }
	},
};

BI.getNumberFormat = function(value) {
	if (typeof value === 'string')
		return BI.numberFormats[value];
	return value || null;
};

/** Liste des opérateurs supportés pour les filtres "texte" */
BI.stringFilterOperators = {
	NotFiltered: { active: false, pattern: false, name: 'NotFiltered' },
	Equal:       { active: true,  pattern: true,  name: 'Equal' },
	Different:   { active: true,  pattern: true,  name: 'Different' },
	IsNull:      { active: true,  pattern: false, name: 'IsNull' },
	IsNotNull:   { active: true,  pattern: false, name: 'IsNotNull' },
	Like:        { active: true,  pattern: true,  name: 'Like' },
	NotLike:     { active: true,  pattern: true,  name: 'NotLike' }
};

/** Liste des opérateurs supportés pour les filtres "oui/non" */
BI.booleanFilterOperators = {
	NotFiltered: { active: false, name: 'NotFiltered' },
	IsNull:      { active: true,  name: 'IsNull' },
	IsTrue:      { active: true,  name: 'IsTrue' },
	IsFalse:     { active: true,  name: 'IsFalse' },
	IsNotNull:   { active: true,  name: 'IsNotNull' },
	IsNotTrue:   { active: true,  name: 'IsNotTrue' },
	IsNotFalse:  { active: true,  name: 'IsNotFalse' }
};

/** Liste des statuts possibles pour les membres d'un niveau (voir ReportLevelFilter.java pour plus d'infos) */
BI.levelFilterStates = {
	Visible:     { visible: true,  name: 'Visible' },
	Included:    { visible: false, name: 'Included' },
	Filtered:    { visible: false, name: 'Filtered' },
	Inheritable: { visible: false, name: 'Inheritable' },
	Inherited:   { visible: false, name: 'Inherited' }
};

function buildDateTimeType(userFormat, internalFormat, pickDate, pickTime) {
	function buildFilterInput(cell, placeholder, value) {
		// Formattage de value (un "long") en texte pour l'utilisateur
		var text = value ? moment(value).format(userFormat) : '';
		// Ajout de l'input avec valeur dans le parent
		var input = $('<input class="form-control" type="text" />').attr('placeholder', placeholder).val(text).appendTo(cell);
		// Si le composant "Bootstrap Datetimepicker" est dispo, on l'utilise car plus joli qu'un <input type="text" />
		if ($.fn.datetimepicker) {
			input.wrap('<div style="position: relative;" />').datetimepicker({
				locale: BI.options.lang,
				format: userFormat,
				useCurrent: false,
				calendarWeeks: true
			});
		}
	}
	function applyFilterInput(cell) {
		// Récupération de la valeur
		var text = cell.find('input').val();
		if (text) {
			try {
				// Parser la date
				var value = moment(text, userFormat);
				// Ajuster en "date" ou "heure" si l'un des deux doit être tronqué
				if (!pickDate)
					value = value.year(1970).month(0).date(1);
				if (!pickTime)
					value = value.startOf('day');
				// Renvoi de la valeur sous la forme d'un long
				return value.toDate().getTime();
			} catch (ex) {}
		}
		return null;
	}
	return {
		align: 'right',
		formatCellWithHTML: false,
		formatCellNotEmpty: function(value, _lang, _decimals, _numberFormat) {
			 return moment(value).format(userFormat);
		},
		formatHeaderNotEmpty: function(value, _lang, _decimals, _numberFormat) {
			return moment(value).format(userFormat);
		},
		formatInternalNotEmpty: function(value) {
			return moment(value).format(internalFormat);
		},
		compare: function(value1, value2) {
			return value1 - value2;
		},
		isFilterActive: function(filter) {
			return filter.min || filter.max || false;
		},
		buildFilterEditor: function(filter, lang, cell1, cell2) {
			buildFilterInput(cell1, lang.filtersMinPlaceholder, filter.min);
			buildFilterInput(cell2, lang.filtersMaxPlaceholder, filter.max);
		},
		applyFilterEditor: function(filter, _lang, cell1, cell2) {
			filter.min = applyFilterInput(cell1);
			filter.max = applyFilterInput(cell2);
		}
	};
}

/** Liste des types de données supportées par le rapport */
BI.types = {
	text: {
		align: 'left',
		formatCellWithHTML: false,
		formatCellNotEmpty: function(value, _lang, _decimals, _numberFormat) {
			 return value;
		},
		formatHeaderNotEmpty: function(value, _lang, _decimals, _numberFormat) {
			return value;
		},
		formatInternalNotEmpty: function(value) {
			return value;
		},
		compare: function(value1, value2) {
			return value1.localeCompare(value2);
		},
		isFilterActive: function(filter) {
			var op = BI.stringFilterOperators[filter.operator || 'NotFiltered'];
			return op.active && (filter.pattern || !op.pattern);
		},
		buildFilterEditor: function(filter, lang, cell1, cell2) {
			var options = $.map(BI.stringFilterOperators, function(_operator, name) {
				return $('<option />').attr('value', name).text(lang.filterOperators[name]).prop('selected', name === filter.operator)[0];
			});
			$('<select class="form-control" style="padding-right: 16px;" />').append(options).appendTo(cell1).change();
			$('<input class="form-control" type="text" />').val(filter.pattern || '').appendTo(cell2);
		},
		applyFilterEditor: function(filter, _lang, cell1, cell2) {
			filter.operator = cell1.children('select').val();
			filter.pattern = cell2.children('input').val();
		}
	},
	date: buildDateTimeType(BI.options.dateFormat, 'YYYY/MM/DD', true, false),
	time: buildDateTimeType(BI.options.timeFormat, 'HH:mm:ss', false, true),
	datetime: buildDateTimeType(BI.options.datetimeFormat, 'YYYY/MM/DD  HH:mm:ss', true, true),
	boolean: {
		align: 'center',
		formatCellWithHTML: true,
		formatCellNotEmpty: function(value, _lang, _decimals, _numberFormat) {
			 return !!value ? BI.options.templateChecked : BI.options.templateUnchecked ? BI.options.templateUnchecked : '';
		},
		formatHeaderNotEmpty: function(value, lang, _decimals, _numberFormat) {
			return !!value ? lang['yes'] : lang['no'];
		},
		formatInternalNotEmpty: function(value) {
			return !!value ? '1' : '0';
		},
		compare: function(value1, value2) {
			if (value1 === value2)
				return 0; //true/true, false/false, undefined/undefined
			if (value1 === true || value2 === undefined)
				return 1; //true/false, true/undefined, false/undefined
			return -1; // false/true, undefined/true, undefined/false
		},
		isFilterActive: function(filter) {
			return BI.booleanFilterOperators[filter.operator || 'NotFiltered'].active;
		},
		buildFilterEditor: function(filter, lang, cell1, _cell2) {
			var options = $.map(BI.booleanFilterOperators, function(_operator, name) {
				return $('<option />').attr('value', name).text(lang.filterOperators[name]).prop('selected', name === filter.operator)[0];
			});
			$('<select class="form-control" style="padding-right: 16px;" />').append(options).appendTo(cell1);
		},
		applyFilterEditor: function(filter, _lang, cell1, _cell2) {
			filter.operator = cell1.children('select').val();
		}
	},
	integer: {
		align: 'right',
		formatCellWithHTML: false,
		formatCellNotEmpty: function(value, _lang, _decimals, _numberFormat) {
			 return value.toFixed(0);
		},
		formatHeaderNotEmpty: function(value, _lang, _decimals, _numberFormat) {
			 return value.toFixed(0);
		},
		formatInternalNotEmpty: function(value) {
			return value.toFixed(0);
		},
		compare: function(value1, value2) {
			return BI.types.number.compare(value1, value2);
		},
		isFilterActive: function(filter) {
			return BI.types.number.isFilterActive(filter);
		},
		buildFilterEditor: function(filter, lang, cell1, cell2) {
			BI.types.number.buildFilterEditor(filter, lang, cell1, cell2);
		},
		applyFilterEditor: function(filter, lang, cell1, cell2) {
			BI.types.number.applyFilterEditor(filter, lang, cell1, cell2);
		}
	},
	number: {
		align: 'right',
		formatCellWithHTML: false,
		formatCellNotEmpty: function(value, lang, decimals, numberFormat) {
			return numberFormat.formatNotEmpty(value, lang, decimals);
		},
		formatHeaderNotEmpty: function(value, lang, decimals, numberFormat) {
			return numberFormat.formatNotEmpty(value, lang, decimals);
		},
		formatInternalNotEmpty: function(value) {
			return value.toString();
		},
		compare: function(value1, value2) {
			return (value1 === value2) ? 0 : (value1 > value2 ? 1 : -1);
		},
		isFilterActive: function(filter) {
			return (typeof filter.min === 'number') || (typeof filter.max === 'number');
		},
		buildFilterEditor: function(filter, lang, cell1, cell2) {
			var i1 = $('<input type="text" class="form-control" placeholder="' + lang.filtersMinPlaceholder +'" />').appendTo(cell1);
			var i2 = $('<input type="text" class="form-control" placeholder="' + lang.filtersMaxPlaceholder +'" />').appendTo(cell2);
			if (typeof filter.min === 'number')
				i1.val(filter.min.toString());
			if (typeof filter.max === 'number')
				i2.val(filter.max.toString());
		},
		applyFilterEditor: function(filter, _lang, cell1, cell2) {
			var v1 = cell1.children('input').val() || '';
			var v2 = cell2.children('input').val() || '';
			try {
				filter.min = v1 ? parseFloat(v1) : null;
				filter.max = v2 ? parseFloat(v2) : null;
			} catch (ex) { }
		}
	},
};

BI.getType = function(value) {
	if (typeof value === 'string')
		return BI.types[value];
	return value || null;
};

/**
 * Cette classe représente un filtre sur champ, avant aggrégation. Il est défini côté client mais utilisé côté serveur
 *
 * @constructor
 * @this {BIReportFilter}
 * @param {string} name - le nom unique du filtre
 * @param {string} caption - l'intitulé du filtre, unique si possible pour que l'utilisateur s'y retrouve le mieux possible
 * @param {string} type - le nom du type des valeurs non aggrégées (= dans la table) pour ce filtre, parmi BI.types
 * @param {number} min - la borne min du filtre ou null, représentant la valeur (si 'number') ou le timeMS (si 'date'/'time'/'datetime')
 * @param {number} max - la borne max du filtre ou null, représentant la valeur (si 'number') ou le timeMS (si 'date'/'time'/'datetime')
 * @param {string} pattern - le texte à recherché, valable uniquement pour les filtres 'text'
 * @param {string} operator - le type de comparaison, parmi stringFilterOperators (si 'text') ou parmi booleanFilterOperators (si 'boolean')
*/
function BIReportFilter(name, caption, type, min, max, pattern, operator) {
	this.name = name;
	this.caption = caption;
	this.type = BI.getType(type);
	this.min = min;
	this.max = max;
	this.pattern = pattern;
	this.operator = operator;
}

/**
 * Cette classe représente un attribut d'un niveau, et NE DOIT PAS être partagé avec d'autres niveaux.
 *
 * @constructor
 * @this {BIReportAttribute}
 * @param {string} name - le nom unique de l'attribut (customers.code, products.ean, ...)
 * @param {string} defaultCaption - l'intitulé d'origine de l'attribut venant du cube
 * @param {string} caption - l'intitulé de l'attribut, unique au sein d'un niveau (Code, EAN, ...)
 * @param {number} width - la largeur en pixel choisie par l'utilisateur pour la colonne affichant cet attribut
 * @param {string} type - le nom du type des valeurs de cet attribut, parmi BI.types
 * @param {number} decimals - le nombre de décimales souhaité, quand l'attribut est un 'number'
 * @param {string} format - le nom du format d'affichage, parmi BI.numberFormats, autrement dit 'Number'/'Currency'/'Percent'
 * @param {string} imageUrlFormat - le format (contenant %VALUE%) permettant de générer les URLs des images si l'attribut représente une image
 */
function BIReportAttribute(name, defaultCaption, caption, width, type, decimals, format, imageUrlFormat) {
	this.name = name;
	this.defaultCaption = defaultCaption || '';
	this.caption = caption || this.defaultCaption;
	this.width = width;
	this.type = BI.getType(type);
	this.decimals = decimals;
	this.format = BI.getNumberFormat(format);
	this.imageUrlFormat = imageUrlFormat;
}

/**
 * Cette classe représente un niveau, avec sa définition, ses attributs, ses niveaux parents, et sa personnalisation.
 *
 * @constructor
 * @this {BIReportLevel}
 * @param {string} name - le nom unique du niveau (customers, products, ...)
 * @param {string} defaultCaption - l'intitulé d'origine du niveau venant du cube
 * @param {string} caption - l'intitulé du niveau, unique si possible pour que l'utilisateur s'y retrouve le mieux possible (Clients, Articles, ...)
 * @param {number} width - la largeur en pixel choisie par l'utilisateur pour la colonne affichant l'intitulé des membres de ce niveau
 * @param {string} keyType - le nom du type des clefs des membres du niveaux, parmi BI.types
 * @param {string} captionType - le nom du type des intitulés des membres du niveaux, parmi BI.types
 * @param {number} decimals - le nombre de décimales souhaité, quand l'intitulé des niveaux est un 'number'
 * @param {string} format - le nom du format d'affichage, parmi BI.numberFormats, autrement dit 'Number'/'Currency'/'Percent'
 * @param {boolean} sortAscending - indique si le niveau est actuellement trié en ascendant ou en descendant
 * @param {boolean} allExpanded - indique si le niveau est actuellement entièrement déployé
 * @param {boolean} allowNullKeys - indique si le niveau peut éventuellement être vide (ajoute une entrée dans le liste pour choisir les filtres)
 * @param {Array} attributes - la liste des BIReportAttribute de ce niveau
 * @param {Array} visibleAttributeIndex - la liste des index dans 'attributes' des attributs du niveau actuellement affichés
 * @param {string} defaultState - le statut par défaut des membres, parmi BI.levelFilterStates
 * @param {boolean hasCustomStates - indique si la map "states" côté serveur contient quelque chose. Le contenu nous importe peu mais on doit savoir s'il y a quelque chose
 */
function BIReportLevel(name, defaultCaption, caption, width, keyType, captionType, decimals, format, sortAscending, allExpanded, allowNullKeys) {
	this.name = name;
	this.defaultCaption = defaultCaption || '';
	this.caption = caption || this.defaultCaption;
	this.width = width;
	this.keyType = BI.getType(keyType);
	this.captionType = BI.getType(captionType);
	this.decimals = decimals;
	this.format = BI.getNumberFormat(format);
	this.sortAscending = (typeof sortAscending === 'boolean') ? sortAscending : true;
	this.allExpanded = (typeof allExpanded === 'boolean') ? allExpanded : false;
	this.allowNullKeys = (typeof allowNullKeys === 'boolean') ? allowNullKeys : true;
	this.attributes = [];
	this.visibleAttributeIndex = [];
	this.defaultState = 'Visible';
	this.hasCustomStates = false;
}

/**
 * Cette classe représente un groupe de mesures dans le rapport. Par défaut, les mesures sont affichées
 * à plat mais l'utilisateur peut créer un ou plusieurs groupes avec libellé s'il le souhaite.
 *
 * @constructor
 * @this {BIReportMeasureGroup}
 * @param {string} caption - l'intitulé du groupe, choisi par l'utilisateur
 * @param {number} firstMeasureIndex - l'index, parmi BIReportView.visibleMeasures, de la première mesure de ce groupe
 * @param {number} lastMeasureIndex - l'index, parmi BIReportView.visibleMeasures, de la dernière mesure de ce groupe
 */
function BIReportMeasureGroup(caption, firstMeasureIndex, lastMeasureIndex) {
	this.caption = caption;
	this.firstMeasureIndex = firstMeasureIndex;
	this.lastMeasureIndex = lastMeasureIndex;
}

/**
 * Cette classe représente une source à l'origine des mesures (non calculées) : elles organise les mesures lors d'une recherche
 * et elles indiquent les niveaux associés pour détecter les mesures répétitives.
 *
 * @constructor
 * @this {BIReportMeasureSource}
 * @param {String} name - le nom unique de la source, référencé par BIReportMeasure.sourceName
 * @param {String} caption - l'intitulé de la source, normallement unique car généré par l'application
 * @prams {Array} levelNames - le nom des niveaux que la source connait, pour détecter les mesures répétitives
 */
function BIReportMeasureSource(name, caption, levelNames) {
	this.name = name;
	this.caption = caption;
	this.levelNames = levelNames || [];
}

/**
 * Cette classe représente une mesure dont certaines sont affichées et d'autres disponibles pour ajout ultérieur.
 *
 * @constructor
 * @this {BIReportMeasure}
 * @param {string} name - le nom unique de la mesure (source1.mesure1, source2.measure1, source3.measure10, ...)
 * @param {string} defaultCaption - l'intitulé d'origine de la mesure, si elle vient du cube
 * @param {string} caption - l'intitulé de la mesure, unique si possible pour que l'utilisateur s'y retrouve le mieux possible (Facing, PVC, CATP, ...)
 * @param {string} description - une description de cette mesure (c'est prévu depuis toujours mais étrangement jamais mis en place)
 * @param {number} width - la largeur en pixel choisie par l'utilisateur pour la colonne affichant cette mesure, si elles sont affichées en colonne
 * @param {string} type - le nom du type des valeurs aggrégées pour cette mesure, parmi BI.types
 * @param {number} decimals - le nombre de décimales souhaité, quand la mesure affiche des nombres
 * @param {string} format -  le nom du format d'affichage, parmi BI.numberFormats, autrement dit 'Number'/'Currency'/'Percent'
 * @param {string} formula - la formule de la mesure (uniquement pour saisie côté client donc une chaine suffit)
 * @param {string} sourceName - le nom de la source BIReportMeasureSource de laquelle vient la mesure (ou null pour les mesures calculée)
 * @param {Array} highlights - les couleurs par sueils pour la mesure, si elle affiche des nombres
*/
function BIReportMeasure(name, defaultCaption, caption, description, width, type, decimals, format, formula, sourceName, highlights) {
	this.name = name;
	this.defaultCaption = defaultCaption || '';
	this.caption = caption || this.defaultCaption;
	this.description = description;
	this.width = width;
	this.type = BI.getType(type);
	this.decimals = decimals;
	this.format = BI.getNumberFormat(format || 'Number');
	this.formula = formula;
	this.sourceName = sourceName;
	this.highlights = highlights || [];
}

/**
 * Cette classe représente une couleur spéciale pour un intervalle de valeur d'une mesure numérique.
 *
 * @constructor
 * @this {BIReportMeasureHighlight}
 * @param {number} min - la valeur min à partir de laquelle il faut appliquer la couleur, ou null s'il n'y a pas de min
 * @param {number} max - la valeur max jusqu'à laquelle il faut appliquer la couleur, ou null s'il n'y a pas de max
 * @params {string} color - la couleur, au format valide CSS, pour les cellules dans l'intervalle donné
 * @params {string} fontColor - la couleur du texte, au format valide CSS, pour les cellules dans l'intervalle donné
 */
function BIReportMeasureHighlight(min, max, color, fontColor) {
	this.min = min;
	this.max = max;
	this.color = color;
	this.fontColor = fontColor;
}

/**
 * Cette classe représente une ligne ou une colonne dans un rapport.
 *
 * @constructor
 * @this {BIReportNode}
 * @param {number} depth - la profondeur du noeud dans l'axe, en commençant à 0. Certaines méthodes prenant en paramètre depth comprennent -1 comme "totaux"
 * @param {Object} member - le membre (par exemple un client) correspondant à ce noeud, ressemblant à { key, caption, attribute1, attribute2, ...}
 * @param {boolean} expandable - indique si le noeud peut être déployé (c'est à dire s'il y a un niveau en dessous et s'il y a effectivement des sous-noeuds)
 * @param {boolean} expanded - indique si le noeud est actuellement déployé
 * @param {Object} totalCell - les totaux de la ligne si le noeud est une ligne ou les totaux de la colonne si le noeud est une colonne
 */
function BIReportNode(depth, member, expandable, expanded, totalCell) {
	this.depth = depth;
	this.member = member;
	this.expandable = expandable;
	this.expanded = expanded;
	this.totalCell = totalCell;
}

/**
 * Cette classe représente un axe du rapport, contenant soit les lignes, soit les colonnes et la configuration de cet axe.
 *
 * @constructor
 * @this {BIReportAxe}
 * @param {Array} levels - la liste des BIReportLevel affichés sur cet axe
 * @param {Array} nodes - par défaut vide, contient la liste des lignes ou colonnes actuellement visibles sur cet axe
 * @param {number} offset - l'index dans "nodes" du premier noeud affiché sur la page en cours
 * @param {number} size - le nombre de noeuds dans "nodes" affichés sur la page en cours
 * @param {boolean} hideEmpty - indique si on doit cacher les lignes (ou colonnes) vides de cet axe
 * @param {boolean} hideEmptyUsingVisibleMeasures - indique si la notion de vide ne concerne que les mesures affichées
 * @param {string} totalsPosition - le nom de la position des totaux, parmi "FixBefore", "Before", "Hidden", "After" et "FixAfter"
 */
function BIReportAxe(totalsPosition) {
	this.levels = [];
	this.nodes = [];
	this.offset = 0;
	this.size = 0;
	this.hideEmpty = true;
	this.hideEmptyUsingVisibleMeasures = false;
	this.totalsPosition = totalsPosition;
}

/**
 * Cette classe représente le rapport, équivalent de la classe Report en Java
 *
 * @constructor
 * @this {BIReportView}
 * @param {Function} onexecute - la fonction a appeler quand les actions nécessitent des données sur le serveur
 * @param {string} caption - le titre du rapport
 * @param {BIReportLevel[]} levels - liste de tous les niveaux (qu'ils soient en ligne, en colonne, en accès rapide ou cachés)
 * @param {BIReportLevel[]} extraLevels - liste des niveaux en accès rapides dans la zone au dessus de la grille
 * @param {BIReportAxe} rowAxe - représente les niveaux en ligne, les lignes générées et les options d'affichage des lignes
 * @param {BIReportAxe} colAxe - représente les niveaux en colonne, les colonnes générées et les options d'affichage des colonnes
 * @param {BIReportMeasure[]} measures - liste de toutes les mesures (qu'elles soient visibles, en accès rapide ou ou cachées)
 * @param {BIReportMeasure[]} extraMeasures - liste des mesures en accès rapide dans la zone au dessus de la grille
 * @param {BIReportMeasure[]} visibleMeasures - liste des mesures actuellement affichées, dans l'ordre, y compris celles des groupes
 * @param {BIReportMeasureGroup[]} measureGroups - liste des groupes de mesures, chaque groupe ayant un texte et pouvant contenir une ou plusieurs mesures
 * @param {BIReportFilter[]} filters - liste des filtres possibles dans ce rapport
 * @param {boolean} calculate - indique si on calcule automatiquement les valeurs dans la grille
 * @param {boolean} calculateOnlyVisibleMeasures - indique si seules les mesures affichées sont calculées (plus rapide quand le rapport est finalisé)
 * @param {boolean} measureOnCols - indique si les mesures sont côte à côte, en colonne (true) ou l'une en dessous de l'autre, en ligne (false)
 * @param {boolean} hideFixedMeasures - indique si les mesures n'ayant rien à voir avec un niveau doivent être masquées pour les lignes/colonnes de ce niveau
 * @param {number} headerSize - indique la hauteur réservée pour la dernière ligne d'en-tête (46px ?)
 * @param {number} measureNamesWidth - indique la largeur de la colonne affichant le nom des mesures à gauche quand elles sont affichées en ligne
 * @param {number} measureValuesWidth - indique la largeur de chaque colonne, commune à toutes les mesures quand elles sont affichées en ligne
 * @param {number} measureGroupsWidth - indique la largeur de la colonne affichant le nom des groupes à gauche quand elles sont affichées en ligne
 * @param {string} sortMeasureName - le nom de la mesure selon laquelle l'utilisateur a trié, ou null s'il n'y a pas de tri sur mesure (ex: Facing)
 * @param {boolean} sortMeasureAscending - indique si le tri selon une mesure se fait de manière ascendante (true) ou descendante (false)
 * @param {Array} sortMeasurePath - indique le chemin de la ligne/colonne dont les valeurs servent au tri selon une mesure (ex: enseigne=1, trimestre=201604)
 * @param {Object} grandTotalCell - les grand-totaux, habituellement en bas à droite
 * @param {Array} cells - les valeurs aux intersections d'une ligne et d'une colonne, sous la forme d'un tableau de taille nbligne*nbcolonne
 */
function BIReportView(onexecute) {
	this.onexecute = onexecute;
	this.caption = '';
	this.levels = [];
	this.extraLevels = [];
	this.rowAxe = new BIReportAxe('FixAfter');
	this.colAxe = new BIReportAxe('After');
	this.measures = [];
	this.extraMeasures = [];
	this.visibleMeasures = [];
	this.measureGroups = [];
	this.measureSources = [];
	this.filters = [];
	this.calculate = true;
	this.calculateOnlyVisibleMeasures = false;
	this.measureOnCols = true;
	this.hideFixedMeasures = false;
	this.headerSize = 46;
	this.measureNamesWidth = 120;
	this.measureValuesWidth = 60;
	this.measureGroupsWidth = 60;
	this.sortMeasureName = null;
	this.sortMeasureAscending = true;
	this.sortMeasurePath = [];
	this.grandTotalCell = {};
	this.cells = [];
	this.internalUpdateCache();
}

/**
 * Cette fonction met à jour des données précalculées afin d'accélérer le rendu de la grille.
 * Pour le moment, le cache contient :
 * - la liste des mesures visibles pour chaque niveau de profondeur
 * - la liste des groupes visibles pour chaque niveau de profondeur
 * - la profondeur maximale visible en ligne
 * - la profondeur maximale visible en colonne
 */
BIReportView.prototype.internalUpdateCache = function() {
	var self = this;
	// On calcule la profondeur maximale visible en ligne
	self.calculatedRowAxeDepth = self.rowAxe.nodes.reduce(function(d, node) {
		return Math.max(d, node.depth);
	}, 0);
	// On calcule la profondeur maximale visible en colonne
	self.calculatedColAxeDepth = self.colAxe.nodes.reduce(function(d, node) {
		return Math.max(d, node.depth);
	}, 0);
	// On calcule le cache pour l'axe où sont affichées les mesures
	var axe = self.measureOnCols ? self.colAxe : self.rowAxe;
	// Pour cela, on a besoin de savoir la source associée à chaque mesure visibles
	var visibleMeasureSources = self.visibleMeasures.map(function(measure) {
		if (measure.sourceName)
			return self.measureSources.find(function(source) {
				return source.name === measure.sourceName;
			});
		else //if (measure.formula)
			return null;
	});
	// Pour chaque niveau en profondeur, on n'affichera que les mesures non répétitives
	self.calculatedMeasureGroupsByDepth = [];
	self.calculatedVisibleMeasuresByDepth = [];
	// Chaque groupe de mesure sera encapsulé dans un objet pour ajuster les index de mesures
	function wrapMeasureGroup(g) {
		var group = new BIReportMeasureGroup(g.caption, g.firstMeasureIndex, g.lastMeasureIndex);
		group.originalGroup = g;
		return group;
	}
	// Quand une mesure est zappée car répétitive, on ajuste les indes dans les groupes
	function skipMeasureIndex(groups, index) {
		var i = 0, g;
		for (; i < groups.length; i++) {
			g = groups[i];
			if (g.firstMeasureIndex > index)
				g.firstMeasureIndex--;
			if (g.lastMeasureIndex >= index)
				g.lastMeasureIndex--;
		}
	}
	for (var i = 0; i < axe.levels.length; i++) {
		// Si l'option est désactivée, on affiche toutes les mesures (et donc tous les groupes)
		if (! self.hideFixedMeasures) {
			self.calculatedMeasureGroupsByDepth.push(self.measureGroups);
			self.calculatedVisibleMeasuresByDepth.push(self.visibleMeasures);
			continue;
		}
		// Sinon, la liste dépend du niveau
		var levelName = axe.levels[i].name;
		// Au départ, on prend les groupes tels quels et on ajustera les index début/fin au fur et à mesure
		var measureGroupsForDepth = self.measureGroups.map(wrapMeasureGroup);
		// Au départ, la liste de mesure et vide et on complètera au fur et à mesure
		var visibleMeasuresForDepth = [];
		for (var j = 0; j < self.visibleMeasures.length; j++) {
			var measure = self.visibleMeasures[j];
			// Une mesure est affichée si elle est calculée ou si elle appartient à une source connaissant le niveau
			if (measure.formula || visibleMeasureSources[j].levelNames.indexOf(levelName) >= 0) {
				visibleMeasuresForDepth.push(self.visibleMeasures[j]);
			} else {
				// Sinon, la mesure est considérée comme répétitive, on la cache et on ajuste les index de son groupe
				skipMeasureIndex(measureGroupsForDepth, visibleMeasuresForDepth.length);
			}
		}
		// Une fois toutes les mesures parcourues, on nettoie les groupes devenus vides
		measureGroupsForDepth = measureGroupsForDepth.filter(function(g) {
			return g.lastMeasureIndex >= g.firstMeasureIndex;
		});
		// OK, on a fini pour ce niveau, on passe au niveau suivant dans l'arborescence
		self.calculatedMeasureGroupsByDepth.push(measureGroupsForDepth);
		self.calculatedVisibleMeasuresByDepth.push(visibleMeasuresForDepth);
	}
};

/**
 * Cette méthode permet de personnaliser le titre des popins (actuellement celui des filtres et de la configuration avancée).
 * Par défaut, il s'agit du nom du rapport (this.caption) mais SOLVNet y ajoute l'id (suite à la demande 3257 dans Inside).
 */
BIReportView.prototype.getPopinTitle = function() {
	return this.caption;
};

/**
 * Cette méthode permet de demander un menu d'actions pour certains noeuds du rapport.
 * Pour ces noeuds, on active la classe CSS "bbm-report-node-with-actions".
 * Quand on clique dessus, le rapport appellera "getNodeActions" pour alimenter le menu.
 * 
 * @param {BIReportNode} _node le noeud (ligne ou colonne) dont on veut savoir si des actions sont disponibles
 * @param {BIReportLevel} _level le niveau associé au noeud, pour savoir de quel type de données on parle
 * @return true si une action on souhaite activer le menu d'actions pour ce noeud, false sinon
 */
BIReportView.prototype.hasNodeActions = function(_node, _level) {
	// Par défaut, jquery-bi.js ne propose pas d'actions. Ce comportement peut être surchargé, comme dans SOLVNet, pour gérer un menu d'actions
	return false;
};

/**
 * Cette méthode permet de définir le contenu du menu quand on clique sur un noeud ayant des actions.
 * Cette méthode n'est appelée que si "hasNodeActions" avait renvoyée "true" lors de création du noeud. 
 * La méthode renvoie un tableau d'actions pouvant être :
 * - une entrée prédéfinie
 *     { name: 'expand' } : ajoutera une action "Déployer cet élément", si possible
 *     { name: 'collapse' } : ajoutera une action "Diminuer cet élément", si possible
 *     { name: 'exclude' } : ajoutera une action "Exclure cet élément"
 *     { name: 'separator' } : ajoutera un séparateur de menu
 * - un bouton d'action personnalisée
 *     { name: 'action', caption: 'Mon action', icon: 'edit', onclick: function(node, level, view, nodeIndex, isRow) { ... } }
 * - un lien vers une URL personnalisée
 *     { name: 'action', caption: 'Mon action', icon: 'edit', onurl: function(node, level, view, nodeIndex, isRow) { return '...'; } }
 *
 * @param {BIReportNode} _node le noeud (ligne ou colonne) dont on veut obtenir le tableau d'actions disponibles
 * @param {BIReportLevel} _level le niveau associé au noeud, pour savoir de quel type de données on parle
 * @return {Array} le tableau des actions pour ce noeud
 */
BIReportView.prototype.getNodeActions = function(_node, _level) {
	// Par défaut, jquery-bi.js ne propose pas d'actions. Ce comportement peut être surchargé, comme dans SOLVNet, pour gérer un menu d'actions
	return [];
};

/** Méthode interne pour formater le libellé d'un noeud du tableau (nom du client ou date d'un jour par exemple) */
BIReportView.prototype.formatLevelCell = function(node, lang, level) {
	var value = level.captionType ? node.member.caption : node.member.key;
	if (! BI.isValue(value))
		return '';
	var type = level.captionType || level.keyType;
	return type.formatHeaderNotEmpty(value, lang, level.decimals, level.format);
};

/** Méthode interne pour formater le texte d'un attribut de niveau (code ou CATP de client par exemple) */
BIReportView.prototype.formatAttributeCell = function(node, lang, attribute, cell) {
	var value = node.member[attribute.name];
	if (! BI.isValue(value))
		cell.empty();
	else if (attribute.imageUrlFormat !== null)
		cell.css('textAlign', 'center').append(BI.buildElement('img').attr('src', attribute.imageUrlFormat.replace('%VALUE%', value)));
	else
		cell.text(attribute.type.formatHeaderNotEmpty(value, lang, attribute.decimals, attribute.format));
};

/** Cette méthode recherche une éventuelle personnalisation des couleurs "BIReportMeasureHighlight" pour la mesure "measure" quand la valeur est "value"
 * 
 * @param {BIReportMeasure} measure la mesure dont on vérifie les couleurs. NB: seules les nombres sont actuellement supportés
 * @param {Number} value la valeur dont on souhaite savoir si elle doit utiliser une couleur particulière
 * @return {BIReportMeasureHighlight} renvoie la personnalisation de couleurs correspondant à "value", si elle existe, ou '' sinon  
 */
BIReportView.getMeasureHighlight = function(measure, value) {
	if ((measure.type === BI.types.integer || measure.type === BI.types.number) && (typeof value === 'number') && (measure.highlights.length > 0)) {
		for (var i = 0; i < measure.highlights.length; i++) {
			var min = measure.highlights[i].min;
			var minActive = (typeof min === 'number');
			var max = measure.highlights[i].max;
			var maxActive = (typeof max === 'number');
			if (!minActive && !maxActive)
				continue;
			if (minActive && value < min)
				continue;
			if (maxActive && value > max)
				continue;
			return measure.highlights[i];
		}
	}
	return '';
};

/** Méthode interne pour rechercher dans la position dans "axe.nodes" d'un noeud dont on connait le chemin (un tableau de N clefs) */
BIReportView.prototype.findNodeIndex = function(axe, path/*: key[]*/) {
	// S'il n'y a pas de chemin, on recherche les totaux. On retourne dans ce cas "-1"
	if (path.length === 0)
		return -1;
	// On va parcourir l'axe du début à la fin
	var nodeIndex = 0;
	// On commence par chercher un noeud de niveau 0, puis de niveau 1 plus loin, ...
	var depth = 0;
	while (nodeIndex < axe.nodes.length) {
		var node = axe.nodes[nodeIndex];
		// A chaque fois qu'on trouve la bonne clef au bon niveau
		if (node.depth === depth && node.member.key === path[depth]) {
			// Soit on a trouvé la dernière clef, nodeIndex est dans ce cas la position qu'on cherchait
			if (depth === path.length - 1)
				return nodeIndex;
			// Soit on a trouvé un parent, on avance d'un niveau dans le chemin cherché
			depth++;
		}
		nodeIndex++;
	}
	// Si on a été jusqu'au bout, c'est qu'on n'a pas trouvé le noeud, on retourne "null"
	return null;
};

/** Méthode interne pour rechercher dans la position d'une ligne dont on connait le chemin (un tableau de N clefs) */
BIReportView.prototype.findRowIndex = function(path/*: key[]*/) {
	return this.findNodeIndex(this.rowAxe, path);
};

/** Méthode interne pour rechercher dans la position d'une colonne dont on connait le chemin (un tableau de N clefs) */
BIReportView.prototype.findColIndex = function(path/*: key[]*/) {
	return this.findNodeIndex(this.colAxe, path);
};

/** Méthode interne pour savoir s'il y a des lignes au-dessus de la vue actuelle, et donc s'il faut activer le bouton "Page précédente" */
BIReportView.prototype.hasRowsBefore = function() {
	return this.rowAxe.offset > 0;
};

/** Méthode interne pour savoir s'il y a des colonnes à gauche de la vue actuelle, et donc s'il faut activer le bouton "Page précédente" */
BIReportView.prototype.hasColsBefore = function() {
	return this.colAxe.offset > 0;
};

/** Méthode interne pour savoir s'il y a des lignes en-dessous de la vue actuelle, et donc s'il faut activer le bouton "Page Suivante" */
BIReportView.prototype.hasRowsAfter = function() {
	return this.rowAxe.offset + this.rowAxe.size < this.rowAxe.nodes.length;
};

/** Méthode interne pour savoir s'il y a des colonnes à droite de la vue actuelle, et donc s'il faut activer le bouton "Page Suivante" */
BIReportView.prototype.hasColsAfter = function() {
	return this.colAxe.offset + this.colAxe.size < this.colAxe.nodes.length;
};

/** Méthode interne pour savoir si le rapport est paramétré pour afficher les totaux par colonnes en haut, alors qu'ils sont en bas par défaut */
BIReportView.prototype.hasInvertedTotalRow = function() {
	return this.rowAxe.totalsPosition === 'FixBefore' || this.rowAxe.totalsPosition === 'Before';
};

/** Méthode interne pour savoir si le rapport est paramétré pour afficher les totaux par lignes à gauche, alors qu'ils sont à droite par défaut */
BIReportView.prototype.hasInvertedTotalCol = function() {
	return this.colAxe.totalsPosition === 'FixBefore' || this.colAxe.totalsPosition === 'Before';
};

/** Méthode interne pour savoir si le rapport est paramétré pour figer les totaux par colonnes, soit en haut, soit en bas */
BIReportView.prototype.hasFixTotalRow = function() {
	return this.rowAxe.totalsPosition === 'FixBefore' || this.rowAxe.totalsPosition === 'FixAfter';
};

/** Méthode interne pour savoir si le rapport est paramétré pour figer les totaux par lignes, soit à gauche, soit à droite */
BIReportView.prototype.hasFixTotalCol = function() {
	return this.colAxe.totalsPosition === 'FixBefore' || this.colAxe.totalsPosition === 'FixAfter';
};

/** Méthode interne pour savoir si le rapport contient des lignes non figées (les totaux ou, plus couramment, les noeuds des niveaux mis en ligne) */
BIReportView.prototype.hasFloatingRows = function() {
	return this.rowAxe.totalsPosition === 'Before' || this.rowAxe.totalsPosition === 'After' || this.rowAxe.nodes.length > 0;
};

/** Méthode interne pour savoir si le rapport contient des colonnes non figées (les totaux ou, plus couramment, les noeuds des niveaux mis en colonne) */
BIReportView.prototype.hasFloatingCols = function() {
	return this.colAxe.totalsPosition === 'Before' || this.colAxe.totalsPosition === 'After' || this.colAxe.nodes.length > 0;
};

/** Méthode interne pour parcourir les noeuds de l'axe visibles dans la page en cours, et dans l'ordre paramétré */
BIReportView.prototype.forEachNode = function(axe, axeDepth, consumer) {
	// Passer sur chaque noeud parent du 1er noeud de la page pour montrer l'arboresence
	function consumeParent(nodes, offset) {
		var depth = nodes[offset].depth;
		if (depth > 0) {
			var pos = offset - 1;
			while (nodes[pos].depth >= depth) {
				pos--;
			}
			consumeParent(nodes, pos);
			consumer(nodes[pos], pos, true);
		}
	}

	// Passer sur les totaux s'ils sont affichés en avant (en haut pour les lignes ou à gauche pour les colonnes)
	if (axe.totalsPosition === 'Before')
		consumer(null, -1, true);

	if (axe.nodes.length) {
		// Passer sur chaque noeud parent du 1er noeud de la page pour montrer l'arboresence
		consumeParent(axe.nodes, axe.offset);

		// Passer sur chaque ligne/colonne de la page
		var maxIndex = axe.offset + axe.size;
		for (var i = axe.offset; i < maxIndex; i++) {
			consumer(axe.nodes[i], i, axe.nodes[i].depth < axeDepth);
		}
	}

	// Passer sur les totaux s'ils sont affichés en après (en bas pour les lignes ou à droite pour les colonnes)
	if (axe.totalsPosition === 'After')
		consumer(null, -1, true);
};

/** Méthode interne pour parcourir les lignes visibles dans la page en cours, et dans l'ordre paramétré */
BIReportView.prototype.forEachRow = function(consumer) {
	this.forEachNode(this.rowAxe, this.calculatedRowAxeDepth, consumer);
};

/** Méthode interne pour parcourir les colonnes visibles dans la page en cours, et dans l'ordre paramétré */
BIReportView.prototype.forEachCol = function(consumer) {
	this.forEachNode(this.colAxe, this.calculatedColAxeDepth, consumer);
};

/**
 * Cette méthode renvoie la cellule (= valeurs des mesures) à l'intersection de la ligne et de la colonne données :
 * @param {BIReportNode} row la ligne demandée, ou null si la cellule recherchée est un total par colonne (en haut ou en bas)
 * @param {BIReportNode} rowIndex l'index dans rowAxe.nodes, ou -1 si la cellule recherchée est un total par colonne
 * @param {BIReportNode} col la colonne demandée, ou null si la cellule recherchée est un total par ligne (à droite ou à gauche)
 * @param {BIReportNode} colIndex l'index dans colAxe.nodes, ou -1 si la cellule recherchée est un total par ligne
 * @return {Object} la cellule recherché, qui sera soit this.grandTotalCell, soit un BIReportNode.totalCell, soit une entrée de this.cells
 */
BIReportView.prototype.getCell = function(row, rowIndex, col, colIndex) {
	// Si row et et col sont null, il s'agit des grand-totaux, qui existente toujours
	if (row == null && col == null)
		return this.grandTotalCell;
	// Si row est null et col non null, il s'agit du total de la colonne
	if (row == null)
		return col.totalCell;
	// Si col est null et row non null, il s'agit du total de la ligne
	if (col == null)
		return row.totalCell;
	// Si les deux sont précisées, on recherche dans cells.

	// Remarque 1 : this.cells est un tableau à une dimension, contenant les cellules de la 1ère ligne, suivies des cellules
	// de la seconde ligne, ... Du coup, ça n'est pas aussi simple que ça :
	//return this.cells[rowIndex][colIndex];

	// Remarque 2 : Alors que rowAxe.nodes et colAxe.nodes contiennent toutes les lignes / colonnes pour gérer la pagination,
	// "cells" ne contient que les cellules de la page en cours. Du coup, ça n'est pas aussi simple que ça :
	//return this.cells[rowIndex * this.colAxe.nodes.length + colIndex];

	// Calcul de l'index de la ligne à utiliser dans le tableau cells
	var cellRowIndex;
	if (rowIndex < this.rowAxe.offset)
		cellRowIndex = row.depth; // pour les parents de la 1ère ligne, ça correspond à leur profondeur
	else
		cellRowIndex = rowIndex - this.rowAxe.offset + this.rowAxe.nodes[this.rowAxe.offset].depth;
	// Calcul de l'index de la colonne à utiliser dans le tableau cells
	var cellColIndex;
	if (colIndex < this.colAxe.offset) {
		/*
		 * Condition vraie seulement si on ne se trouve pas sur la première page et
		 * qu'il s'agit d'un niveau parent de ce qui aurait du être la première colonne.
		 * Les niveaux parents ont été ajoutés en début de ligne et leur profondeur correspond à leur index.
		 */
		cellColIndex = col.depth;
	} else {
		cellColIndex = colIndex - this.colAxe.offset;
		/*
		 * Il faut ajouter la profondeur de la première colonne à afficher (hors niveaux parents).
		 *
		 * Sur la première page offset vaut 0 et la toute première colonne doit avoir une profondeur de 0 donc ça ne change rien.
		 * 
		 * Sur les pages suivantes la première colonne a afficher peut avoir des parents.
		 * Si par exemple la première colonne possède 2 niveaux parents alors 2 colonnes ont été ajoutées au début de chaque ligne.
		 * Il faut donc se décaller de 2 pour avoir l'index de la première colonne.
		 */
		cellColIndex += this.colAxe.nodes[this.colAxe.offset].depth;
	}

	// Sur les pages horizontales, this.colAxe.size n'inclut pas les colonnes des niveaux parents de la première colonne qui ont été ajoutés.
	// Il faut les prendre en compte dans le calcul de la taille d'une ligne
	const colAxeSize = this.colAxe.size + this.colAxe.nodes[this.colAxe.offset].depth;
	return this.cells[cellRowIndex * colAxeSize + cellColIndex];
};

/** Méthode interne renvoyant la hauteur actuellement paramétrée pour les en-têtes, mais apparemment pas utilisée à date */
BIReportView.prototype.getHeaderSize = function() { return this.headerSize || 46; };
/** Méthode interne renvoyant la largeur de la colonne affichant les groupes de mesures, s'ils existent et lorsque les mesures sont affichées en ligne */
BIReportView.prototype.getMeasureGroupsWidth = function() { return this.measureGroupsWidth || 60; };
/** Méthode interne renvoyant la largeur de la colonne affichant les noms de mesures, lorsque les mesures sont affichées en ligne */
BIReportView.prototype.getMeasureNamesWidth = function() { return this.measureNamesWidth || 120; };
/** Méthode interne renvoyant la largeur de la colonne affichant les valeurs des mesures, lorsque les mesures sont affichées en ligne */
BIReportView.prototype.getMeasureValuesWidth = function() { return this.measureValuesWidth || 60; };
/** Méthode interne renvoyant la largeur de la colonne d'un mesure donnée, lorsque les mesures sont affichées en colonne */
BIReportView.prototype.getMeasureWidth = function(measure) { return measure.width || 60; };
/** Méthode interne renvoyant la largeur de la colonne d'un attribut, lorsque son niveau associé est affichée en ligne (NB: on n'affiche pas les attributs des niveaux en colonnes) */
BIReportView.prototype.getAttributeWidth = function(attribute) { return attribute.width || 60; };
/** Méthode interne renvoyant la largeur de la colonne d'un niveau affiché en ligne (NB: pour les niveaux en colonne, la largeur dépend des mesures) */
BIReportView.prototype.getLevelWidth = function(level) { return level.width || 120; };

/** Cette méthode transforme un tableau d'objets (niveaux ou mesures) en un tableau de noms */
BIReportView.prototype.getNames = function(items) {
	return items.map(function(item) { return item.name; });
};

/** Cette méthode transforme un tableau de noms en un tableau d'objets (niveaux ou mesures), recherchés dans un tableau exhaustif */
BIReportView.prototype.getFromNames = function(items, names) {
	return names.map(function(name) {
		return items.find(function(item) {
			return item.name === name;
		});
	});
};

/** Cette méthode supprime une mesure calculée. Toutes les mesures peuvent être _masquées_ mais seules les mesures calculées
 * peuvent être _supprimées_, et en plus à condition de ne pas être utilisée dans la formule d'autres mesures calculées */
BIReportView.prototype.removeMeasure = function(measure) {
	var self = this;
	self.execute({
		operations: ['removeMeasure'],
		measureName: measure.name
	}, function(response) {
		if (response === true) {
			// Nettoyage des cellules
			delete self.grandTotalCell[measure.name];
			self.rowAxe.nodes.forEach(function(node) {
				delete node.totalCell[measure.name];
			});
			self.colAxe.nodes.forEach(function(node) {
				delete node.totalCell[measure.name];
			});
			self.cells.forEach(function(cell) {
				delete cell[measure.name];
			});
			// Suppression de la liste des mesures
			self.measures.splice(self.measures.indexOf(measure), 1);
			// Le reste a été nettoyé dans "execute"
			// visibleMeasures, extraMeasures, measureGroups, ...
		}
	});

};

/** Cette méthode effectue l'opération demandée sur la vue en contactant le serveur et lance un évènement "bi.change" */
BIReportView.prototype.execute = function(operation, callback) {
	var self = this;
	this.onexecute(this, operation, function(data) {
		if (data.rowLevelNames)
			self.rowAxe.levels = self.getFromNames(self.levels, data.rowLevelNames);
		if (data.rows)
			self.rowAxe.nodes = data.rows;
		if (typeof data.rowOffset === 'number')
			self.rowAxe.offset = data.rowOffset;
		if (typeof data.rowSize === 'number')
			self.rowAxe.size = data.rowSize;

		if (data.colLevelNames)
			self.colAxe.levels = self.getFromNames(self.levels, data.colLevelNames);
		if (data.cols)
			self.colAxe.nodes = data.cols;
		if (typeof data.colOffset === 'number')
			self.colAxe.offset = data.colOffset;
		if (typeof data.colSize === 'number')
			self.colAxe.size = data.colSize;

		if (data.extraLevelNames)
			self.extraLevels = self.getFromNames(self.levels, data.extraLevelNames);
		if (data.extraMeasureNames)
			self.extraMeasures = self.getFromNames(self.measures, data.extraMeasureNames);
		if (data.visibleMeasureNames)
			self.visibleMeasures = self.getFromNames(self.measures, data.visibleMeasureNames);
		if (data.measureGroups)
			self.measureGroups = data.measureGroups;

		if (data.measureSort) {
			self.sortMeasureName = data.measureSort.name || null;
			self.sortMeasureAscending = !!data.measureSort.ascending;
			self.sortMeasurePath = data.measureSort.path || [];
		}

		if (data.grandTotalCell)
			self.grandTotalCell = data.grandTotalCell;
		if (data.cells)
			self.cells = data.cells;

		self.internalUpdateCache();

		if (callback)
			callback(data.response);

		$(self).trigger('bi.change', [{
			storage: !!data.storage,
			rowLevels: !!data.rowLevelNames,
			rows: !!data.rows,
			rowOffset: (typeof data.rowOffset === 'number'),
			colLevels: !!data.colLevelNames,
			cols: !!data.cols,
			colOffset: (typeof data.colOffset === 'number'),
			extraLevels: !!data.extraLevelNames,
			extraMeasures: !!data.extraMeasureNames,
			visibleMeasures: !!data.visibleMeasureNames,
			measureGroups: !!data.measureGroups,
			sortMeasure: !!data.sortMeasure,
			grandTotalCell: !!data.grandTotalCell,
			cells: !!data.cells
		}, operation]);
	});
};

/**
 * C'est un composant jQuery qui permet de rechercher dans un rapport
 */
function BIReportGridSearch(target, view) {
	this.view = view;
	this.searchLevel = null;
	this.lang = BI.langs[BI.options.lang];
	this.target = $(target).addClass('bbm-report-search').html(''
		+ '<div>'
		+ '  <input type="text" placeholder="' + this.lang.searchPlaceholder + '" />'
		+ '  <button type="button" class="btn btn-link"><i class="material-icons">search</i></button>'
		+ '  <div class="dropdown">'
		+ '    <button type="button" class="btn btn-link dropdown-toggle" data-toggle="dropdown"><i></i><span class="caret"></span></button>'
		+ '    <ul class="dropdown-menu dropdown-menu-right"><li><a href="#">Niveau 1</a></li><li><a href="#">Niveau 2</a></li></ul>'
		+ '  </div>'
		+ '</div>'
	);

	this.internalUpdate();
	this.internalConnect();
}

/** Cette méthode détruit le composant */
BIReportGridSearch.prototype.destroy = function() {
	this.target.removeClass('bbm-report-search').empty();
};

/** Cette méthode connecte les écouteurs sur l'input, sur le button, sur le menu et sur la vue */
BIReportGridSearch.prototype.internalConnect = function() {
	var self = this;
	var container = this.target.children(/*'div'*/);

	// Noter le niveau servant à la recherche quand l'utilisateur fait sa sélection
	container.children('.dropdown').on('click', 'a', function(event) {
		event.preventDefault();
		// Récupérer le "li"
		var li = $(event.target).closest('li');
		// Noter le niveau sélectionné
		self.searchLevel = li.data('level');
		// Mettre à jour le texte du bouton
		li.parent().siblings('button').children('i').text(self.searchLevel.caption + ' ');
		// Marquer l'entrée sélectionnée
		li.addClass('active').siblings().removeClass('active');
	});

	// Lancer la recherche sur en appuyant sur "Entrée" et pas sur "onchange" pour pouvoir choisir le niveau d'abord
	container.children('input').on('keyup', function(event) {
		if (event.keyCode === 10 || event.keyCode === 13)
			self.internalSearch($(event.target).val());
	});

	// Lancer la recherche sur en appuyant sur le bouton
	container.children('button').on('click', function(event) {
		self.internalSearch($(event.target).closest('button').prev().val());
	});

	// Raffraichir l'IHM quand les niveaux changent
	$(self.view).on('bi.change', function(_event, changes) {
		if (changes.rowLevels || changes.colLevels)
			self.internalUpdate();
	});
};

/** Cette méthode met à jour la zone de recherche quand les niveaux en ligne ou en colonne changent */
BIReportGridSearch.prototype.internalUpdate = function() {
	// Vérifier si la recherche est actif et prévenir ceux qui le souhaitent
	var enabled = this.view.rowAxe.levels.length > 0 || this.view.colAxe.levels.length > 0;
	this.target.trigger('bi.togglesearch', [enabled]);
	if (!enabled) {
		this.target.fadeOut();
		return;
	}

	// La recherche en disponible pour chaque niveau affiché
	var levels = this.view.rowAxe.levels.concat(this.view.colAxe.levels);
	var rowLevelCount = this.view.rowAxe.levels.length;

	// Si le niveau sur lequel on cherchait n'est plus affiché, on le désélectionne
	if (this.searchLevel !== null && levels.indexOf(this.searchLevel) === -1)
		this.searchLevel = null;

	// Si aucun niveau n'est sélectionné, on sélectionne le premier automatiquement
	if (this.searchLevel === null)
		this.searchLevel = levels[0];

	// Ensuite, on met le texte du bouton
	var dropdown = this.target.find('>div>.dropdown');
	dropdown.find('>button>:first-child').text(this.searchLevel.caption + ' ');

	// On met à jour le menu
	var menu = dropdown.children('ul').empty();
	levels.forEach(function(level, levelIndex) {
		if (levelIndex > 0 && levelIndex === rowLevelCount)
			menu.append('<li role="separator" class="divider"></li>');
		$('<li />').data('level', level)
			.toggleClass('active', level === this.searchLevel)
			.append($('<a href="#" />').text(level.caption))
			.appendTo(menu);
	}.bind(this));
};

/** Cette méthode lance une recherche. En retour, la vue lancera un évènement "bi.change" qui mettra la grille à jour */
BIReportGridSearch.prototype.internalSearch = function(term) {
	this.view.execute({
		operations: ['search'],
		searchText: term,
		searchLoop: true,
		levelName: this.searchLevel.name
	});
};

/** Cette méthode affiche ou cache la zone de recherche */
BIReportGridSearch.prototype.toggle = function() {
	var search = this.target;
	if (search.is(':visible')) {
		search.fadeOut();
	} else {
		search.fadeIn(function() {
			search.find('>div>input').focus();
		});
	}
};

/**
 * C'est un composant jQuery qui permet de personnaliser les mesures en accès rapides
 * ainsi que les niveaux en lignes, en colonnes et en accès rapide.
 */
function BIReportGridCustomization(target, view) {
	this.view = view;
	this.lang = BI.langs[BI.options.lang];
	this.target = $(target).addClass('bbm-report-customization').html(''
		+ '<table>'
		+ '  <tbody>'
		+ '    <tr class="bbm-report-extra-measures"><td class="bbm-report-customization-header">' + this.lang.extraMeasuresLabel + '</td><td></td></tr>'
		+ '    <tr class="bbm-report-extra-levels"><td class="bbm-report-customization-header">' + this.lang.extraLevelsLabel + '</td><td></td></tr>'
		+ '    <tr class="bbm-report-row-levels"><td class="bbm-report-customization-header">' + this.lang.rowLevelsLabel + '</td><td></td></tr>'
		+ '    <tr class="bbm-report-col-levels"><td class="bbm-report-customization-header">' + this.lang.colLevelsLabel + '</td><td></td></tr>'
		+ '  </tbody>'
		+ '</table>'
	);

	this.root = this.target.children('table').children('tbody');
	this.internalUpdate(true, true, true, true);
	this.internalConnect();
}

/** Cette méthode détruit le composant */
BIReportGridCustomization.prototype.destroy = function() {
	this.target.removeClass('bbm-report-customization').empty();
};

/** Cette méthode connecte les écouteurs pour le Drag&Drop, pour les popovers des boutons et pour les changements de la vue */
BIReportGridCustomization.prototype.internalConnect = function() {
	var self = this;
	if (!$.fn.dndDraggable)
		throw new Error('$.fn.dndDraggable requis');
	if (!$.fn.dndDroppable)
		throw new Error('$.fn.dndDroppable requis');
	if (!$.fn.popoverWithCheckBounds)
		throw new Error('$.fn.popoverWithCheckBounds requis');

	// Glisser depuis la zone "customization"
	this.root.dndDraggable({
		selector: '>tr >td >button',
		drag: function(operation) {
			var button = $(operation.draggable);
			operation.type = button.attr('data-cell-type');
			operation.data = button.data('level') || button.data('measure');
			operation.title = operation.data.caption;
		}
	});

	// Déposer une mesure sur une mesure en accès rapide (=> à une position précise)
	this.root.dndDroppable({
		accept: ['measure', 'extraMeasure'],
		selector: '>tr.bbm-report-extra-measures >td >button',
		drop: function(operation) {
			var dstMeasure = $(operation.droppable).closest('button').data('measure');
			if (operation.data === dstMeasure)
				return;
			self.internalMoveMeasureAtExtraMeasureIndex(operation, self.view.extraMeasures.indexOf(dstMeasure));
		}
	});

	// Déposer une mesure sur la ligne d'accès rapide (=> à la fin de la liste)
	this.root.dndDroppable({
		accept: ['measure', 'extraMeasure'],
		selector: '>tr.bbm-report-extra-measures',
		drop: function(operation) {
			if (operation.data !== self.view.extraMeasures[self.view.extraMeasures.length - 1])
				self.internalMoveMeasureAtExtraMeasureIndex(operation, self.view.extraMeasures.length);
		}
	});

	// Déposer un niveau sur un niveau en accès rapide (=> à une position précise)
	this.root.dndDroppable({
		accept: ['rowLevel', 'colLevel', 'extraLevel'],
		selector: '>tr.bbm-report-extra-levels >td >button',
		drop: function(operation) {
			self.internalDropLevelOnLevel(operation, self.view.extraLevels);
		}
	});

	// Déposer un niveau sur un niveau en ligne (=> à une position précise)
	this.root.dndDroppable({
		accept: ['rowLevel', 'colLevel', 'extraLevel'],
		selector: '>tr.bbm-report-row-levels >td >button',
		drop: function(operation) {
			self.internalDropLevelOnLevel(operation, self.view.rowAxe.levels);
		}
	});

	// Déposer un niveau sur un niveau en colonne (=> à une position précise)
	this.root.dndDroppable({
		accept: ['rowLevel', 'colLevel', 'extraLevel'],
		selector: '>tr.bbm-report-col-levels >td >button',
		drop: function(operation) {
			self.internalDropLevelOnLevel(operation, self.view.colAxe.levels);
		}
	});

	// Déposer un niveau à la fin des accès rapide
	this.root.dndDroppable({
		accept: ['rowLevel', 'colLevel', 'extraLevel'],
		selector: '>tr.bbm-report-extra-levels',
		drop: function(operation) {
			self.internalDropLevelAtEnd(operation, self.view.extraLevels);
		}
	});

	// Déposer un niveau à la fin des lignes
	this.root.dndDroppable({
		accept: ['rowLevel', 'colLevel', 'extraLevel'],
		selector: '>tr.bbm-report-row-levels',
		drop: function(operation) {
			self.internalDropLevelAtEnd(operation, self.view.rowAxe.levels);
		}
	});

	// Déposer un niveau à la fin des colonnes
	this.root.dndDroppable({
		accept: ['rowLevel', 'colLevel', 'extraLevel'],
		selector: '>tr.bbm-report-col-levels',
		drop: function(operation) {
			self.internalDropLevelAtEnd(operation, self.view.colAxe.levels);
		}
	});

	// Popover pour les niveaux et les mesures
	this.root.popoverWithCheckBounds({
		selector: '>tr>td:last-child>button',
		container: this.root,
		html: true,
		/*
		 * Pour éviter d'envoyer 2 requêtes au serveur il faut donner un title dont la valeur dans un if est interprétée comme true.
		 * Avant d'afficher le popover, Bootstrap fait un appel à sa méthode hasContent() qui est implémentée de la manière suivante:
		 *         return this.getTitle() || this.getContent()
		 * Si this.getTitle() renvoie false alors this.getContent() est appelé et une requête vers le serveur risque d'être exécutée
		 */
		title: ' ',
		placement: 'auto right',
		template: '<div class="popover" role="tooltip"><div class="arrow"></div><div class="popover-content"></div></div>',
		content: function() {
			var button = $(this).closest('button');
			var type = button.attr('data-cell-type');
			self.root.children('.popover').remove();
			switch(type) {
				case 'extraMeasure':
					return BI.createPopoverForMeasure(self.view, button.data('measure'), null);
				case 'extraLevel':
				case 'rowLevel':
				case 'colLevel':
					return BI.createPopoverForLevel(self.view, button.data('level'));
				default:
					return '';
			}
		}
	});

	// Raffraichir l'IHM quand la vue indique qu'elle a été modifiée
	$(self.view).on('bi.change', function(_event, changes, operation) {
		// Si les filtres ont changé, on force la mise à jour des niveaux pour souligner ou non les libellés
		var isFilter = operation.operations.indexOf('changeLevelFilter') >= 0;
		self.internalUpdate(changes.extraMeasures, isFilter || changes.extraLevels, isFilter || changes.rowLevels, isFilter || changes.colLevels);
	});
};

/** Cette méthode met à jour la zone de personnalisation quand les niveaux ou les mesures changent */
BIReportGridCustomization.prototype.internalUpdate = function(measures, levels, rowLevels, colLevels) {
	var root = this.root;
	function append(trClass, list, cellType, dataName) {
		var content = [];
		list.forEach(function(entry, index) {
			if (index > 0)
				content.push('<i class="bbm-report-customization-separator" />');
			var underline = dataName === 'level' && BI.isFilteredLevel(entry);
			content.push($('<button type="button" class="btn btn-link" />')
				.attr('data-cell-type', cellType)
				.css('text-decoration', underline ? 'underline' : 'none')
				.data(dataName, entry)
				.text(entry.caption).get(0));
		});
		root.find('>.' + trClass + '>:last-child').empty().append(content);
	}
	if (measures)
		append('bbm-report-extra-measures', this.view.extraMeasures, 'extraMeasure', 'measure');
	if (levels)
		append('bbm-report-extra-levels', this.view.extraLevels, 'extraLevel', 'level');
	if (rowLevels)
		append('bbm-report-row-levels', this.view.rowAxe.levels, 'rowLevel', 'level');
	if (colLevels)
		append('bbm-report-col-levels', this.view.colAxe.levels, 'colLevel', 'level');
};

/** Cette méthode prend en compte le glisser/déposer d'un niveau sur le bouton représentant un autre niveau */
BIReportGridCustomization.prototype.internalDropLevelOnLevel = function(operation, items) {
	var dropLevel = $(operation.droppable).closest('button').data('level');
	var dropIndex = items.indexOf(dropLevel);
	if (operation.data !== dropLevel)
		this.internalDropLevelAtIndex(operation, items, dropIndex);
};

/** Cette méthode prend en compte le glisser/déposer d'un niveau à la fin d'une liste de niveaux */
BIReportGridCustomization.prototype.internalDropLevelAtEnd = function(operation, items) {
	if (operation.data !== items[items.length - 1])
		this.internalDropLevelAtIndex(operation, items, items.length);
};

/** Cette méthode prend en compte le glisser/déposer d'un niveau dans une liste à une position donnée */
BIReportGridCustomization.prototype.internalDropLevelAtIndex = function(operation, items, index) {
	// Récupérer le niveau glissé
	var level = operation.data;

	// Cacher le niveau s'il était visible
	if (operation.type === 'extraLevel')
		this.view.extraLevels.splice(this.view.extraLevels.indexOf(level), 1);
	else if (operation.type === 'rowLevel')
		this.view.rowAxe.levels.splice(this.view.rowAxe.levels.indexOf(level), 1);
	else
		this.view.colAxe.levels.splice(this.view.colAxe.levels.indexOf(level), 1);

	// Déplacer le niveau dans la liste demandée à la position attendue
	items.splice(index, 0, level);

	// Mettre à jour le reste en passant par le serveur
	var operations = [];
	if (operation.type !== 'extraLevel' || items !== this.view.extraLevels)
		operations.push('changeAxeLevels');
	if (operation.type === 'extraLevel' || items === this.view.extraLevels)
		operations.push('changeExtraLevels');
	this.view.execute({
		operations: operations,
		extraLevelNames: this.view.getNames(this.view.extraLevels),
		rowLevelNames: this.view.getNames(this.view.rowAxe.levels),
		colLevelNames: this.view.getNames(this.view.colAxe.levels),
	});
};

/** Cette méthode prend en compte le glisser/déposer d'une mesure dans la zone d'accès rapide à une position donnée */
BIReportGridCustomization.prototype.internalMoveMeasureAtExtraMeasureIndex = function(operation, index) {
	// Récupérer la mesure glissée
	var measure = operation.data;
	var measureIndex;

	// Cacher la mesure si elle était visible
	if (operation.type === 'measure') {
		// Récupérer la position actuelle
		measureIndex = this.view.visibleMeasures.indexOf(measure);
		// MAJ des groupes
		this.view.measureGroups = this.view.measureGroups.filter(function(group) {
			if (group.firstMeasureIndex > measureIndex)
				group.firstMeasureIndex--;
			if (group.lastMeasureIndex >= measureIndex)
				group.lastMeasureIndex--;
			return group.lastMeasureIndex >= group.firstMeasureIndex;
		});
		// Retrait de la mesure
		this.view.visibleMeasures.splice(measureIndex, 1);
	} else {
		// Récupérer la position actuelle
		measureIndex = this.view.extraMeasures.indexOf(measure);
		// Retrait de la mesure de son ancienne position
		this.view.extraMeasures.splice(measureIndex, 1);
		// Si on visait "la fin", c'est une positon avant maintenant qu'on a retiré "measure"
		if (index > this.view.extraMeasures.length)
			index--;
	}

	// Déplacer la mesure à la position attendue
	this.view.extraMeasures.splice(index, 0, measure);

	// Mettre à jour le reste en passant par le serveur
	if (operation.type === 'measure') {
		this.view.execute({
			operations: ['hideMeasure', 'changeExtraMeasures'],
			measureName: measure.name,
			extraMeasureNames: this.view.getNames(this.view.extraMeasures),
		});
	} else {
		this.view.execute({
			operations: ['changeExtraMeasures'],
			extraMeasureNames: this.view.getNames(this.view.extraMeasures),
		});
	}
};

/** Cette méthode affiche ou cache la zone de personnalisation */
BIReportGridCustomization.prototype.toggle = function() {
	this.target.fadeToggle();
};

/**
 * C'est un plugin jQuery qui construira un rapport grille OLAP interactive
 */
function BIReportGrid(target, view) {
	this.view = view;
	this.lang = BI.langs[BI.options.lang];
	this.target = $(target).addClass('bbm-report')
		.toggleClass('bbm-report-invert-col-axe-totals', this.view.hasInvertedTotalCol())
		.toggleClass('bbm-report-invert-row-axe-totals', this.view.hasInvertedTotalRow())
		.html(''
		+ '<div class="bbm-report-main">'
		+ '  <div class="bbm-report-top">'
		+ '    <div class="bbm-report-left"><table class="bbm-report-table"><thead><tr class="bbm-report-layout-row" /></thead></table></div>'
		+ '    <div class="bbm-report-center"><table class="bbm-report-table"><thead><tr class="bbm-report-layout-row" /></thead></table></div>'
		+ '    <div class="bbm-report-right"><table class="bbm-report-table"><thead><tr class="bbm-report-layout-row" /></thead></table></div>'
		+ '  </div>'
		+ '  <div class="bbm-report-middle">'
		+ '    <div class="bbm-report-left"><table class="bbm-report-table"><tbody><tr class="bbm-report-layout-row" /></tbody></table></div>'
		+ '    <div class="bbm-report-center"><table class="bbm-report-table"><tbody><tr class="bbm-report-layout-row" /></tbody></table></div>'
		+ '    <div class="bbm-report-right"><table class="bbm-report-table"><tbody><tr class="bbm-report-layout-row" /></tbody></table></div>'
		+ '  </div>'
		+ '  <div class="bbm-report-bottom">'
		+ '    <div class="bbm-report-left"><table class="bbm-report-table"><tfoot><tr class="bbm-report-layout-row" /></tfoot></table></div>'
		+ '    <div class="bbm-report-center"><table class="bbm-report-table"><tfoot><tr class="bbm-report-layout-row" /></tfoot></table></div>'
		+ '    <div class="bbm-report-right"><table class="bbm-report-table"><tfoot><tr class="bbm-report-layout-row" /></tfoot></table></div>'
		+ '  </div>'
		+ '</div>'
		+ '<div class="bbm-report-scroll bbm-report-scroll-v">'
		+ '  <button type="button" class="btn btn-link" data-operation="moveRowFirstPage" title="' + this.lang.paginationFirstPage + '"><i class="material-icons">first_page</i></button>'
		+ '  <button type="button" class="btn btn-link" data-operation="moveRowPreviousPage" title="' + this.lang.paginationPreviousPage + '"><i class="material-icons">chevron_left</i></button>'
		+ '  <div><span class="bbm-report-scroll-handle"></span></div>'
		+ '  <button type="button" class="btn btn-link" data-operation="moveRowNextPage" title="' + this.lang.paginationNextPage + '"><i class="material-icons">chevron_right</i></button>'
		+ '  <button type="button" class="btn btn-link" data-operation="moveRowLastPage" title="' + this.lang.paginationLastPage + '"><i class="material-icons">last_page</i></button>'
		+ '</div>'
		+ '<div class="bbm-report-scroll bbm-report-scroll-h">'
		+ '  <button type="button" class="btn btn-link" data-operation="moveColFirstPage" title="' + this.lang.paginationFirstPage + '"><i class="material-icons">first_page</i></button>'
		+ '  <button type="button" class="btn btn-link" data-operation="moveColPreviousPage" title="' + this.lang.paginationPreviousPage + '"><i class="material-icons">chevron_left</i></button>'
		+ '  <div><span class="bbm-report-scroll-handle"></span></div>'
		+ '  <button type="button" class="btn btn-link" data-operation="moveColNextPage" title="' + this.lang.paginationNextPage + '"><i class="material-icons">chevron_right</i></button>'
		+ '  <button type="button" class="btn btn-link" data-operation="moveColLastPage" title="' + this.lang.paginationLastPage + '"><i class="material-icons">last_page</i></button>'
		+ '</div>'
		);

	// Récupération de certaines parties une fois pour toute plutôt que de chercher à chaque fois dans un arbre DOM plus complexe
	this.components = {};
	this.components.top = this.target.find('>.bbm-report-main>.bbm-report-top');
	this.components.bottom = this.target.find('>.bbm-report-main>.bbm-report-bottom').toggle(this.view.hasFixTotalRow());
	this.components.middle = this.target.find('>.bbm-report-main>.bbm-report-middle');
	this.components.left = this.target.find('>.bbm-report-main>*>.bbm-report-left');
	this.components.right = this.target.find('>.bbm-report-main>*>.bbm-report-right').toggle(this.view.hasFixTotalCol());
	this.components.center = this.target.find('>.bbm-report-main>*>.bbm-report-center');
	this.components.vscroll = this.target.children('.bbm-report-scroll-v');
	this.components.hscroll = this.target.children('.bbm-report-scroll-h');
	this.components.maintable = this.target.find('>.bbm-report-main>.bbm-report-middle>.bbm-report-center>table');

	// Les mesures longues à calculer si on demande à DOM ou jQuery de le faire.
	// Du coup, on le fait soit-même si possible et, surtout, on garde la valeur tant qu'elle reste valable.
	this.topHeight = 0;     // hauteur de la partie fixe en haut
	this.bottomHeight = 0;  // hauteur de la partie fixe en bas
	this.middleHeight = 0;  // hauteur de la partie au centre
	this.vscrollHeight = 0; // hauteur de l'ascenseur à droite
	this.leftWidth = 0;     // largeur de la partie fixe à gauche
	this.rightWidth = 0;    // largeur de la partie fixe à droite
	this.centerWidth = 0;   // largeur de la partie au centre
	this.hscrollWidth = 0;  // largeur de l'ascenseur en bas

	// Ajustement des margin pour masquer les ascenseurs
	var scrollDimensions = BaseAPI.getScrollDimensions(document.body);
	this.components.maintable.parent().css({
		'margin-bottom': '-' + scrollDimensions.height + 'px',
		'margin-right': '-' + scrollDimensions.width + 'px',
		'overflow': 'scroll'
	});

	// Dessin initial
	this.internalUpdateGrid();
	this.internalUpdateWidth(true);
	this.internalUpdateHeight(true);
	this.internalConnectEvents(); // connexion des listeners et des plugins jQuery UI
	this.internalUpdateScrollTop(null, 0, null);
}

BIReportGrid.prototype.destroy = function() {
	this.target.off('detectresize wheel mousedown');
	this.target.removeClass('bbm-report bbm-report-invert-col-axe-totals bbm-report-invert-row-axe-totals');
	this.target.empty();
};

BIReportGrid.prototype.internalConnectEvents = function() {
	var self = this;
	if (!$.fn.detectResize)
		throw new Error('$.fn.detectResize requis');
	if (!$.fn.dndDraggable)
		throw new Error('$.fn.dndDraggable requis');
	if (!$.fn.dndDroppable)
		throw new Error('$.fn.dndDroppable requis');
	if (!$.fn.popoverWithCheckBounds)
		throw new Error('$.fn.popoverWithCheckBounds requis');

	// Ajuster l'affichage quand la taille change
	this.target.detectResize().on('detectresize', function() {
		self.updateSize();
	});

	// Glisser un niveau depuis la grille
	this.components.top.children('.bbm-report-left').dndDraggable({
		selector: 'td.bbm-report-level>span',
		drag: function(operation) {
			var td = $(operation.draggable).closest('td');
			operation.type = td.attr('data-cell-type');
			operation.data = td.data('level');
			operation.title = operation.data.caption;
		}
	});

	// Glisser une mesure depuis la grille
	this.target.children('.bbm-report-main').dndDraggable({
		type: 'measure',
		selector: '.bbm-report-top td.bbm-report-measure>span, .bbm-report-left td.bbm-report-measure>span',
		drag: function(operation) {
			var td = $(operation.draggable).closest('td');
			operation.data = td.data('measure');
			operation.title = operation.data.caption;
		}
	});

	// Déposer sur un groupe de mesure pour l'afficher à la fin du groupe
	this.target.children('.bbm-report-main').dndDroppable({
		accept: ['measure', 'extraMeasure'],
		selector: '.bbm-report-top .bbm-report-measure-group > span, .bbm-report-left .bbm-report-measure-group > span',
		drop: function(operation) {
			// Récupérer la mesure
			var measure = operation.data;
			// Récupérer le groupe
			var group = $(operation.droppable).closest('.bbm-report-measure-group').data('group');
			// Retirer si besoin la mesure de son ancienne position
			if (operation.type === 'measure')
				self.hideMeasure(measure);
			// Ajout à la fin du groupe
			self.showMeasureAtIndex(measure, group.lastMeasureIndex + 1, true);
			// MAJ de l'IHM
			self.internalUpdateVisibleMeasures();
		}
	});

	// Déposer sur une mesure visible pour l'afficher à la place
	this.target.children('.bbm-report-main').dndDroppable({
		accept: ['measure', 'extraMeasure'],
		selector: '.bbm-report-top .bbm-report-measure > span, .bbm-report-left .bbm-report-measure > span',
		drop: function(operation) {
			// Récupérer la mesure glissée
			var srcMeasure = operation.data;
			// Récupérer la mesure où on dépose
			var dstMeasure = $(operation.droppable).closest('.bbm-report-measure').data('measure');
			// Vérifier s'il y a vraiment quelque chose à faire
			if (operation.type === 'measure' && srcMeasure === dstMeasure)
				return;
			// Ajouter par défaut à la nouvelle position
			var dstMeasureIndex = self.view.visibleMeasures.indexOf(dstMeasure);
			// Retirer si besoin la mesure de son ancienne position
			if (operation.type === 'measure')
				self.hideMeasure(srcMeasure);
			// Ajouter la mesure à la position calculée
			self.showMeasureAtIndex(srcMeasure, dstMeasureIndex, false);
			// MAJ de l'IHM
			self.internalUpdateVisibleMeasures();
		}
	});

	// Déposer un niveau sur un niveau déjà visible pour l'afficher à la place
	this.components.top.children('.bbm-report-left').dndDroppable({
		accept: ['rowLevel', 'colLevel', 'extraLevel'],
		selector: '.bbm-report-level > span',
		drop: function(operation) {
			self.dropLevel(operation);
		}
	});

	// Scroll horizontal grâce au composant en bas
	var hscrollBar = self.components.hscroll.children('div');
	var hscrollCallback = function(event) {
		self.internalUpdateScrollLeft(event.clientX, null, null);
	};
	// Déplacement immédiat en cliquant dans la barre
	hscrollBar.on('click', hscrollCallback);
	// Déplacement à la souris en appuyant d'abord sur la barre
	hscrollBar.mouseDrag({ move: hscrollCallback });
	// Déplacement dans les pages avec les boutons "Première", "Précédente", "Suivante" et "Dernière"
	self.components.hscroll.children('button').on('click', function(event) {
		self.view.execute({ operations: [$(event.target).closest('button').attr('data-operation')] });
	});

	// Scroll vertical grâce au composant à droite
	var vscrollBar = self.components.vscroll.children('div');
	var vscrollCallback = function(event) {
		self.internalUpdateScrollTop(event.clientY, null, null);
	}.bind(this);
	// Déplacement immédiat en cliquant dans la barre
	vscrollBar.on('click', vscrollCallback);
	// Déplacement à la souris en appuyant d'abord sur la barre
	vscrollBar.mouseDrag({ move: vscrollCallback });
	// Déplacement dans les pages avec les boutons "Première", "Précédente", "Suivante" et "Dernière"
	self.components.vscroll.children('button').on('click', function(event) {
		self.view.execute({ operations: [$(event.target).closest('button').attr('data-operation')] });
	});

	// Scroll horizontal et vertical en tactile
	// Les ascenseurs natifs ne sont pas visibles (cf margin à -17px dans le CSS).
	// Par contre, le fait d'avoir "overflow: auto" fait qu'on peut faire défiler au doigt
	self.components.maintable.parent().on('scroll', function(event) {
		var currentScrollTop = self.components.middle.children('.bbm-report-left').scrollTop() || 0;
		if (currentScrollTop !== event.target.scrollTop)
			self.internalUpdateScrollTop(null, event.target.scrollTop, event.target);

		var currentScrollLeft = self.components.top.children('.bbm-report-center').scrollLeft() || 0;
		if (currentScrollLeft !== event.target.scrollLeft)
			self.internalUpdateScrollLeft(null, event.target.scrollLeft, event.target);
	});

	// Redimensionnement auto en fonction du contenu
	self.components.top.on('dblclick', '.ui-resizable-e', function(event) {
		var td = $(event.target).closest('td');
		self.internalAutoResizeCell(td);
		return false;
	}).on('click', '.ui-resizable-e', function() {
		// Le return false est nécessaire pour que le popover associé à
		// l'en-tête n'apparaisse pas quand on double-clic pour redimensionner
		return false;
	});

	// Déployer / Diminuer les lignes et les colonnes
	self.components.top.on('click', '.bbm-report-node *:not(.bbm-report-node-with-actions)', function(event) {
		var nodeIndex = $(event.target).closest('td').data('nodeIndex');
		var expandable = self.view.colAxe.nodes[nodeIndex].expandable;
		if (expandable) {
			self.view.execute({
				operations: ['changeColExpanded'],
				index: nodeIndex
			});
		}
	});
	self.components.left.on('click', '.bbm-report-node *:not(.bbm-report-node-with-actions)', function(event) {
		var nodeIndex = $(event.target).closest('td').data('nodeIndex');
		var expandable = self.view.rowAxe.nodes[nodeIndex].expandable;
		if (expandable) {
			self.view.execute({
				operations: ['changeRowExpanded'],
				index: nodeIndex
			});
		}
	});

	// Raffraichir l'IHM quand la vue indique qu'elle a été modifiée
	$(self.view).on('bi.change', function(_event, _changes, operation) {
		if (operation.operations.length === 1 && 'resizeLevel,resizeAttribute,resizeMeasure,resizeMeasureGroups,resizeMeasureNames,resizeMeasureValues'.indexOf(operation.operations[0]) >= 0)
			return;
		self.internalUpdateGrid();
		self.internalUpdateWidth(false);
		self.internalUpdateHeight(false);
	});

	// Popover pour les niveaux, les attributs, les mesures et les groupes de mesures
	self.target.popoverWithCheckBounds({
		selector: [
			'.bbm-report-level > span',
			'.bbm-report-attribute > span',
			'.bbm-report-measure > span',
			'.bbm-report-measure-group > span',
			'.bbm-report-node .bbm-report-node-with-actions'
		].join(','),
		container: self.target,
		html: true,
		placement: function(_popover, header) {
			// afficher le popover à droite pour la partie de gauche, ou en dessous pour les parties au centre ou à droite
			return $(header).closest('div').is('.bbm-report-left') ? 'auto right' : 'auto bottom';
			// afficher le popover en bas pour la partie du haut, ou à droite pour les parties du centre ou du bas
			//return $(header).closest('div').parent().is('.bbm-report-top') ? 'bottom' : 'right';
		},
		template: '<div class="popover" role="tooltip"><div class="arrow"></div><div class="popover-content"></div></div>',
		content: function() {
			var td = $(this).closest('td');
			self.target.children('.popover').remove();
			if (td.is('.bbm-report-level'))
				return BI.createPopoverForLevel(self.view, td.data('level'));
			if (td.is('.bbm-report-attribute'))
				return BI.createPopoverForAttribute(self.view, td.data('attribute'), td.data('level'));
			if (td.is('.bbm-report-measure'))
				return BI.createPopoverForMeasure(self.view, td.data('measure'), td.data('nodeIndex'));
			if (td.is('.bbm-report-measure-group'))
				return BI.createPopoverForMeasureGroup(self.view, td.data('group'));
			if (td.has('.bbm-report-node-with-actions'))
				return BI.createPopoverForMember(self.view, td, self.target);
			return '';
		}
	});
};

BIReportGrid.prototype.hideMeasure = function(measure) {
	// Récupérer la position actuelle
	var measureIndex = this.view.visibleMeasures.indexOf(measure);
	// MAJ des groupes
	this.view.measureGroups.forEach(function(group) {
		if (group.firstMeasureIndex > measureIndex)
			group.firstMeasureIndex--;
		if (group.lastMeasureIndex >= measureIndex)
			group.lastMeasureIndex--;
	});
	// Retrait de la mesure
	this.view.extraMeasures.push(this.view.visibleMeasures[measureIndex]);
	this.view.visibleMeasures.splice(measureIndex, 1);
};

BIReportGrid.prototype.showMeasureAtIndex = function(measure, measureIndex, inGroup) {
	// MAJ des groupes
	this.view.measureGroups.forEach(function(group) {
		if (group.firstMeasureIndex > measureIndex)
			group.firstMeasureIndex++;
		if ((group.lastMeasureIndex >= measureIndex) || (inGroup && measureIndex === group.lastMeasureIndex + 1))
			group.lastMeasureIndex++;
	});
	// Ajout de la mesure
	this.view.visibleMeasures.splice(measureIndex, 0, measure);
	this.view.extraMeasures.splice(this.view.extraMeasures.indexOf(measure), 1);
	// Prévenir le serveur et les autres composants qui écoutent la vue
	this.view.execute({
		operations: ['changeVisibleMeasures', 'changeExtraMeasures', 'changeMeasureGroups'],
		visibleMeasureNames: this.view.getNames(this.view.visibleMeasures),
		extraMeasureNames: this.view.getNames(this.view.extraMeasures),
		measureGroups: this.view.measureGroups,
	});
};

BIReportGrid.prototype.dropLevel = function(operation) {
	// Récupérer le niveau glissé et le niveau où l'on drop
	var dragLevel = operation.data;
	var dropLevel = $(operation.droppable).closest('.bbm-report-level').data('level');
	if (dragLevel === dropLevel)
		return;
	var dropAxe = this.view.rowAxe;
	var dropIndex = dropAxe.levels.indexOf(dropLevel);
	if (dropIndex === -1) {
		dropAxe = this.view.colAxe;
		dropIndex = dropAxe.levels.indexOf(dropLevel);
	}

	// Retirer le niveau de son ancienne liste
	if (operation.type === 'extraLevel')
		this.view.extraLevels.splice(this.view.extraLevels.indexOf(dragLevel), 1);
	else if (operation.type === 'rowLevel')
		this.view.rowAxe.levels.splice(this.view.rowAxe.levels.indexOf(dragLevel), 1);
	else
		this.view.colAxe.levels.splice(this.view.colAxe.levels.indexOf(dragLevel), 1);

	// Déplacer le niveau dans l'axe demandé à la position attendue
	dropAxe.levels.splice(dropIndex, 0, dragLevel);

	// Détecter les changements pour vider si besoin
	var rowAxeChanged = operation.type === 'rowLevel' || dropAxe === this.view.rowAxe;
	var colAxeChanged = operation.type === 'colLevel' || dropAxe === this.view.colAxe;
	var extraChanged = operation.type === 'extraLevel';
	if (rowAxeChanged)
		this.view.rowAxe.nodes.length = 0;
	if (colAxeChanged)
		this.view.colAxe.nodes.length = 0;
	if (rowAxeChanged || colAxeChanged)
		this.internalUpdateGrid();

	// Mettre à jour le reste en passant par le serveur
	this.view.execute({
		operations: extraChanged ? ['changeAxeLevels', 'changeExtraLevels'] : ['changeAxeLevels'],
		extraLevelNames: extraChanged ? this.view.getNames(this.view.extraLevels) : [],
		rowLevelNames: this.view.getNames(this.view.rowAxe.levels),
		colLevelNames: this.view.getNames(this.view.colAxe.levels),
	});
};

BIReportGrid.prototype.forEachMeasure = function(node, consumer) {
	if (node == null)
		this.view.visibleMeasures.forEach(consumer);
	else
		this.getMeasuresForDepth(node.depth).forEach(consumer);
};

BIReportGrid.prototype.getMeasuresForDepth = function(depth) {
	return this.view.calculatedVisibleMeasuresByDepth[depth];
};

BIReportGrid.prototype.getMeasureGroupsForDepth = function(depth) {
	return this.view.calculatedMeasureGroupsByDepth[depth];
};

/** Cette méthode prévient la grille que sa taille a changée */
BIReportGrid.prototype.updateSize = function(_depth) {
	// Quand la taille change, on ajuste certaines positions et visibilité
	this.internalUpdateWidth(true);
	this.internalUpdateHeight(true);
	// Si on avait scrollé tout en bas (ou à droite) et qu'on réduit la taille
	// l'ascenseur disparaissait. Dorénavant, on revient en haut (ou à gauche)
	this.internalUpdateScrollTop(0);
	this.internalUpdateScrollLeft(0);
};

/** Cette méthode met à jour la partie du rapport qu'il faut quand la liste des mesures visibles change */
BIReportGrid.prototype.internalUpdateVisibleMeasures = function() {
	// MAJ de l'IHM
	if (this.view.measureOnCols) {
		this.internalUpdateTopCenter();
		this.internalUpdateTopRight();
	} else {
		this.internalUpdateMiddleLeft();
		this.internalUpdateBottomLeft();
	}
	this.internalUpdateMiddleCenter();
	this.internalUpdateMiddleRight();
	this.internalUpdateBottomCenter();
	this.internalUpdateBottomRight();
};

/**
 * Cette méthode ajuste la visibilité de l'ascenseur et des boutons en bas quand le contenu des colonnes change.
 */
BIReportGrid.prototype.internalUpdateWidth = function(updateParentWidth) {
	if (updateParentWidth)
		this.hscrollWidth = this.components.hscroll[0].offsetWidth;

	this.components.left.css('width', this.leftWidth + 'px');
	this.components.right.css('width', this.rightWidth + 'px');
	if (this.view.colAxe.totalsPosition === 'FixBefore') {
		this.components.right.css('left', this.leftWidth + 'px');
		this.components.center.css('left', (this.leftWidth + this.rightWidth) + 'px').css('right', '0');
	} else if (this.view.colAxe.totalsPosition === 'FixAfter') {
		this.components.right.css('left', 'auto');
		this.components.center.css('left', this.leftWidth + 'px').css('right', this.rightWidth + 'px');
	} else {
		this.components.center.css('left', this.leftWidth + 'px').css('right', '0');
	}

	var hscroll = this.centerWidth > this.hscrollWidth - this.leftWidth - this.rightWidth;
	this.components.hscroll.find('.bbm-report-scroll-handle').toggle(hscroll);
	this.components.hscroll.children().slice(0, 2).prop('disabled', ! this.view.hasColsBefore());
	this.components.hscroll.children().slice(3).prop('disabled', ! this.view.hasColsAfter());
};

/**
 * Cette méthode ajuste la visibilité de l'ascenseur et des boutons à droite quand le contenu des lignes change.
 */
BIReportGrid.prototype.internalUpdateHeight = function(updateParentHeight) {
	if (updateParentHeight)
		this.vscrollHeight = this.components.vscroll[0].offsetHeight;

	this.components.top.css('height', this.topHeight + 'px');
	this.components.bottom.css('height', this.bottomHeight + 'px');
	if (this.view.rowAxe.totalsPosition === 'FixBefore') {
		this.components.bottom.css('top', this.topHeight + 'px');
		this.components.middle.css('top', (this.topHeight + this.bottomHeight) + 'px').css('bottom', '0');
	} else if (this.view.rowAxe.totalsPosition === 'FixAfter') {
		this.components.bottom.css('top', 'auto');
		this.components.middle.css('top', this.topHeight + 'px').css('bottom', this.bottomHeight + 'px');
	} else {
		this.components.middle.css('top', this.topHeight + 'px').css('bottom', '0');
	}

	var vscroll = this.middleHeight > this.vscrollHeight - this.topHeight - this.bottomHeight;
	this.components.vscroll.find('.bbm-report-scroll-handle').toggle(vscroll);
	this.components.vscroll.children().slice(0, 2).prop('disabled', ! this.view.hasRowsBefore());
	this.components.vscroll.children().slice(3).prop('disabled', ! this.view.hasRowsAfter());
};

/**
 * Cette méthode permet de redimensionner à une largeur donnée une colonne.
 *
 * Les cellules pouvant être redimensionnées sont :
 * - l'en-tête de colonne d'un attribut (change attribute.width)
 * - l'en-tête de colonne d'un niveau (change level.width)
 * - l'en-tête de colonne des groupes de mesures lorsqu'elles sont affichées en lignes (change view.measureGroupsWidth)
 * - l'en-tête de colonne des libellés de mesures lorsqu'elles sont affichées en lignes (change view.measureNamesWidth)
 * - l'en-tête de colonne des totaux par ligne des mesures lorsqu'elles sont affichées en lignes (change view.measureValuesWidth)
 * - l'en-tête de colonne des totaux par ligne d'une mesure lorsqu'elles sont affichées en colonnes (change measure.width)
 *
 * La largeur demandée peut être :
 * - calculée automatiquement par BIReportGrid.prototype.internalAutoResizeCell
 * - choisie par l'utilisateur grâce au plugin jQuery "resizable" activé dans BIReportGrid.prototype.internalActivateResize
 *
 * @param {jQuery} td - la cellule à redimensionner (automatiquement ou via le plugin jQuery "resizable")
 * @param {number} newWidth - la nouvelle largeur en pixel souhaitée pour la colonne
 * @see BIReportGrid.prototype.internalAutoResizeCell
 * @see BIReportGrid.prototype.internalActivateResize
 */
BIReportGrid.prototype.internalResizeCell = function(td, newWidth) {
	// Le type de cellule, qui nous indique quoi redimensionner
	var type = td.attr('data-cell-type');
	// Les paramètres de la méthode "view.execute"
	// NB1 : sous Chrome, on obtient des nombres décimaux pour newWidth. Il faut arrondir
	// NB2 : on utilise Math.ceil (entier supérieur) et non Math.floor (en inférieur) pour éviter que les ... reviennent si on est trop petit
	var parameters = { operations: [], width: Math.ceil(newWidth) };
	// L'élément de la vue associé à la cellule
	var item;
	switch (type) {
	case 'attribute':
		item = td.data('attribute');
		parameters.operations.push('resizeAttribute');
		parameters.levelName = td.data('level').name;
		parameters.attributeName = item.name;
		item.width = parameters.width;
		break;
	case 'rowLevel':
		item = td.data('level');
		parameters.operations.push('resizeLevel');
		parameters.levelName = item.name;
		item.width = parameters.width;
		break;
	case 'measure':
		item = td.data('measure');
		parameters.operations.push('resizeMeasure');
		parameters.measureName = item.name;
		item.width = parameters.width;
		break;
	case 'measureGroups':
		parameters.operations.push('resizeMeasureGroups');
		this.view.measureGroupsWidth = parameters.width;
		break;
	case 'measureNames':
		parameters.operations.push('resizeMeasureNames');
		this.view.measureNamesWidth = parameters.width;
		break;
	case 'measureValues':
		parameters.operations.push('resizeMeasureValues');
		this.view.measureValuesWidth = parameters.width;
		break;
	}
	// On met à jour l'IHM (comme c'est plus simple pour la partie gauche, on regarde si c'est cette partie qui est touchée)
	var leftResize = (type === 'attribute') || (type === 'rowLevel') || (type === 'measureGroups') || (type === 'measureNames');
	if (leftResize) {
		// Si on redimensionne une colonne de gauche, on ajuste la largeur à gauche
		this.components.left.find('>table>*>.bbm-report-layout-row').replaceWith(this.internalBuildLeftLayoutRow().toDOM());
	} else {
		// Si on redimensionne les mesures, on ajuste les largeurs au centre et à droite
		this.components.center.find('>table>*>.bbm-report-layout-row').replaceWith(this.internalBuildCenterLayoutRow().toDOM());
		this.components.right.find('>table>*>.bbm-report-layout-row').replaceWith(this.internalBuildRightLayoutRow().toDOM());
	}
	// Ajuster les ascenseurs
	this.internalUpdateWidth(true);
	// Revenir complètement à gauche s'il n'est pas pertinent de garder la position de l'ascenseur
	if (leftResize || this.view.colAxe.nodes.length > 0 && this.view.colAxe.totalsPosition !== 'Before')
		this.internalUpdateScrollLeft(0);
	// Exécution de la méthode côté serveur
	this.view.execute(parameters);
};

/**
 * Cette méthode permet de redimensionner automatiquement une colonne.
 *
 * @param {jQuery} td - la cellule double-cliquée afin de la redimensionner automatiquement
 * @see BIReportGrid.prototype.internalResizeCell pour le détail des colonnes pouvant être redimensionnées
 */
BIReportGrid.prototype.internalAutoResizeCell = function(td) {
	// La cellule dans laquelle l'utilisateur a double-cliquer pour auto-redimensionner
	var type = td.attr('data-cell-type');
	// Indiquera la nouvelle largeur calculée automatiquement
	var newWidth = null;
	// Pour ajuster, on va temporairement changer le style des tables et cellules en "width: auto;"
	var leftTables, centerTables, rightTables, leftCells, centerCells, rightCells;
	// Préparation de la fonction qui calculera la largeur maximale, utile dans tous les cas
	function maxWidth(cells) {
		return cells.get().reduce(function(currentMax, cell) {
			return Math.max(currentMax, Math.ceil($(cell).outerWidth()));
		}, 40);
	}
	// Auto-dimensionner les valeurs de mesures quand elles sont affichées en ligne
	if (type === 'measureValues') {
		// Passage en taille auto
		centerTables = this.components.center.children('table').css('width', 'auto');
		rightTables = this.components.right.children('table').css('width', 'auto');
		centerCells = centerTables.find('>*>tr.bbm-report-layout-row>*').css('width', 'auto');
		rightCells = rightTables.find('>*>tr.bbm-report-layout-row>*').css('width', 'auto');
		// Calcul de la largeur maximale
		newWidth = Math.max(maxWidth(centerCells), maxWidth(rightCells));
		// Retour aux tailles fixes
		centerTables.css('width', '');
		rightTables.css('width', '');
	}
	// Auto-dimensionner une mesure quand elle est affichée en colonne
	else if (type === 'measure') {
		// Retirer la taille fixe pour la mesure
		var measure = td.data('measure');
		// Passage en taille auto
		centerTables = this.components.center.children('table').css('width', 'auto');
		rightTables = this.components.right.children('table').css('width', 'auto');
		centerCells = centerTables.find('>*>tr.bbm-report-layout-row>*').filter(function() { return $(this).data('measure') === measure; }).css('width', 'auto');
		rightCells = rightTables.find('>*>tr.bbm-report-layout-row>*').filter(function() { return $(this).data('measure') === measure; }).css('width', 'auto');
		// Calcul des largeurs max
		newWidth = Math.max(maxWidth(centerCells), maxWidth(rightCells));
		// Retour aux tailles fixes
		centerTables.css('width', '');
		rightTables.css('width', '');
	}
	// Auto-dimensionner un niveau ou un attribut ou la colonne des groupes ou des mesures quand elles sont affichées en ligne
	else {
		// Passage en taille auto
		leftTables = this.components.left.children('table').css('width', 'auto');
		leftCells = leftTables.find('>*>tr.bbm-report-layout-row>*:nth-child(' + (td.index() + 1) + ')').css('width', 'auto');
		// Calcul de la largeur maximale
		newWidth = maxWidth(leftCells);
		// Retour aux tailles fixes
		leftTables.css('width', '');
	}
	// MAJ du modèle
	this.internalResizeCell(td, newWidth);
};

/**
 * Cette méthode active la zone permettant de redimensionner la colonne en utilisant le plugin jQuery "resizable"
 *
 * @param {jQuery} td - la cellule représente un niveau, un attribut, une mesure ou une autre cellule redimensionnable
 */
BIReportGrid.prototype.internalActivateResize = function(td) {
	td.resizable({
		animate: false,
		helper: 'bbm-report-resizer',
		handles: 'e',
		stop: function(_event, ui) {
			// La cellule redimensionnée
			var td = ui.element;
			// La nouvelle taille
			var newWidth = ui.size.width;
			// Supprimer le taille figée par CSS par le plugin "resizable"
			td.css('width', '').css('height', '');
			// Redimnesionnement
			this.internalResizeCell(td, newWidth);
		}.bind(this)
	});
};

/**
 * Cette méthode est appelée pour positionner la grille verticalement :
 * - soit grâce à "scrollTop" quand l'appel vient d'un évènement "scroll"
 * - soit grâce à "clientY" quand on manipule l'ascenseur
 * Le décalage est appliqué aux div (middle) et enregistré dans l'ascenseur vertical (vscroll).
 *
 * @param {number} clientY - la position de la souris quand on manipule l'ascenseur vertical
 * @param {number} scrollTop - le décalage vertical à appliquer quand c'est un évènement "scroll"
 * @param {DOMElement} source - le div qui a lancé un évènement "scroll" ou null si ça vient d'ailleurs
 * @return true si le décalage a effectivement changé
 */
BIReportGrid.prototype.internalUpdateScrollTop = function(clientY, scrollTop, source) {
	// On regarde le dernier "clientY" sauvegardé pour voir s'il y a vraiment quelque chose à faire
	var v = this.components.vscroll.data('position') || 0;
	if (clientY === v)
		return false;
	// Pour calculer la position, on a besoin de la table, de la barre et de la poignée, avec leur taille
	var tableMaxScroll = this.middleHeight - this.vscrollHeight + this.topHeight + this.bottomHeight;
	var bar = this.components.vscroll.children('div');
	var barSize = bar.height();
	var handle = bar.children();
	var handleSize = handle.height();
	var handleOffset;
	if (clientY !== null) {
		// On déduit la position de la poignée à partir de clientY
		handleOffset = clientY - bar.offset().top - handleSize / 2;
		// On ajuste la valeur de "handleOffset" en fonction des contraintes
		handleOffset = Math.max(0, Math.min(barSize - handleSize, handleOffset));
		// On déduit la valeur de "scrollTop" associée
		scrollTop = tableMaxScroll * handleOffset / (barSize - handleSize);
	} else {
		// On ajuste la valeur de "scrollTop" en fonction du scroll possible
		scrollTop = Math.max(0, Math.min(scrollTop, tableMaxScroll));
		// On en déduit la position de la poignée
		handleOffset = scrollTop * (barSize - handleSize) / tableMaxScroll;
		// Puis la valeur à sauvegarder
		clientY = handleOffset + bar.offset().top + handleSize / 2;
	}
	// Nouvelle position pour la poignée
	handle.css('top', handleOffset + 'px');
	// Nouvelle valeur sauvegardée pour accélérer le prochain évènement
	this.components.vscroll.data('position', clientY);
	// Nouvelle valeur de scrollTop pour les tables left/center/right
	this.components.middle.children().filter(function() { return this !== source; }).scrollTop(scrollTop);
	return true;
};

/**
 * Cette méthode est appelée pour positionner la grille horizontalement :
 * - soit grâce à "scrollLeft" quand l'appel vient d'un évènement "scroll"
 * - soit grâce à "clientX" quand on manipule l'ascenseur
 * Le décalage est appliqué aux div (*>center) et enregistré dans l'ascenseur horizontal (hscroll).
 *
 * @param {number} clientX - la position de la souris quand on manipule l'ascenseur horizontal
 * @param {number} scrollLeft - le décalage horizontal à appliquer quand c'est un évènement "scroll"
 * @param {DOMElement} source - le div qui a lancé un évènement "scroll" ou null si ça vient d'ailleurs
 * @return true si le décalage a effectivement changé
 */
BIReportGrid.prototype.internalUpdateScrollLeft = function(clientX, scrollLeft, source) {
	// On regarde le dernier "clientX" sauvegardé pour voir s'il y a vraiment quelque chose à faire
	var v = this.components.hscroll.data('position') || 0;
	if (clientX === v)
		return false;
	// Pour calculer la position, on a besoin de la table, de la barre et de la poignée, avec leur taille
	var maxScroll = this.centerWidth - this.hscrollWidth + this.leftWidth + this.rightWidth;
	var bar = this.components.hscroll.children('div');
	var barSize = bar.width();
	var handle = bar.children();
	var handleSize = handle.width();
	var handleOffset;
	if (clientX !== null) {
		// On déduit la position de la poignée à partir de clientX
		handleOffset = clientX - bar.offset().left - handleSize / 2;
		// On ajuste la valeur de "handleOffset" en fonction des contraintes
		handleOffset = Math.max(0, Math.min(barSize - handleSize, handleOffset));
		// On déduit la valeur de "scrollLeft" associée
		scrollLeft = maxScroll * handleOffset / (barSize - handleSize);
	} else {
		// On ajuste la valeur de "scrollLeft" en fonction du scroll possible
		scrollLeft = Math.max(0, Math.min(scrollLeft, maxScroll));
		// On en déduit la position de la poignée
		handleOffset = scrollLeft * (barSize - handleSize) / maxScroll;
		// Puis la valeur à sauvegarder
		clientX = handleOffset + bar.offset().left + handleSize / 2;
	}
	// Nouvelle position pour la poignée
	handle.css('left', handleOffset + 'px');
	// Nouvelle valeur sauvegardée pour accélérer le prochain évènement
	this.components.hscroll.data('position', clientX);
	// Nouvelle valeur de scrollLeft pour les tables top/middle/bottom
	this.components.center.filter(function() { return this !== source; }).scrollLeft(scrollLeft);
	return true;
};

/**
 * Cette méthode dessine les en-tête de mesure quand celles-ci sont affichées en colonnes
 *
 * @param {BIReportNode} reportCol - la colonne du rapport (ou null pour les totaux)
 * @param {number} reportColIndex - l'index de la colonne dans l'axe (ou -1 pour les totaux)
 * @param {boolean} isMeasureSort - indique si le tri éventuel sur mesure est fait sur ce noeud
 * @param {DOM} measureTableRow - le "tr" contenant les libellés de mesures (si aucun groupe ou si la mesure est dans un groupe)
 * @param {DOM} groupTableRow - le "tr" contenant les libellés des groupes ou des mesures hors groupe
 * @param {Number} le nombre de mesure pour cette colonne (1 <= N <= visibleMeasures.length)
 */
BIReportGrid.prototype.internalDrawMeasureHeadersOnCol = function(reportCol, reportColIndex, isMeasureSort, measureTableRow, groupTableRow) {
	// Récupération des mesures et des groupes de mesures du noeud
	var measures, groups, measureIndex = 0, groupIndex = 0;
	if (reportCol == null) {
		measures = this.view.visibleMeasures;
		groups = this.view.measureGroups;
	} else {
		measures = this.getMeasuresForDepth(reportCol.depth);
		groups = this.getMeasureGroupsForDepth(reportCol.depth);
	}
	// Parcours des mesures
	var td, group, measure;
	while (measureIndex < measures.length) {
		// Si on commence un groupe
		if (groupIndex < groups.length && measureIndex === groups[groupIndex].firstMeasureIndex) {
			group = groups[groupIndex];
			td = BI.buildElement('td')
				.attr('class', 'bbm-report-measure-group')
				.attr('title', group.caption)
				.data('group', group.originalGroup || group)
				.append(BI.buildElement('span').text(group.caption))
				.appendTo(groupTableRow);
			if (group.lastMeasureIndex > group.firstMeasureIndex)
				td.attr('colspan', (group.lastMeasureIndex - group.firstMeasureIndex + 1));
			while (measureIndex <= group.lastMeasureIndex) {
				measure = measures[measureIndex];
				td = BI.buildElement('td')
					.attr('class', 'bbm-report-measure')
					.attr('data-cell-type', 'measure')
					.attr('title', measure.description || measure.caption)
					.data('measure', measure)
					.data('nodeIndex', reportColIndex)
					.append(BI.buildElement('span').text(measure.caption))
					.appendTo(measureTableRow);
				this.internalDrawMeasureSortIndicator(td, isMeasureSort, measure);
				// La dernière mesure du dernier groupe est ':last-child' si elle n'est suivie que de mesures hors-groupe
				// Du coup, elle n'a pas de bord à droite alors qu'il lui en faudrait un. Le plus simple est de forcer le bord avec une classe CSS
				if ((groupIndex === groups.length - 1) && (measureIndex === group.lastMeasureIndex) && (measureIndex < measures.length - 1))
					td.attr('class', 'bbm-report-measure bbm-report-force-right-border');
				if (reportCol == null)
					this.internalActivateResize(td.toJQUERY());
				measureIndex++;
			}
			groupIndex++;
		} else {
			measure = measures[measureIndex];
			td = BI.buildElement('td')
				.attr('class', 'bbm-report-measure')
				.attr('data-cell-type', 'measure')
				.attr('title', measure.description || measure.caption)
				.data('measure', measure)
				.data('nodeIndex', reportColIndex)
				.append(BI.buildElement('span').text(measure.caption));
			this.internalDrawMeasureSortIndicator(td, isMeasureSort, measure);
			if (reportCol == null)
				this.internalActivateResize(td.toJQUERY());
			if (!!groupTableRow)
				td.attr('rowspan', '2').appendTo(groupTableRow);
			else
				td.appendTo(measureTableRow);
			measureIndex++;
		}
	}
	return measures.length;
};

/**
 * Cette méthode dessine les en-tête de mesure quand celles-ci sont affichées en lignes.
 * La première mesure sera affichée sur la ligne fournie et d'autres lignes seront ajoutées pour les mesures suivantes.
 * Le nombre de ligne utilisée sera retournée et correspondra donc aux nombres de mesures pour une ligne de ce niveau.
 *
 * @param {BIReportNode} reportRow - la ligne du rapport (ou null pour les totaux)
 * @param {number} reportRowIndex - l'index de la ligne dans l'axe (ou -1 pour les totaux)
 * @param {boolean} isMeasureSort - indique si le tri éventuel sur mesure est fait sur ce noeud
 * @param {DOM} tableRow - le "tr" créé pour cette ligne
 * @param {DOM} tableRowParent - le "tbody" ou "tfoot" parent de "tableRow"
 * @param {Number} le nombre de mesure pour cette ligne (1 <= N <= visibleMeasures.length)
 */
BIReportGrid.prototype.internalDrawMeasureHeadersOnRow = function(reportRow, reportRowIndex, isMeasureSort, tableRow, tableRowParent) {
	// Récupération des mesures et des groupes de mesures du noeud
	var isGroup, measures, groups, measureIndex = 0, groupIndex = 0;
	if (reportRow == null) {
		isGroup = true;
		measures = this.view.visibleMeasures;
		groups = this.view.measureGroups;
	} else {
		isGroup = reportRow.depth < this.view.calculatedRowAxeDepth;
		measures = this.getMeasuresForDepth(reportRow.depth);
		groups = this.getMeasureGroupsForDepth(reportRow.depth);
	}
	// Si on a au moins un groupe, les cellules font par défaut 2 colonnes de span, sauf au sein d'un groupe
	var colspan = (this.view.measureGroups.length > 0) ? 2 : 1;
	// Parcours des mesures
	var tr, td, group, measure;
	while (measureIndex < measures.length) {
		if (measureIndex === 0) {
			tr = tableRow;
		} else {
			tr = BI.buildElement('tr').appendTo(tableRowParent);
			tr.toJQUERY().toggleClass('bbm-report-group', isGroup);
		}

		// Si on commence un groupe
		if (groupIndex < groups.length && measureIndex === groups[groupIndex].firstMeasureIndex) {
			group = groups[groupIndex];
			td = BI.buildElement('td')
				.attr('class', 'bbm-report-measure-group')
				.attr('title', group.caption)
				.data('group', group.originalGroup || group)
				.append(BI.buildElement('span').text(group.caption))
				.appendTo(tr);
			if (group.lastMeasureIndex > group.firstMeasureIndex)
				td.attr('rowspan', (group.lastMeasureIndex - group.firstMeasureIndex + 1));
			// Pendant le parcours d'un groupe, les cellules ne font qu'une colonne de colspan
			colspan = 1;
		}

		// En-tête de mesure
		measure = measures[measureIndex];
		td = BI.buildElement('td')
			.attr('class', 'bbm-report-measure')
			.attr('data-cell-type', 'measure')
			.attr('title', measure.description || measure.caption)
			.data('measure', measure)
			.data('nodeIndex', reportRowIndex)
			.append(BI.buildElement('span').text(measure.caption))
			.appendTo(tr);
		this.internalDrawMeasureSortIndicator(td, isMeasureSort, measure);
		if (colspan === 2)
			td.attr('colspan', '2');
		measureIndex++;

		// Si on finit un groupe
		if (groupIndex < groups.length && measureIndex === groups[groupIndex].lastMeasureIndex) {
			// On passe au suivant
			groupIndex++;
			// Et les cellules des mesures repassent en colspan="2"
			colspan = 2;
		}
	}
	return measures.length;
};

/**
 * Cette méthode dessine dans "td" un indicateur de tri sur mesure si c'est le bon noeud ("isMeasureSort") et la bonne mesure ("measure")
 *
 * @param {DOM} td - la cellule contenant l'en-tête de mesure
 * @param {boolean} isMeasureSort - procalculé en amont, indique si le noeud en cours est celui du tri sur mesure
 * @param {BIReportMeasure} measure - la mesure dont on vient de générer l'en-tête, à comparer avec la mesure du tri
 */
BIReportGrid.prototype.internalDrawMeasureSortIndicator = function(td, isMeasureSort, measure) {
	if (isMeasureSort && measure.name === this.view.sortMeasureName) {
		var i = this.view.sortMeasureAscending ? BI.options.templateSortAscending : BI.options.templateSortDescending;
		td.toDOM().insertBefore(i.cloneNode(true), td.toDOM().childNodes[0]);
	}
};

/**
 * Cette méthode ajoute une cellule "td" à la ligne "tr", affichant la valeur de la mesure "measure" pour la celulle du rapport "cell"
 *
 * @param {DOM} tr la ligne dans laquelle ajouter une case
 * @param {Object} cell le tableau des valeurs pour la cellule du rapport
 * @param {BIReportMeasure} measure la mesure dont on souhaite afficher la valeur
 */
BIReportGrid.prototype.internalDrawMeasureValue = function(tr, cell, measure) {
	var td = BI.buildElement('td');
	var value = cell[measure.name];
	try {
		// Valeur
		var text = value ? measure.type.formatCellNotEmpty(value, this.lang, measure.decimals, measure.format) : '';
		if (text && measure.type.formatCellWithHTML)
			td.html(text);
		else
			td.text(text);
		// Alignement
		// - par défaut, le CSS calle les mesures à droite car la majorité sont des nombres
		// - pour les textes et les booléens, l'alignement est respectivement gauche et centre
		if (measure.type.align !== 'right')
			td.css('text-align', measure.type.align);
		// Couleur et couleur de texte
		var measureHighlight = BIReportView.getMeasureHighlight(measure, value);
		if (!!measureHighlight) {
			// Couleur
			var color = measureHighlight.color;
			if (!!color)
				td.css('backgroundColor', color);
			// Couleur de texte
			var fontColor = measureHighlight.fontColor;
			if (!!fontColor)
				td.css('color', fontColor);
		}
	} catch (ex) {
		td.text('erreur').attr('title', ex.message);
	}
	td.appendTo(tr);
};

/**
 * Cette méthode génère une cellule affichant "TOTAUX", avec les colspan et rowspan adaptés,
 * en fonctions du nombre de mesures, de niveaux et de la position des mesures (lignes ou colonnes).
 *
 * @param {Number} colspan identique à l'attribut colspan de HTML
 * @param {Number} rowspan identique à l'attribut rowspan de HTML
 */
BIReportGrid.prototype.internalBuildTotalCell = function(colspan, rowspan) {
	return BI.buildElement('td')
		.text(this.lang.totals)
		.colspan(colspan)
		.rowspan(rowspan);
};

/** La cellule d'en-tête d'une ligne ou d'une colonne, avec icône et intitulé */
BIReportGrid.prototype.internalBuildNodeCell = function(node, nodeIndex, axe) {
	return BI.buildElement('td')
		.addClass('bbm-report-node')
		.data('nodeIndex', nodeIndex)
		.append(this.internalGetNodeIcon(node, axe))
		.append(this.internalGetNodeCaption(node, axe.levels[node.depth]));
};

/** L'intitulé d'une ligne ou d'une colonne, activant éventuellement le menu d'actions */
BIReportGrid.prototype.internalGetNodeCaption = function(node, level) {
	return BI.buildElement('span')
		.text(this.view.formatLevelCell(node, this.lang, level))
		.toggleClass('bbm-report-node-with-actions', this.view.hasNodeActions(node, level));
};

/** L'icône d'une ligne ou d'une colonne et fonction de son état déployable / déployé */
BIReportGrid.prototype.internalGetNodeIcon = function(node, axe) {
	// Pour le dernier niveau, aucun noeud n'est déployable donc pas besoin d'espace vide
	if (node.depth === axe.levels.length - 1)
		return '';
	// Icone "-", "+" ou vide selon que le noeud soit déployé, déployable ou vide
	if (node.expanded)
		return BI.options.templateExpanded.cloneNode(true);
	if (node.expandable)
		return BI.options.templateCollapsed.cloneNode(true);
	return BI.options.templateLeaf.cloneNode(true);
};

/** Cette méthode définit la largeur des colonnes de la partie gauche en générant une ligne "invisble" contenant des cellules de largeur définie */
BIReportGrid.prototype.internalBuildLeftLayoutRow = function() {
	var self = this;
	var layoutRow = BI.layoutRow();
	self.view.rowAxe.levels.slice(0, self.view.calculatedRowAxeDepth + 1).forEach(function(level, _levelIndex) {
		level.visibleAttributeIndex.forEach(function(index) {
			layoutRow.add(self.view.getAttributeWidth(level.attributes[index]));
		});
		layoutRow.add(self.view.getLevelWidth(level));
	});
	// Si les mesures sont en lignes, on affiche :
	// - 1 colonne éventuelle pour le libellé des groupes
	// - 1 colonne pour le libellé des mesures
	if (! self.view.measureOnCols) {
		if (self.view.measureGroups.length > 0)
			layoutRow.add(self.view.getMeasureGroupsWidth());
		layoutRow.add(self.view.getMeasureNamesWidth());
	}
	// Si les mesures sont en colonnes, qu'il n'y a aucun niveau en ligne, on ajoute une colonne
	// - pour afficher le nom des niveaux en colonnes
	// - pour afficher l'en-tête "Mesures" en en-tête de la ligne des mesures
	if (self.view.measureOnCols && self.view.rowAxe.levels.length === 0) {
		layoutRow.add(100);
	}
	this.leftWidth = layoutRow.width + 1;
	return layoutRow.tr;
};

/** Cette méthode définit la largeur des colonnes de la partie centrale en générant une ligne "invisble" contenant des cellules de largeur définie */
BIReportGrid.prototype.internalBuildCenterLayoutRow = function() {
	var self = this;
	var layoutRow = BI.layoutRow();
	if (self.view.measureOnCols) {
		self.view.forEachCol(function(col, _colIndex, _colIsGroup) {
			self.forEachMeasure(col, function(measure) {
				layoutRow.add(self.view.getMeasureWidth(measure)).data('measure', measure);
			});
		});
	} else {
		var count = self.view.colAxe.size + (self.view.hasFixTotalCol() ? 0 : 1);
		for (var i = 0; i < count; i++) {
			layoutRow.add(self.view.getMeasureValuesWidth());
		}
	}
	this.centerWidth = layoutRow.width;
	return layoutRow.tr;
};

/** Cette méthode définit la largeur des colonnes de la partie droite (par défaut) en générant une ligne "invisble" contenant des cellules de largeur définie */
BIReportGrid.prototype.internalBuildRightLayoutRow = function() {
	var self = this;
	var layoutRow = BI.layoutRow();
	if (self.view.measureOnCols) {
		self.view.visibleMeasures.forEach(function(measure) {
			layoutRow.add(self.view.getMeasureWidth(measure)).data('measure', measure);
		});
	} else {
		layoutRow.add(self.view.getMeasureValuesWidth());
	}
	this.rightWidth = layoutRow.width + 1;
	return layoutRow.tr;
};

/** Cette méthode redessine tout le contenu de la grille (les 3x3=9 zones) et ajuste les classes CSS ou la visibilité des totaux en fonction de la vue */
BIReportGrid.prototype.internalUpdateGrid = function() {
	this.target.toggleClass('bbm-report-with-measures-on-rows', ! this.view.measureOnCols);
	this.target.toggleClass('bbm-report-invert-col-axe-totals', this.view.hasInvertedTotalCol());
	this.target.toggleClass('bbm-report-invert-row-axe-totals', this.view.hasInvertedTotalRow());
	this.components.bottom.toggle(this.view.hasFixTotalRow());
	this.components.right.toggle(this.view.hasFixTotalCol());

	this.internalUpdateTopLeft();
	this.internalUpdateTopCenter();
	this.internalUpdateTopRight();
	this.internalUpdateMiddleLeft();
	this.internalUpdateMiddleCenter();
	this.internalUpdateMiddleRight();
	this.internalUpdateBottomLeft();
	this.internalUpdateBottomCenter();
	this.internalUpdateBottomRight();
};

/** La partie fixe en haut à gauche, affichant le nom des niveaux généralement, des attributs éventuellement et , selon la configuration, les en-têtes 'Mesures' et 'Groupes' */
BIReportGrid.prototype.internalUpdateTopLeft = function() {
	var self = this;
	// Vider la table
	var parent = self.components.top.find('>.bbm-report-left>table>thead').empty()[0];
	// Ajouter une ligne définissant les colonnes avec leur largeur
	var layoutRow = self.internalBuildLeftLayoutRow().appendTo(parent);
	// Récupérer le nombre de colonnes que ça représente pour faciliter les calculs de "colspan" pour la suite
	var colCount = layoutRow.toDOM().childElementCount;
	// Afficher les niveaux en colonnes
	var td;
	self.view.colAxe.levels.slice(0, self.view.calculatedColAxeDepth + 1).forEach(function(level) {
		td = BI.buildElement('td')
			.attr('class', 'bbm-report-level')
			.attr('data-cell-type', 'colLevel')
			.attr('title', level.caption)
			.data('level', level)
			.append(BI.buildElement('span').text(level.caption));
		if (colCount > 1)
			td.attr('colspan', colCount);
		BI.buildElement('tr').append(td).appendTo(parent);
	});
	// Afficher les niveaux en lignes avec leur(s) attribut(s)
	var headerRow = BI.buildElement('tr').appendTo(parent);
	// Vérifier si les en-têtes doivent être sur 2 lignes (= si les mesures sont en colonnes et qu'il y a un groupe)
	var doubleHeaderRow = (self.view.measureOnCols && self.view.measureGroups.length > 0) ? BI.buildElement('tr').appendTo(parent) : null;
	self.view.rowAxe.levels.slice(0, self.view.calculatedRowAxeDepth + 1).forEach(function(level, _levelIndex) {
		level.visibleAttributeIndex.forEach(function(index) {
			td = BI.buildElement('td')
				.attr('class', 'bbm-report-attribute')
				.attr('data-cell-type', 'attribute')
				.attr('title', level.attributes[index].caption)
				.data('level', level)
				.data('attribute', level.attributes[index])
				.append(BI.buildElement('span').text(level.attributes[index].caption))
				.appendTo(headerRow);
			self.internalActivateResize(td.toJQUERY());
			if (!!doubleHeaderRow)
				td.attr('rowspan', '2');
		});
		td = BI.buildElement('td')
			.attr('class', 'bbm-report-level')
			.attr('data-cell-type', 'rowLevel')
			.attr('title', level.caption)
			.data('level', level)
			.append(BI.buildElement('span').text(level.caption))
			.appendTo(headerRow);
		self.internalActivateResize(td.toJQUERY());
		if (!!doubleHeaderRow)
			td.attr('rowspan', '2');
	});
	// Afficher éventuellement les en-têtes de colonnes contenant les groupes et les mesures
	if (self.view.measureOnCols) {
		if (self.view.rowAxe.levels.length === 0) {
			td = BI.buildElement('td')
				.text(self.lang.measureNamesHeader)
				.appendTo(headerRow);
			if (!!doubleHeaderRow)
				td.attr('rowspan', '2');
		}
	} else {
		// L'en-tête de colonne des groupes, redimensionnable
		if (self.view.measureGroups.length > 0) {
			td = BI.buildElement('td')
				.attr('data-cell-type', 'measureGroups')
				.text(self.lang.measureGroupsHeader)
				.appendTo(headerRow);
			self.internalActivateResize(td.toJQUERY());
		}
		// L'en-tête de colonne des mesures, redimensionnable aussi
		td = BI.buildElement('td')
			.attr('data-cell-type', 'measureNames')
			.text(self.lang.measureNamesHeader)
			.appendTo(headerRow);
		self.internalActivateResize(td.toJQUERY());
	}
	// Recalculer la hauteur de l'en-tête
	self.topHeight = parent.offsetHeight + 1;
};

/** La partie fixe en haut mais pouvant scroller horizontalement, affichant les en-têtes de colonnes (et les totaux s'ils ne sont pas figés) */
BIReportGrid.prototype.internalUpdateTopCenter = function() {
	var self = this;
	var parent = self.components.top.find('>.bbm-report-center>table>thead').empty()[0];
	self.centerWidth = 0;
	if (!self.view.hasFloatingCols())
		return;
	self.internalBuildCenterLayoutRow().appendTo(parent);
	var levels = self.view.colAxe.levels.slice(0, self.view.calculatedColAxeDepth + 1);
	var levelRows = levels.map(function(_level) { return BI.buildElement('tr').appendTo(parent); });
	if (self.view.measureOnCols) {
		// Création d'une ligne pour les mesures et, si besoin, d'une ligne pour les libellés de groupes
		var groupRow = self.view.measureGroups.length > 0 ? BI.buildElement('tr').appendTo(parent) : null;
		var measureRow = BI.buildElement('tr').appendTo(parent);
		// On récupère d'abord l'index du noeud sur lequel il y aurait un tri sur mesure
		var measureSortColIndex = self.view.findColIndex(self.view.sortMeasurePath);
		// Parcours des colonnes, y compris les totaux s'ils ne sont pas fixes
		self.view.forEachCol(function(col, colIndex, _colIsGroup) {
			// En-têtes de mesures pour le noeud
			var measureCount = self.internalDrawMeasureHeadersOnCol(col, colIndex, colIndex === measureSortColIndex, measureRow, groupRow);
			if (col != null) {
				// On ajoute si besoin une cellule vide au dessus pour marquer la profondeur
				if (col.depth > 0)
					BI.buildElement('td')
						.rowspan(col.depth)
						.colspan(measureCount)
						.appendTo(levelRows[0]);
				// On ajoute le libellé du noeud
				self.internalBuildNodeCell(col, colIndex, self.view.colAxe)
					.rowspan(levels.length - col.depth)
					.colspan(measureCount)
					.appendTo(levelRows[col.depth]);
			} else {
				// En-tête "TOTAUX" pour les totaux par ligne si au moins un niveau en colonne
				if (levelRows.length > 0)
					self.internalBuildTotalCell(measureCount, levelRows.length).appendTo(levelRows[0]);
			}
		});
	} else {
		// On ajoute une ligne vide qui sera utilisée par agrandir le "rowspan" du libellé du noeud
		BI.buildElement('tr').appendTo(parent);
		// Parcours des colonnes, y compris les totaux s'ils ne sont pas fixes
		self.view.forEachCol(function(col, colIndex, _colIsGroup) {
			if (col == null) {
				// TOTAUX
				var td = self.internalBuildTotalCell(1, levelRows.length + 1)
					.attr('data-cell-type', 'measureValues')
					.appendTo(parent.childNodes[1]);
				self.internalActivateResize(td.toJQUERY());
			} else {
				// On ajoute si besoin une cellule vide au dessus pour marquer la profondeur
				if (col.depth > 0)
					BI.buildElement('td').rowspan(col.depth).appendTo(levelRows[0]);
				// On ajoute le libellé du noeud
				self.internalBuildNodeCell(col, colIndex, self.view.colAxe)
					.rowspan(levels.length + 1 - col.depth)
					.appendTo(levelRows[col.depth]);
			}
		});
	}
};

/** La partie fixe en haut à droite (par défaut) ou à gauche (si demandé) affichant les en-têtes de totaux s'ils sont figés et non masqués */
BIReportGrid.prototype.internalUpdateTopRight = function() {
	var self = this;
	var parent = self.components.top.find('>.bbm-report-right>table>thead').empty()[0];
	if (!self.view.hasFixTotalCol())
		return;
	var parentFragment = document.createDocumentFragment();
	self.internalBuildRightLayoutRow().appendTo(parentFragment);
	var levels = self.view.colAxe.levels.slice(0, self.view.calculatedColAxeDepth + 1);
	var levelRows = levels.map(function(_level) { return BI.buildElement('tr').appendTo(parentFragment); });
	if (self.view.measureOnCols) {
		// Création d'une ligne pour les mesures et, si besoin, d'une ligne pour les libellés de groupes
		var groupRow = self.view.measureGroups.length > 0 ? BI.buildElement('tr').appendTo(parentFragment) : null;
		var measureRow = BI.buildElement('tr').appendTo(parentFragment);
		// En-têtes de mesures pour les totaux (node = null)
		var measureCount = self.internalDrawMeasureHeadersOnCol(null, -1, self.view.sortMeasurePath.length === 0, measureRow, groupRow);
		// En-tête "TOTAUX" pour les totaux par ligne si au moins un niveau en colonne
		if (levelRows.length > 0)
			self.internalBuildTotalCell(measureCount, levelRows.length).appendTo(levelRows[0]);
	} else {
		// On ajoute une ligne vide qui sera utilisée par agrandir le "rowspan" de la cellule des totaux
		BI.buildElement('tr').appendTo(parentFragment);
		// TOTAUX
		var td = self.internalBuildTotalCell(1, levelRows.length + 1)
			.attr('data-cell-type', 'measureValues')
			.appendTo(parentFragment.childNodes[1]);
		self.internalActivateResize(td.toJQUERY());
	}
	parent.appendChild(parentFragment);
};

/** La partie fixe à gauche mais pouvant scroller verticalement, affichant les en-têtes de lignes (et les totaux s'ils ne sont pas figés) */
BIReportGrid.prototype.internalUpdateMiddleLeft = function() {
	var self = this;
	var parent = self.components.middle.find('>.bbm-report-left>table>tbody').empty()[0];
	self.middleHeight = 0;
	if (!self.view.hasFloatingRows())
		return;
	var parentFragment = document.createDocumentFragment();
	var layoutRow = self.internalBuildLeftLayoutRow().appendTo(parentFragment);
	var colCount = layoutRow.toDOM().childElementCount;
	var rowCount = 0;
	if (self.view.measureOnCols) {
		// On parcourt les lignes
		self.view.forEachRow(function(row, rowIndex, rowIsGroup) {
			// Génération du noeud
			var tr = BI.buildElement('tr');
			if (rowIsGroup)
				tr.attr('class', 'bbm-report-group');
			if (row == null) {
				self.internalBuildTotalCell(colCount, 1).appendTo(tr);
			} else {
				// Ajouter une cellule vide avant le noeud si celui-ci n'est pas un noeud racine
				var spanBefore = 0;
				for (var levelIndex = 0; levelIndex < row.depth; levelIndex++) {
					spanBefore = spanBefore + 1 + self.view.rowAxe.levels[levelIndex].visibleAttributeIndex.length;
				}
				if (spanBefore)
					BI.buildElement('td').attr('colspan', spanBefore).appendTo(tr);

				// Ajouter ensuite les attributs du noeud
				var level = self.view.rowAxe.levels[row.depth];
				for (var i = 0; i < level.visibleAttributeIndex.length; i++) {
					var attribute = level.attributes[level.visibleAttributeIndex[i]];
					var td = BI.buildElement('td');
					self.view.formatAttributeCell(row, self.lang, attribute, td);
					td.appendTo(tr);
				}
				// Ajouter ensuite l'intitulé et l'icone du noeud
				self.internalBuildNodeCell(row, rowIndex, self.view.rowAxe)
					.colspan(colCount - spanBefore - level.visibleAttributeIndex.length)
					.appendTo(tr);
			}
			tr.appendTo(parentFragment);
			rowCount++;
		});
	} else {
		// On retire 1 ou 2 colonnes de span pour les noeuds quand les mesures sont en ligne
		colCount--;
		if (self.view.measureGroups.length > 0)
			colCount--;
		// On récupère d'abord l'index du noeud sur lequel il y aurait un tri sur mesure
		var measureSortRowIndex = self.view.findRowIndex(self.view.sortMeasurePath);
		// On parcourt ensuite toutes les lignes
		self.view.forEachRow(function(row, rowIndex, rowIsGroup) {
			// Génération du noeud
			var tr = BI.buildElement('tr');
			if (rowIsGroup)
				tr.attr('class', 'bbm-report-group');
			if (row == null) {
				// En-tête "TOTAUX" pour les totaux par colonne si au moins un niveau en ligne
				if (self.view.rowAxe.levels.length > 0)
					self.internalBuildTotalCell(colCount, 1).appendTo(tr);// rowspan par défaut, remplacé après internalDrawMeasureHeadersOnRow
			} else {
				// Ajouter une cellule vide avant le noeud si celui-ci n'est pas un noeud racine
				var spanBefore = 0;
				for (var levelIndex = 0; levelIndex < row.depth; levelIndex++) {
					spanBefore = spanBefore + 1 + self.view.rowAxe.levels[levelIndex].visibleAttributeIndex.length;
				}
				if (spanBefore)
					BI.buildElement('td').attr('colspan', spanBefore).appendTo(tr);

				// Ajouter ensuite les attributs du noeud
				var level = self.view.rowAxe.levels[row.depth];
				for (var i = 0; i < level.visibleAttributeIndex.length; i++) {
					var attribute = level.attributes[level.visibleAttributeIndex[i]];
					var td = BI.buildElement('td');
					self.view.formatAttributeCell(row, self.lang, attribute, td);
					td.appendTo(tr);
				}
				// Ajouter ensuite l'intitulé et l'icone du noeud
				self.internalBuildNodeCell(row, rowIndex, self.view.rowAxe)
					.colspan(colCount - spanBefore - level.visibleAttributeIndex.length)
					.appendTo(tr);
			}
			tr.appendTo(parentFragment);
			var tds = tr.toJQUERY().children();
			// Afficher les mesures, une par ligne, et récupérer le nombre de lignes générées
			var count = self.internalDrawMeasureHeadersOnRow(row, rowIndex, rowIndex === measureSortRowIndex, tr, parentFragment);
			// Si besoin, ajuster "rowspan" sur les cellules en début de lignes (espaces + libellé + attributs
			if (count > 1)
				tds.attr('rowspan', count);
			rowCount += count;
		});
	}
	parent.appendChild(parentFragment);
	// Recalculer la hauteur de l'en-tête
	self.middleHeight = rowCount * 32;
};

/** La partie centrale, pouvant scroller dans les 2 sens, affichant les mesures des cellules (et de certains totaux si non figés) */
BIReportGrid.prototype.internalUpdateMiddleCenter = function() {
	var self = this;
	var parent = self.components.middle.find('>.bbm-report-center>table>tbody').empty()[0];
	if (!self.view.hasFloatingRows() || !self.view.hasFloatingCols())
		return;
	var parentFragment = document.createDocumentFragment();
	self.internalBuildCenterLayoutRow().appendTo(parentFragment);
	if (self.view.measureOnCols) {
		self.view.forEachRow(function(row, rowIndex, rowIsGroup) {
			var tr = BI.buildElement('tr');
			if (rowIsGroup)
				tr.attr('class', 'bbm-report-group');
			self.view.forEachCol(function(col, colIndex, _colIsGroup) {
				var cell = self.view.getCell(row, rowIndex, col, colIndex);
				self.forEachMeasure(col, function(measure) {
					self.internalDrawMeasureValue(tr, cell, measure);
				});
			});
			tr.appendTo(parentFragment);
		});
	} else {
		self.view.forEachRow(function(row, rowIndex, rowIsGroup) {
			self.forEachMeasure(row, function(measure) {
				var tr = BI.buildElement('tr');
				if (rowIsGroup)
					tr.attr('class', 'bbm-report-group');
				self.view.forEachCol(function(col, colIndex, _colIsGroup) {
					var cell = self.view.getCell(row, rowIndex, col, colIndex);
					self.internalDrawMeasureValue(tr, cell, measure);
				});
				tr.appendTo(parentFragment);
			});
		});
	}
	parent.appendChild(parentFragment);
};

/** La partie fixe à droite (par défaut) ou à gauche (si demandé), pouvant scroller verticalement et affichant les totaux par ligne */
BIReportGrid.prototype.internalUpdateMiddleRight = function() {
	var self = this;
	var parent = self.components.middle.find('>.bbm-report-right>table>tbody').empty()[0];
	if (!self.view.hasFloatingRows() || !self.view.hasFixTotalCol())
		return;
	var parentFragment = document.createDocumentFragment();
	self.internalBuildRightLayoutRow().appendTo(parentFragment);
	if (self.view.measureOnCols) {
		self.view.forEachRow(function(row, _rowIndex, rowIsGroup) {
			var cell = row == null ? self.view.grandTotalCell : row.totalCell;
			var tr = BI.buildElement('tr');
			if (rowIsGroup)
				tr.attr('class', 'bbm-report-group');
			self.forEachMeasure(null, function(measure) {
				self.internalDrawMeasureValue(tr, cell, measure);
			});
			tr.appendTo(parentFragment);
		});
	} else {
		self.view.forEachRow(function(row, _rowIndex, rowIsGroup) {
			var cell = row == null ? self.view.grandTotalCell : row.totalCell;
			self.forEachMeasure(row, function(measure) {
				var tr = BI.buildElement('tr');
				if (rowIsGroup)
					tr.attr('class', 'bbm-report-group');
				self.internalDrawMeasureValue(tr, cell, measure);
				tr.appendTo(parentFragment);
			});
		});
	}
	parent.appendChild(parentFragment);
};

/** La partie fixe à gauche en bas (par défaut) ou en haut (si demandé) affichant les en-têtes de totaux s'ils sont figés et non masqués */
BIReportGrid.prototype.internalUpdateBottomLeft = function() {
	var self = this;
	var parent = self.components.bottom.find('>.bbm-report-left>table>tfoot').empty()[0];
	if (!self.view.hasFixTotalRow())
		return;
	var parentFragment = document.createDocumentFragment();
	var layoutRow = self.internalBuildLeftLayoutRow().appendTo(parentFragment);
	var colCount = layoutRow.toDOM().childElementCount;
	// On crée la première ligne (qui servira à la première measure et éventuellement au texte "TOTAUX")
	var tr = BI.buildElement('tr').appendTo(parentFragment);
	if (self.view.measureOnCols) {
		// C'est juste une cellule affichant "TOTAUX"
		self.internalBuildTotalCell(colCount, 1).appendTo(tr);
	} else {
		// Afficher les mesures, une par ligne, et récupérer le nombre de lignes générées
		var measureCount = self.internalDrawMeasureHeadersOnRow(null, -1, self.view.sortMeasurePath.length === 0, tr, parentFragment);
		// On ajuste le colspan du layout en retirant les colonnes des mesures [et des groupes]
		colCount = colCount - (self.view.measureGroups.length > 0 ? 2 : 1);
		// Si besoin, on affiche le texte "TOTAUX"
		if (colCount > 0)
			self.internalBuildTotalCell(colCount, measureCount).prependTo(tr);
	}
	parent.appendChild(parentFragment);
	// Recalculer la hauteur de l'en-tête
	self.bottomHeight = parent.offsetHeight + 1;
};

/** La partie fixe en bas (par défaut) ou en haut (si demandé), pouvant scroller horizontalement et affichant les totaux par ligne */
BIReportGrid.prototype.internalUpdateBottomCenter = function() {
	var self = this;
	var parent = self.components.bottom.find('>.bbm-report-center>table>tfoot').empty()[0];
	if (!self.view.hasFixTotalRow() || !self.view.hasFloatingCols())
		return;
	var parentFragment = document.createDocumentFragment();
	self.internalBuildCenterLayoutRow().appendTo(parentFragment);
	if (self.view.measureOnCols) {
		// Une seule ligne avec une mesure dans chaque colonne
		var tr = BI.buildElement('tr');
		self.view.forEachCol(function(col, _colIndex, _colIsGroup) {
			var cell = col == null ? self.view.grandTotalCell : col.totalCell;
			self.forEachMeasure(col, function(measure) {
				self.internalDrawMeasureValue(tr, cell, measure);
			});
		});
		tr.appendTo(parentFragment);
	} else {
		// Chaque mesure sur une ligne, avec une cellule par colonne
		self.forEachMeasure(null, function(measure) {
			var tr = BI.buildElement('tr');
			self.view.forEachCol(function(col, _colIndex, _colIsGroup) {
				var cell = col == null ? self.view.grandTotalCell : col.totalCell;
				self.internalDrawMeasureValue(tr, cell, measure);
			});
			tr.appendTo(parentFragment);
		});
	}
	parent.appendChild(parentFragment);
};

/** La partie fixe en bas à droite (par défaut mais paramétrable) affichant les grand-totaux, quand ils sont figés sur les 2 axes */
BIReportGrid.prototype.internalUpdateBottomRight = function() {
	var self = this;
	var parent = self.components.bottom.find('>.bbm-report-right>table>tfoot').empty()[0];
	if (!self.view.hasFixTotalRow() || !self.view.hasFixTotalCol())
		return;
	var cell = self.view.grandTotalCell;
	var parentFragment = document.createDocumentFragment();
	self.internalBuildRightLayoutRow().appendTo(parentFragment);
	if (self.view.measureOnCols) {
		// Une seule ligne avec une mesure dans chaque colonne
		var tr = BI.buildElement('tr');
		self.forEachMeasure(null, function(measure) {
			self.internalDrawMeasureValue(tr, cell, measure);
		});
		tr.appendTo(parentFragment);
	} else {
		// Chaque mesure sur une ligne, avec une seule cellule
		self.forEachMeasure(null, function(measure) {
			var tr = BI.buildElement('tr');
			self.internalDrawMeasureValue(tr, cell, measure);
			tr.appendTo(parentFragment);
		});
	}
	parent.appendChild(parentFragment);
};

/**
 * C'est un composant jQuery qui permet de configurer le rapport via un popin :
 * - onglet 1 : les options générales du rapport
 * - onglet 2 : les niveaux en lignes, en colonnes, en accès rapide ou filtrés
 * - onglet 2 : les mesures affichées, les groupes de mesures et les mesures en accès rapide
 */
function BIReportGridConfiguration(target, view) {
	this.view = view;
	this.lang = BI.langs[BI.options.lang];
	this.target = $(target).addClass('bbm-report-configuration').html(''
		+ '<ul class="nav nav-pills">'
		+ '  <li role="presentation" class="active"><a href="#">' + this.lang.configurationOptionsTab + '</a></li>'
		+ '  <li role="presentation"><a href="#">' + this.lang.configurationLevelsTab + '</a></li>'
		+ '  <li role="presentation"><a href="#">' + this.lang.configurationMeasuresTab + '</a></li>'
		+ '</ul>'
		+ '<div style="padding: 40px;">'
		+ '  <div class="form-group">'
		+ '    <label for="bi-options-caption">' + this.lang.configurationOptionCaption + '</label>'
		+ '    <input id="bi-options-caption" class="form-control" type="text" required maxlength="50" />'
		+ '  </div>'
		+ '  <div class="form-group">'
		+ '    <input id="bi-options-calculate" type="checkbox" />'
		+ '    <label for="bi-options-calculate">' + this.lang.configurationOptionCalculate + '</label>'
		+ '  </div>'
		+ '  <div class="form-group">'
		+ '    <input id="bi-options-calculateonlyvisiblemeasures" type="checkbox" />'
		+ '    <label for="bi-options-calculateonlyvisiblemeasures">' + this.lang.configurationOptionCalculateOnlyVisibleMeasures + '</label>'
		+ '  </div>'
		+ '  <div class="form-group">'
		+ '    <input id="bi-options-measureoncols" type="checkbox" />'
		+ '    <label for="bi-options-measureoncols">' + this.lang.configurationOptionMeasureOnCols + '</label>'
		+ '  </div>'
		+ '  <div class="form-group">'
		+ '    <input id="bi-options-hideempty" type="checkbox" />'
		+ '    <label for="bi-options-hideempty">' + this.lang.configurationOptionHideEmpty + '</label>'
		+ '  </div>'
		+ '  <div class="form-group">'
		+ '    <input id="bi-options-hideemptyusingvisiblemeasures" type="checkbox" />'
		+ '    <label for="bi-options-hideemptyusingvisiblemeasures">' + this.lang.configurationOptionHideEmptyUsingVisibleMeasures + '</label>'
		+ '  </div>'
		+ '  <div class="form-group">'
		+ '    <input id="bi-options-hidefixedmeasures" type="checkbox" />'
		+ '    <label for="bi-options-hidefixedmeasures">' + this.lang.configurationOptionHideFixedMeasures + '</label>'
		+ '  </div>'
		+ '  <div class="form-group">'
		+ '    <label for="bi-options-rowtotalsposition">' + this.lang.configurationOptionRowTotalsPosition + '</label>'
		+ '    <select id="bi-options-rowtotalsposition" class="form-control">'
		+ '      <option value="FixBefore">' + this.lang.rowTotalsPositions.FixBefore + '</option>'
		+ '      <option value="Before">' + this.lang.rowTotalsPositions.Before + '</option>'
		+ '      <option value="Hidden">' + this.lang.rowTotalsPositions.Hidden + '</option>'
		+ '      <option value="After">' + this.lang.rowTotalsPositions.After + '</option>'
		+ '      <option value="FixAfter">' + this.lang.rowTotalsPositions.FixAfter + '</option>'
		+ '    </select>'
		+ '  </div>'
		+ '  <div class="form-group">'
		+ '    <label for="bi-options-coltotalsposition">' + this.lang.configurationOptionColTotalsPosition + '</label>'
		+ '    <select id="bi-options-coltotalsposition" class="form-control">'
		+ '      <option value="FixBefore">' + this.lang.colTotalsPositions.FixBefore + '</option>'
		+ '      <option value="Before">' + this.lang.colTotalsPositions.Before + '</option>'
		+ '      <option value="Hidden">' + this.lang.colTotalsPositions.Hidden + '</option>'
		+ '      <option value="After">' + this.lang.colTotalsPositions.After + '</option>'
		+ '      <option value="FixAfter">' + this.lang.colTotalsPositions.FixAfter + '</option>'
		+ '    </select>'
		+ '  </div>'
		+ '</div>'
		+ '<div style="display: none;">'
		+ '  <h3>'
		+ '    <span>' + this.lang.configurationRowLevelsSection + '</span>'
		+ '    <button type="button" class="btn btn-link text-primary" data-type="levels" data-target="#bi-rowlevels" title="' + this.lang.configurationAddButton + '"><i class="material-icons">add</i></a>'
		+ '  </h3>'
		+ '  <ul id="bi-rowlevels" class="bbm-report-configuration-list">'
		+ '    <li>&nbsp;</li>'
		+ '  </ul>'

		+ '  <h3>'
		+ '    <span>' + this.lang.configurationColLevelsSection + '</span>'
		+ '    <button type="button" class="btn btn-link text-primary" data-type="levels" data-target="#bi-collevels" title="' + this.lang.configurationAddButton + '"><i class="material-icons">add</i></button>'
		+ '  </h3>'
		+ '  <ul id="bi-collevels" class="bbm-report-configuration-list">'
		+ '    <li>&nbsp;</li>'
		+ '  </ul>'

		+ '  <h3>'
		+ '    <span>' + this.lang.configurationExtraLevelsSection + '</span>'
		+ '    <button type="button" class="btn btn-link text-primary" data-type="levels" data-target="#bi-extralevels" title="' + this.lang.configurationAddButton + '"><i class="material-icons">add</i></button>'
		+ '  </h3>'
		+ '  <ul id="bi-extralevels" class="bbm-report-configuration-list">'
		+ '    <li>&nbsp;</li>'
		+ '  </ul>'

		+ '  <h3>'
		+ '    <span>' + this.lang.configurationFilteredLevelsSection + '</span>'
		+ '  </h3>'
		+ '  <div id="bi-filterlevels"></div>'
		+ '</div>'
		+ '<div style="display: none;">'
		+ '  <h3>'
		+ '    <span>' + this.lang.configurationVisibleMeasuresSection + '</span>'
		+ '    <button type="button" class="btn btn-link text-primary" data-type="measures" data-target="#bi-measures" title="' + this.lang.configurationAddButton + '"><i class="material-icons">add</i></button>'
		+ '    <button type="button" class="btn btn-link text-primary" data-type="measuregroup" title="' + this.lang.configurationAddGroupButton + '"><i class="material-icons">playlist_add</i></button>'
		+ '    <button type="button" class="btn btn-link text-primary" data-type="measurecalculation" title="' + this.lang.configurationAddCalculationButton + '"><i class="material-icons">plus_one</i></button>'
		+ '  </h3>'
		+ '  <ul id="bi-measures" class="bbm-report-configuration-list">'
		+ '    <li data-type="measure2">&nbsp;</li>'
		+ '  </ul>'

		+ '  <h3>'
		+ '    <span>' + this.lang.configurationExtraMeasuresSection + '</span>'
		+ '    <button type="button" class="btn btn-link text-primary" data-type="measures" data-target="#bi-extrameasures" title="' + this.lang.configurationAddButton + '"><i class="material-icons">add</i></button>'
		+ '  </h3>'
		+ '  <ul id="bi-extrameasures" class="bbm-report-configuration-list">'
		+ '    <li data-type="extraMeasure2">&nbsp;</li>'
		+ '  </ul>'
		+ '</div>'
	);

	this.internalUpdate();
	this.internalConnect();

	// Affichage du popin une fois que tout est prêt
	this.target.materialPopin({
		title: this.view.getPopinTitle(),
		closeButtonTitle: this.lang.configurationCloseButton,
		buttons : [{
			icon : 'done',
			visible : true,
			title: this.lang.configurationValidateButton,
			// Bloquer le popin tant que les modifications n'ont pas été appliquées
			// https://support.solvnet.fr:9998/devels/edit/2571
			onclickPromise : function validate() {
				var result = $.Deferred();
				this.internalValidate(function() {
					result.resolve();
				});
				return result;
			}.bind(this)
		}]
	});
}

BIReportGridConfiguration.prototype.internalCreateItem = function(item, type) {
	var li = $('<li />').data('item', item).attr('data-type', type)
		// Bouton pour retirer de la liste
		.append('<a class="remove" href="#" title="' + this.lang.configurationRemoveButton + '"><i class="material-icons material-icons-16">cancel</i></a>')
		// Bouton pour le popover
		.append('<a class="customize" href="#" title="' + this.lang.configurationCustomizeButton + '"><i class="material-icons material-icons-16">more_horiz</i></a>')
		// Libellé
		.append('<span class="caption"></span>');
	li.children('span').text(item.caption);
	return li;
};

BIReportGridConfiguration.prototype.internalCreateItems = function(selector, items, type) {
	this.target.find(selector).append(items.map(function(item) {
		return this.internalCreateItem(item, type)[0];
	}.bind(this)));
};

BIReportGridConfiguration.prototype.internalRemoveItem = function(liItems) {
	liItems.each(function() {
		// Récupération de la ligne à retirer
		var li = $(this);
		// Si la ligne est un groupe de mesure, retirer en même temps les mesures du groupe
		var isGroup = li.attr('data-type') === 'measureGroup2';
		if (isGroup) {
			while (li.next().hasClass('ingroup')) {
				li.next().remove();
			}
		}
		// Une fois fait, retirer la ligne elle-même
		li.remove();
	});
};

BIReportGridConfiguration.prototype.internalFindItems = function(item, containers) {
	return containers.children('li').filter(function() {
		return $(this).data('item') === item;
	});
};

/**
 * Cette méthode ajuste le contenu du popin en fonction de la vue en cours (options, niveaux, mesures...)
 *
 * @see voir "internalValidate" pour la sauvegarde dans l'autre sens.
 */
BIReportGridConfiguration.prototype.internalUpdate = function() {
	var self = this;
	this.target.find('#bi-options-caption').val(this.view.caption);
	this.target.find('#bi-options-calculate').prop('checked', this.view.calculate).materialCheckbox({});
	this.target.find('#bi-options-calculateonlyvisiblemeasures').prop('checked', this.view.calculateOnlyVisibleMeasures).materialCheckbox({});
	this.target.find('#bi-options-measureoncols').prop('checked', this.view.measureOnCols).materialCheckbox({});
	this.target.find('#bi-options-hideempty').prop('checked', this.view.rowAxe.hideEmpty).materialCheckbox({});
	this.target.find('#bi-options-hideemptyusingvisiblemeasures').prop('checked', this.view.rowAxe.hideEmptyUsingVisibleMeasures).materialCheckbox({});
	this.target.find('#bi-options-hidefixedmeasures').prop('checked', this.view.hideFixedMeasures).materialCheckbox({});
	this.target.find('#bi-options-rowtotalsposition').val(this.view.rowAxe.totalsPosition);
	this.target.find('#bi-options-coltotalsposition').val(this.view.colAxe.totalsPosition);
	this.internalCreateItems('#bi-rowlevels', this.view.rowAxe.levels, 'level2');
	this.internalCreateItems('#bi-collevels', this.view.colAxe.levels, 'level2');
	this.internalCreateItems('#bi-extralevels', this.view.extraLevels, 'level2');
	this.internalCreateItems('#bi-measures', this.view.visibleMeasures, 'measure2');
	this.internalCreateItems('#bi-extrameasures', this.view.extraMeasures, 'extraMeasure2');

	// Insérer les groupes de mesures et indenter les mesures à l'intérieur des groupes
	var measureItems = this.target.find('#bi-measures > li:not(:first-child)').get();
	this.view.measureGroups.forEach(function(group) {
		for (var i = group.firstMeasureIndex; i <= group.lastMeasureIndex; i++) {
			measureItems[i].className = 'ingroup';
		}
		this.internalCreateItem(group, 'measureGroup2').insertBefore(measureItems[group.firstMeasureIndex]);
	}.bind(this));

	// Afficher pour info la liste des niveaux avec filtres actifs
	var filteredLevels = [].concat(self.view.levels.filter(BI.isFilteredLevel)).sort(BI.compareCaption);
	var fragment = document.createDocumentFragment();
	filteredLevels.forEach(function(level, i) {
		if (i > 0)
			fragment.appendChild($('<span class="separator">, </span>').get(0));
		fragment.appendChild($('<span />').data('level', level).text(BI.getCaption(level)).get(0));
	});
	this.target.find('#bi-filterlevels').append(fragment);
};

/**
 * Cette méthode modifie la vue pour prendre en compte les options sélectionnées dans le popin (options, niveaux, mesures...).
 *
 * @see voir "internalUpdate" pour le chargement dans l'autre sens en amont.
 */
BIReportGridConfiguration.prototype.internalValidate = function(callback) {
	var self = this;

	// Récupérer les valeurs dans le formulaire
	var hideEmpty = this.target.find('#bi-options-hideempty').prop('checked');
	var hideEmptyUsingVisibleMeasures = this.target.find('#bi-options-hideemptyusingvisiblemeasures').prop('checked');
	this.view.caption = this.target.find('#bi-options-caption').val() || this.view.caption;
	this.view.calculate = this.target.find('#bi-options-calculate').prop('checked');
	this.view.calculateOnlyVisibleMeasures = this.target.find('#bi-options-calculateonlyvisiblemeasures').prop('checked');
	this.view.measureOnCols = this.target.find('#bi-options-measureoncols').prop('checked');
	this.view.rowAxe.hideEmpty = hideEmpty;
	this.view.colAxe.hideEmpty = hideEmpty;
	this.view.rowAxe.hideEmptyUsingVisibleMeasures = hideEmptyUsingVisibleMeasures;
	this.view.colAxe.hideEmptyUsingVisibleMeasures = hideEmptyUsingVisibleMeasures;
	this.view.hideFixedMeasures = this.target.find('#bi-options-hidefixedmeasures').prop('checked');
	this.view.rowAxe.totalsPosition = this.target.find('#bi-options-rowtotalsposition').val();
	this.view.colAxe.totalsPosition = this.target.find('#bi-options-coltotalsposition').val();

	// Récupérer les listes dans les 5 "ul"
	function getItems(selector, liSelector) {
		var lis = self.target.find(selector + ' > li:not(:first-child)');
		if (liSelector)
			lis = lis.filter(liSelector);
		return lis.get().map(function(li) { return $(li).data('item'); });
	}
	this.view.rowAxe.levels = getItems('#bi-rowlevels');
	this.view.colAxe.levels = getItems('#bi-collevels');
	this.view.extraLevels = getItems('#bi-extralevels');
	this.view.visibleMeasures = getItems('#bi-measures', '[data-type=measure2]');
	this.view.extraMeasures = getItems('#bi-extrameasures');

	// Récupérer les groupes de mesures
	this.view.measureGroups = [];
	var lis = self.target.find('#bi-measures > li:not(:first-child)').get();
	var liIndex = 0, measureIndex = 0;
	while (liIndex < lis.length) {
		var li = $(lis[liIndex]);
		var type = li.attr('data-type');
		if (type === 'measureGroup2') {
			var group = li.data('item');
			this.view.measureGroups.push(group);
			group.firstMeasureIndex = measureIndex;
			group.lastMeasureIndex = measureIndex - 1;
		} else {
			if (li.hasClass('ingroup'))
				this.view.measureGroups[this.view.measureGroups.length - 1].lastMeasureIndex++;
			measureIndex++;
		}
		liIndex++;
	}

	// Mettre à jour le reste en passant par le serveur
	this.view.execute({
		operations: ['configure', 'changeExtraLevels', 'changeExtraMeasures', 'changeMeasureGroups'],
		caption: this.view.caption,
		calculate: this.view.calculate,
		calculateOnlyVisibleMeasures: this.view.calculateOnlyVisibleMeasures,
		measureOnCols: this.view.measureOnCols,
		hideEmpty: hideEmpty,
		hideEmptyUsingVisibleMeasures: hideEmptyUsingVisibleMeasures,
		hideFixedMeasures: this.view.hideFixedMeasures,
		rowTotalsPosition: this.view.rowAxe.totalsPosition,
		colTotalsPosition: this.view.colAxe.totalsPosition,
		rowLevelNames: this.view.getNames(this.view.rowAxe.levels),
		colLevelNames: this.view.getNames(this.view.colAxe.levels),
		extraLevelNames: this.view.getNames(this.view.extraLevels),
		visibleMeasureNames: this.view.getNames(this.view.visibleMeasures),
		extraMeasureNames: this.view.getNames(this.view.extraMeasures),
		measureGroups: this.view.measureGroups,
	}, function(_response) {
		callback();
	});
};

/** Cette méthode connecte les évènements pour le choix de l'onglet ainsi que le contenu de chacun des 3 onglets */
BIReportGridConfiguration.prototype.internalConnect = function() {
	var self = this;
	if (!$.fn.dndDraggable)
		throw new Error('$.fn.dndDraggable requis');
	if (!$.fn.dndDroppable)
		throw new Error('$.fn.dndDroppable requis');
	if (!$.fn.popoverWithCheckBounds)
		throw new Error('$.fn.popoverWithCheckBounds requis');

	// Changement d'onglet
	this.target.children('ul').on('click', function(event) {
		// L'onglet sélectionné
		var li = $(event.target).closest('li');
		// Cacher l'ancien onglet
		li.siblings().removeClass('active');
		li.parent().siblings('div').hide();
		// Afficher l'onglet sélectionné
		li.addClass('active');
		li.parent().siblings('div').eq(li.index()).show();
		// prevent default
		return false;
	});

	// Activation du "glisser" depuis les 5 listes
	self.target.find('#bi-rowlevels, #bi-collevels, #bi-extralevels, #bi-extrameasures, #bi-measures').dndDraggable({
		selector: 'li',
		drag: function(operation) {
			var li = $(operation.draggable).closest('li');
			var item = li.data('item');
			operation.type = li.attr('data-type');
			operation.data = item;
			operation.caption = item.caption;
		}
	});

	// Activation du "déposer" entre les 3 listes de niveaux
	self.target.find('#bi-rowlevels, #bi-collevels, #bi-extralevels').dndDroppable({
		accept: ['level2'],
		selector: 'li',
		drop: function(operation) {
			// Récupération des 2 lignes du glisser/déposer
			var dragRow = $(operation.draggable).closest('li');
			var dropRow = $(operation.droppable).closest('li');
			if (dragRow.is(dropRow))
				return;
			// Insertion avant uniquement dans un cas particulier
			if (dragRow.parent().is(dropRow.parent()) && dragRow.index() > dropRow.index())
				dragRow.insertBefore(dropRow); // déplacement plus tôt dans la liste
			else
				dragRow.insertAfter(dropRow); // autres cas
		}
	});

	// Activation du "déposer" entre les 2 listes de measures et groupes
	self.target.find('#bi-extrameasures, #bi-measures').dndDroppable({
		accept: ['measure2', 'measureGroup2', 'extraMeasure2'],
		selector: 'li',
		drop: function(operation) {
			// Récupération des 2 lignes du glisser/déposer
			var dragRow = $(operation.draggable).closest('li');
			var dropRow = $(operation.droppable).closest('li');
			if (dragRow.is(dropRow))
				return;
			// Récupération des types des lignes (car plus compliqué que pour les niveaux)
			var dragType = operation.type;
			var dropType = dropRow.attr('data-type');
			if (dragType === 'measureGroup2') {
				var contentRows = dragRow.nextUntil(':not(.ingroup)');
				if (dropType === 'extraMeasure2') {
					// Drop d'un groupe de mesure dans la zone des mesures en extra
					dragRow.remove();
					contentRows.attr('data-type', 'extraMeasure2').removeClass('ingroup');
					contentRows.insertAfter(dropRow);
				} else {
					// Drop d'un groupe de mesure sur une mesure visible ou un autre groupe de mesure
					dragRow.insertBefore(dropRow);
					contentRows.insertBefore(dropRow);
				}
			} else {
				if (dropType === 'measureGroup2') {
					// Drop d'une mesure dans une groupe de mesure
					dragRow.attr('data-type', 'measure2').addClass('ingroup');
					dragRow.insertAfter(dropRow.nextUntil(':not(.ingroup)').last().get(0) || dropRow);
				} else {
					// Drop d'une mesure sur une autre mesure (visible ou en extra)
					dragRow.attr('data-type', dropType).toggleClass('ingroup', dropRow.hasClass('ingroup'));
					// Insertion avant uniquement dans un cas particulier
					if (dragRow.parent().is(dropRow.parent()) && dragRow.index() > dropRow.index())
						dragRow.insertBefore(dropRow); // déplacement plus tôt dans la liste
					else
						dragRow.insertAfter(dropRow); // autres cas
				}
			}
		}
	});

	// Retrait de niveaux / mesures / groupes depuis l'une des listes
	this.target.find('>div>ul').on('click', 'a.remove', function() {
		self.internalRemoveItem($(this).closest('li'));
	});

	// Ajout de niveaux dans l'une des trois listes
	this.target.find('button[data-type=levels]').popover({
		container: this.target.get(0),
		placement: 'auto bottom',
		html: true,
		content: function menuContent() {
			self.target.find('.popover').remove();
			var button = $(this);
			var content = $(''
				+ '<div style="width: 100%;">'
				+ '  <div style="text-align: right; ">'
				+ '    <button type="button" class="btn btn-link cancel"><i class="material-icons">clear</i></button>'
				+ '    <button type="button" class="btn btn-link validate"><i class="material-icons">done</i></button>'
				+ '  </div>'
				+ '  <div style="border-bottom: 1px solid #001F41; margin-bottom: 5px; ">'
				+ '    <i class="material-icons material-icons-16" style="color: #888; ">search</i>'
				+ '    <input class="form-control search" placeholder="' + self.lang.searchPlaceholder + '" style="display: inline-block; width: calc(100% - 40px); height: auto;  box-shadow: none; -webkit-box-shadow: none;" />'
				+ '    <a href="#" class="clear-search"><i class="material-icons material-icons-16">cancel</i></a>'
				+ '  </div>'
				+ '  <ul style="height: 200px; max-height: 200px; overflow-y: auto; overflow-x: hidden; "></ul>'
				+ '</div>');
			var cancelButton = content.find('button.cancel');
			var validateButton = content.find('button.validate');
			var searchInput = content.find('input.search');
			var clearSearchButton = content.find('a.clear-search');
			var levels = [].concat(self.view.levels).sort(BI.compareCaption);
			var list = content.children('ul');

			// Alimenter la liste avec les niveaux
			list.materialTree({
				showTextAsTitle: true,
				items: levels.map(function(level) {
					return {
						text: level.caption,
						selectable: true,
						level: level
					};
				}),
				customize: function(li, item) {
					li.data('item', item.level);
				}
			});

			// Recherche
			searchInput.on('input', function() {
				var text = searchInput.val().toLowerCase();
				list.children('li').each(function() {
					var visible = this.textContent.toLowerCase().indexOf(text) >= 0;
					this.style.display = (visible ? '' : 'none');
				});
			});
			// Vider la recherche
			clearSearchButton.on('click', function() {
				searchInput.val('').focus();
				list.find('li').show();
			});
			// Annuler l'ajout
			cancelButton.on('click', function() {
				list.find('li.bbm-tree-selected').removeClass('bbm-tree-selected');
				searchInput.val('');
				content.closest('.popover').popover('hide');
			});
			// Valider l'ajout
			validateButton.on('click', function() {
				var listContainers = self.target.find('#bi-rowlevels,#bi-collevels,#bi-extralevels');
				var container = listContainers.filter(button.attr('data-target'));
				list.find('li.bbm-tree-selected').removeClass('bbm-tree-selected').each(function() {
					var level = $(this).data('item');
					self.internalRemoveItem(self.internalFindItems(level, listContainers));
					self.internalCreateItem(level, 'level2').appendTo(container);
				});
				searchInput.val('');
				content.closest('.popover').popover('hide');
				return false; // ne pas fermer le popin, même si le bouton s'appelle "validate"
			});
			return content;
		}
	});

	// Ajout de mesure calculée
	this.target.find('button[data-type=measurecalculation]').click(function() {
		self.view.execute({
			operations: ['addMeasure'],
			caption: self.lang.configurationAddCalculationCaption,
			formula: '0',
			decimals: 0,
			format: 'Number'
		}, function(response) {
			if (response !== false) {
				var m = response;
				var measure = new BIReportMeasure(m.name, '', m.caption, '', m.width, m.type, m.decimals, m.format, m.formula, '', []);
				var container = self.target.find('#bi-measures');
				self.view.measures.push(measure);
				self.view.visibleMeasures.push(measure);
				self.internalCreateItem(measure, 'measure2').appendTo(container);
			}
		});
	});

	// Ajout d'un groupe de measure
	this.target.find('button[data-type=measuregroup]').click(function() {
		var group = new BIReportMeasureGroup(self.lang.configurationAddGroupCaption, 0, 0);
		var container = self.target.find('#bi-measures');
		self.internalCreateItem(group, 'measureGroup2').appendTo(container);
	});

	// Ajout de mesures dans l'une des deux listes
	this.target.find('button[data-type=measures]').popover({
		container: this.target.get(0),
		placement: 'auto bottom',
		html: true,
		content: function menuContent() {
			self.target.find('.popover').remove();
			var button = $(this);
			var content = $(''
				+ '<div style="width: 100%;">'
				+ '  <div style="text-align: right; ">'
				+ '    <button type="button" class="btn btn-link cancel"><i class="material-icons">clear</i></button>'
				+ '    <button type="button" class="btn btn-link validate"><i class="material-icons">done</i></button>'
				+ '  </div>'
				+ '  <div style="border-bottom: 1px solid #001F41; margin-bottom: 5px; ">'
				+ '    <i class="material-icons material-icons-16" style="color: #888; ">search</i>'
				+ '    <input class="form-control search" placeholder="' + self.lang.searchPlaceholder + '" style="display: inline-block; width: calc(100% - 40px); height: auto;  box-shadow: none; -webkit-box-shadow: none;" />'
				+ '    <a href="#" class="clear-search"><i class="material-icons material-icons-16">cancel</i></a>'
				+ '  </div>'
				+ '  <ul style="height: 200px; max-height: 200px; overflow-y: auto; overflow-x: hidden; "></ul>'
				+ '</div>');
			var cancelButton = content.find('button.cancel');
			var validateButton = content.find('button.validate');
			var searchInput = content.find('input.search');
			var clearSearchButton = content.find('a.clear-search');
			var sources = [].concat(self.view.measureSources).sort(BI.compareCaption);
			var measures = [].concat(self.view.measures).sort(BI.compareCaption);
			var list = content.children('ul');

			// Fonction qui transforme une "BIReportMeasure" en un "item" pour "materialTree"
			function measureToMaterialTree(measure) {
				return {
					text: measure.caption,
					selectable: true,
					measure: measure
				};
			}

			// Regrouper les mesures par source
			var items = sources.map(function(source) {
				return {
					text: source.caption,
					expanded: true,
					children: measures.filter(function(m) { return m.sourceName === source.name; }).map(measureToMaterialTree)
				};
			});

			// Ajouter si besoin une "source" pour les mesures calculées
			var calculatedMeasures = measures.filter(function(m) { return !m.sourceName; });
			if (calculatedMeasures.length !== 0) {
				items.push({
					text: self.lang.configurationCalculatedMeasuresSource,
					expanded: true,
					children: calculatedMeasures.map(measureToMaterialTree)
				});
			}

			// Alimenter la liste avec les mesures, regroupées par source
			list.materialTree({
				showTextAsTitle: true,
				items: items,
				customize: function(li, item) {
					if (item.measure)
						li.data('item', item.measure);
				}
			});

			// Recherche
			searchInput.on('input', function() {
				var text = searchInput.val().toLowerCase();
				// On parcourt les sources
				list.children('li').each(function() {
					// Afficher les sources si elles contiennent au moins une mesure visible
					var oneVisible = false;
					$(this).find('ul>li').each(function() {
						// Afficher les mesures si leur nom correspond
						var visible = this.textContent.toLowerCase().indexOf(text) >= 0;
						this.style.display = (visible ? '' : 'none');
						oneVisible = oneVisible || visible;
					});
					this.style.display = (oneVisible ? '' : 'none');
					this.classList.toggle('bbm-tree-expanded', oneVisible);
					this.classList.toggle('bbm-tree-collapsed', ! oneVisible);
				});
			});
			// Vider la recherche
			clearSearchButton.on('click', function() {
				searchInput.val('').focus();
				list.find('li').show();
			});
			// Annuler l'ajout
			cancelButton.on('click', function() {
				list.find('li.bbm-tree-selected').removeClass('bbm-tree-selected');
				searchInput.val('');
				content.closest('.popover').popover('hide');
			});
			// Valider l'ajout
			validateButton.on('click', function(_event) {
				var listContainers = self.target.find('#bi-measures,#bi-extrameasures');
				var container = listContainers.filter(button.attr('data-target'));
				var containerType = container.children(':first-child').attr('data-type');
				list.find('li.bbm-tree-selected').removeClass('bbm-tree-selected').each(function() {
					var measure = $(this).data('item');
					self.internalRemoveItem(self.internalFindItems(measure, listContainers));
					self.internalCreateItem(measure, containerType).appendTo(container);
				});
				searchInput.val('');
				content.closest('.popover').popover('hide');
				return false; // ne pas fermer le popin, même si le bouton s'appelle "validate"
			});
			return content;
		}
	});

	// Suite à la mise à jour 3.4.1 de Bootstrap, la propriété "template" est nettoyée, retirant notre attribut style présent jusqu'alors.
	// On pourrait passer l'option "sanitize" à false pour être tranquille mais c'est bof pour la sécurité.
	// Du coup, on injecte nos 3 propriétés une fois le popover dans la page. L'effet bonus, c'est que "left:auto" est bien pris en compte.
	// Note de version : https://github.com/twbs/bootstrap/releases/tag/v3.4.1
	// Options du popover : https://getbootstrap.com/docs/3.4/javascript/#popovers-options
	this.target.find('button[data-type=levels], button[data-type=measures]').on('shown.bs.popover', function() {
		self.target.children('.popover').css({
			width: '300px',
			right: '0',
			left: 'auto'
		});
	});

	// Popover pour les niveaux, mesures et groupes
	var popoverContentOptions = {
		onhidelevel: function(level) {
			// On récupère les 3 listes pouvant contenir des niveaux
			var listContainers = self.target.find('#bi-rowlevels,#bi-collevels,#bi-extralevels');
			// On recherche dedans le "li" correspondant au niveau
			var levelLi = self.internalFindItems(level, listContainers);
			// On l'envoie vers la liste des niveaux en "extra"
			levelLi.appendTo(listContainers.filter('#bi-extralevels'));
		},
		onshowlevel: function(level, axe) {
			// On récupère les 3 listes pouvant contenir des niveaux
			var listContainers = self.target.find('#bi-rowlevels,#bi-collevels,#bi-extralevels');
			// On recherche dedans le "li" correspondant au niveau
			var levelLi = self.internalFindItems(level, listContainers);
			// On l'envoie vers la liste des niveaux en ligne ou en colonne
			levelLi.insertAfter(listContainers.filter(axe === self.view.rowAxe ? '#bi-rowlevels' : '#bi-collevels').children(':first-child'));
		},
		oneditlevel: function(level, caption, _visibleAttributeIndex, _defaultState, _states) {
			// On récupère les 3 listes pouvant contenir des niveaux
			var listContainers = self.target.find('#bi-rowlevels,#bi-collevels,#bi-extralevels');
			// On recherche dedans le "li" correspondant au niveau
			var levelLi = self.internalFindItems(level, listContainers);
			// On utilise son nouvel intitulé
			levelLi.find('span').text(caption);
		},
		onshowmeasure: function(measure) {
			// On récupère les 2 listes pouvant contenir des measures
			var listContainers = self.target.find('#bi-measures,#bi-extrameasures');
			// On recherche dedans le "li" correspondant à la mesure
			var measureLi = self.internalFindItems(measure, listContainers);
			// On l'envoie à la fin de la liste des mesures visibles
			measureLi.removeClass('ingroup').appendTo(listContainers.filter('#bi-measures'));
		},
		onhidemeasure: function(measure) {
			// On récupère les 2 listes pouvant contenir des measures
			var listContainers = self.target.find('#bi-measures,#bi-extrameasures');
			// On recherche dedans le "li" correspondant à la mesure
			var measureLi = self.internalFindItems(measure, listContainers);
			// On l'envoie à la fin de la liste des mesures en "extra"
			measureLi.removeClass('ingroup').appendTo(listContainers.filter('#bi-extrameasures'));
		},
		onremovemeasure: function(measure) {
			// On récupère les 2 listes pouvant contenir des measures
			var listContainers = self.target.find('#bi-measures,#bi-extrameasures');
			// On recherche dedans le "li" correspondant à la mesure
			var measureLi = self.internalFindItems(measure, listContainers);
			// On supprime la ligne de la mesure
			measureLi.remove();
		},
		oneditmeasure: function(measure, caption, _decimals, _format, _highlights, _formula) {
			// On recherche le "li" correspondant à la mesure
			var measureLi = self.internalFindItems(measure, self.target.find('#bi-measures,#bi-extrameasures'));
			// On utilise son nouvel intitulé
			measureLi.find('span').text(caption);
		},
		ondeletegroup: function(group) {
			// On recherche le "li" correspondant au groupe
			var groupLi = self.internalFindItems(group, self.target.find('#bi-measures'));
			// On sort les mesures du groupe, en les gardant visibles
			groupLi.nextUntil(':not(.ingroup)').removeClass('ingroup');
			// On supprime le groupe
			groupLi.remove();
		},
		oneditgroup: function(group, caption) {
			// On recherche le "li" correspondant au groupe
			var groupLi = self.internalFindItems(group, self.target.find('#bi-measures'));
			// On utilise son nouvel intitulé
			groupLi.find('span').text(caption);
		},
	};

	// Création des popovers pour configuration des mesures, groupes de mesures ou niveaux
	// Demande de Nathalie le 27/11/2018 : donner accès au popover des niveaux dans la section "Filtres actifs"
	this.target.popoverWithCheckBounds({
		selector: 'li > a.customize, #bi-filterlevels > span',
		container: this.target,
		html: true,
		placement: 'auto bottom',
		template: '<div class="popover" role="tooltip"><div class="arrow"></div><div class="popover-content"></div></div>',
		content: function() {
			var container = $(this).closest('li,span');
			var type, item;
			if (container.is('span')) {
				type = 'level2';
				item = container.data('level');
			} else {
				type = container.attr('data-type');
				item = container.data('item');
			}
			self.target.children('.popover').remove();
			switch(type) {
				case 'measure2':
				case 'extraMeasure2':
					return BI.createPopoverForMeasure(self.view, item, null, popoverContentOptions);
				case 'measureGroup2':
					return BI.createPopoverForMeasureGroup(self.view, item, popoverContentOptions);
				case 'level2':
					return BI.createPopoverForLevel(self.view, item, popoverContentOptions);
				default:
					return '';
			}
		}
	});
};

/**
 * C'est un composant jQuery qui permet de définir les filtres (sur champs) d'un rapport via un popin.
 */
function BIReportGridFilters(target, view) {
	this.view = view;
	this.lang = BI.langs[BI.options.lang];
	this.target = $(target).addClass('bbm-report-filters').html(''
		+ '<div>'
		+ '  <div class="dropdown">'
		+ '    <button type="button" class="btn btn-link dropdown-toggle" data-toggle="dropdown">'
		+ '      ' + this.lang.filtersAddButton + ' <span class="caret"></span>'
		+ '    </button>'
		+ '    <ul class="dropdown-menu" style="max-height: 300px; overflow-y: auto;"></ul>'
		+ '  </div>'
		+ '</div>'
		+ '<table style="width: 100%; max-width: 100%; margin-top: 20px; table-layout: fixed; ">'
		+ '  <thead>'
		+ '    <tr>'
		+ '      <th style="width: 24px; ">&nbsp;</th>'
		+ '      <th style="width: auto; ">' + this.lang.filtersFieldHeader + '</th>'
		+ '      <th style="width: auto; ">' + this.lang.filtersOperatorHeader + '</th>'
		+ '      <th style="width: auto; ">' + this.lang.filtersValueHeader + '</th>'
		+ '    </tr>'
		+ '  </thead>'
		+ '  <tbody>'
		+ '  </tbody>'
		+ '  <tfoot style="display: none;">'
		+ '    <tr>'
		+ '      <td class="delete"><a href="#" title="' + this.lang.filtersRemoveButton + '"><i class="material-icons">delete</i></a></td>'
		+ '      <td class="field"></td>'
		+ '      <td class="operator"></td>'
		+ '      <td class="value"></td>'
		+ '    </tr>'
		+ '  </tfoot>'
		+ '</table>'
	);

	this.filters = [].concat(this.view.filters).sort(BI.compareCaption);

	this.internalPrepare();

	// Affichage du popin une fois que tout est prêt
	this.target.materialPopin({
		title: this.view.getPopinTitle(),
		closeButtonTitle: this.lang.filtersCancelButton,
		buttons : [{
			icon : 'done',
			visible : true,
			title: this.lang.filtersValidateButton,
			// Bloquer le popin tant que les modifications n'ont pas été appliquées
			// https://support.solvnet.fr:9998/devels/edit/2571
			onclickPromise : function validate() {
				var result = $.Deferred();
				this.internalValidate(function() {
					result.resolve();
				});
				return result;
			}.bind(this)
		}]
	});
}

BIReportGridFilters.prototype.internalPrepare = function() {
	// Récupérer le menu déroulant avec les filtres possibles
	var ul = this.target.find('>:first-child >.dropdown >ul');

	// Récupérer la table avec les filtres actifs
	var table = this.target.children('table').hide();

	// Ecouter la sélection dans le menu déroulant pour ajouter une ligne dans le tableau
	ul.on('click', 'a', function(event) {
		// Eviter le # dans l'URL
		event.preventDefault();
		// Récupérer l'entrée cliquée
		var li = $(event.target).closest('li');
		// Ajouter une ligne dans le tableau
		this.internalAdd(li, li.index());
	}.bind(this));

	// Ecouter le clic sur les boutons de suppression
	table.on('click', 'td.delete > a', function(event) {
		// Eviter le # dans l'URL
		event.preventDefault();
		// Récupérer la ligne, sans le supprimer pour le moment
		var tr = $(event.target).closest('tr');
		// Réafficher l'entrée dans le menu
		ul.children(':nth-child(' + (tr.data('filterIndex') + 1) + ')').show();
		// Supprimer la ligne, maintenant que ".data" a été utilisé
		tr.remove();
		// Afficher / cacher en fonction du nombre de lignes restantes
		table.toggle(! table.children('tbody').is(':empty'));
	});

	// Ecouter le changement d'opérateur pour cacher si besoin la zone texte de saisie
	table.on('change', '.operator > select', function() {
		// pour les booléens, il n'y a rien à cacher mais ça ne gêne pas donc on ne vérifiep pas...
		$(this).closest('td').next().toggle(BI.stringFilterOperators[this.value].pattern);
	});

	// Ajouter les filtres
	this.filters.forEach(function(filter, filterIndex) {
		// Ajouter une entrée dans le menu
		var a = $('<a href="#" />').text(filter.caption);
		var li = $('<li />').data('filter', filter).append(a).appendTo(ul);
		// Si le filtre en actif, ajouter une ligne dans la table
		if (filter.type.isFilterActive(filter))
			this.internalAdd(li, filterIndex);
	}.bind(this));
};

BIReportGridFilters.prototype.internalValidate = function(callback) {
	var self = this;

	// Désactiver les filtres
	this.filters.forEach(function(filter) {
		filter.min = null;
		filter.max = null;
		filter.operator = null;
		filter.pattern = null;
	});

	// Configurer les filtres demandés
	this.target.find('>table >tbody >tr').each(function() {
		// Parcourir chaque ligne du tableau
		var tr = $(this);
		// Récupérer le filtre
		var filter = self.filters[tr.data('filterIndex')];
		// Récupérer les valeurs saisies par l'utilisateur
		filter.type.applyFilterEditor(filter, self.lang, tr.children('.operator'), tr.children('.value'));
	});

	// Mettre à jour le reste en passant par le serveur
	var filterParams = $.map(this.view.filters, function(filter) {
		if (filter.type.isFilterActive(filter)) {
			var min = (typeof filter.min === 'number') ? filter.min.toString() : '';
			var max = (typeof filter.max === 'number') ? filter.max.toString() : '';
			var pattern = (typeof filter.pattern === 'string') ? filter.pattern : '';
			var operator = (typeof filter.operator === 'string') ? filter.operator : '';
			return filter.name + ";" + min + ";" + max + ";" + pattern + ";" + operator;
		}
	});
	this.view.execute({
		operations: ['changeFilters'],
		filters: filterParams
	}, function(_response) {
		callback();
	});
};

BIReportGridFilters.prototype.internalAdd = function(li, filterIndex) {
	// Afficher la table si au moins 1 critère
	var table = this.target.children('table').show();
	// Création de la ligne en clonant le template
	var tr = table.find('>tfoot>tr').clone().data('filterIndex', filterIndex).appendTo(table.children('tbody'));
	// Récupérer le filtre
	var filter = li.data('filter');

	// Chaque filtre ne peut être ajouté qu'une fois
	li.hide();
	// Nom de champ pour la ligne
	tr.children('.field').text(filter.caption);
	// Alimentation de la partie à saisir par l'utilisateur
	filter.type.buildFilterEditor(filter, this.lang, tr.children('.operator'), tr.children('.value'));
};

/**
 * Cette méthode, appelée par les 4 types de popover (attribut, niveau, mesure ou groupe) assemble les actions (= boutons) et les onglets (avec leur contenu).
 *
 * @param {BIReportView} _view - la vue du rapport, pas utile à date
 * @param {Array} tabs - la liste des onglets, sous forme d'un tableau d'objet à 2 propriétés "caption" (String) et "content" (DOM)
 * @param {Array} buttons - les actions spécifiques au popover (sans "Valider" et "Annuler", qui sont gérés automatiquement) sous la forme d'objets (title / danger / icon / onclick)
 * @param {Function} onvalidate - la fonction à appeler quand l'utilisateur valide les modifications
 * @returns le contenu à insérer dans un popover
 */
BI.createPopover = function(_view, tabs, buttons, onvalidate) {
	var lang = BI.langs[BI.options.lang];
	var content = $(''
		+ '<div class="bbm-report-popover">'
		+ '  <div>'
		+ '    <span class="bbm-report-popover-actions">'
		+ '      <button type="button" class="btn btn-link text-primary bbm-report-cancel" title="' + lang.popoverButtonCancel + '"><i class="material-icons">clear</i></button>'
		+ '      <button type="button" class="btn btn-link text-primary bbm-report-validate" title="' + lang.popoverButtonValidate + '"><i class="material-icons">done</i></button>'
		+ '    </span>'
		+ '    <span class="bbm-report-popover-tabs" style="white-space: nowrap; " />'
		+ '  </div>'
		+' </div>'
	);

	// Boutons d'onglets
	var tabBar = content.find('.bbm-report-popover-tabs');
	tabs.forEach(function(tab, tabIndex) {
		$('<button type="button" class="btn" />').text(tab.caption).addClass(tabIndex === 0 ? 'btn-primary' : 'btn-link').appendTo(tabBar);
		$('<div />').toggle(tabIndex === 0).append(tab.content).appendTo(content);
	});
	tabBar.on('click', 'button', function(event) {
		var tabButton = $(event.target).closest('button');
		tabBar.children().removeClass('btn-primary').addClass('btn-link');
		tabButton.addClass('btn-primary').removeClass('btn-link');
		content.children(':nth-child(n+2)').hide().get(tabButton.index()).style.display = 'block';
		return false;
	});

	// Boutons d'actions
	var actionBar = content.find('.bbm-report-popover-actions');
	actionBar.prepend(buttons.map(function(button) {
		return $('<button type="button" class="btn btn-link" />')
			.attr('title', button.title)
			.addClass(button.danger ? 'text-danger' : 'text-primary')
			.append('<i class="material-icons">' + button.icon + '</i>')
			.on('click', function() {
				button.onclick();
				content.closest('.popover').remove();
			})[0];
	}));

	// Bouton de validation
	actionBar.on('click', 'button.bbm-report-validate', function() {
		// Appliquer les modifications
		onvalidate(function() {
			// et fermer le popover si tout va bien
			content.closest('.popover').remove();
		});
	});

	// Bouton d'annulation
	actionBar.on('click', 'button.bbm-report-cancel', function() {
		//var popoverPlugin = content.closest('.popover').parent().data('bs.popover');
		content.closest('.popover').remove();
	});
	return content;
};

/**
 * Cette méthode crée le contenu de l'onglet de renommage commun aux popovers d'attribut, niveau, mesure ou groupe.
 *
 * @param lang l'objet de traduction
 * @param item l'élément à renommer (qui a une propriété "caption" et éventuellement une propriété "defaultCaption")
 * @returns le contenu à insérer dans un onglet du popover
 */
BI.createPopoverRenameInput = function(lang, item) {
	var result = $(''
		+ '<div style="position: relative; ">'
		+ '  <input type="text" class="form-control" placeholder="' + lang.popoverCaptionPlaceholder + '" style="width: 100%; min-width: 300px;" />'
		+ '  <button type="button" class="btn btn-link text-primary" style="position: absolute; right: 0; top: 0; z-index: 1; ">'
		+ '    <i class="material-icons material-icons-16">replay</i></button>'
		+ '  </button>'
		+ '</div>'
	);
	result.children('input').val(item.caption);
	result.children('button').on('click', function() {
		result.children('input').val(item.defaultCaption || '');
		return false;
	});
	return result;
};

/**
 * Cette méthode crée le contenu d'un popover permettant l'édition d'un niveau.
 *
 * @param view la vue du rapport
 * @param level le niveau à éditer
 * @param options paramètres optionnels comme par exemple "oneditlevel"
 * @returns le contenu à insérer dans un popover
 */
BI.createPopoverForLevel = function(view, level, options) {
	var lang = BI.langs[BI.options.lang];
	var isRow = view.rowAxe.levels.indexOf(level) >= 0;
	var isCol = view.colAxe.levels.indexOf(level) >= 0;

	// Onglet du renommage du niveau
	var inputContent = BI.createPopoverRenameInput(lang, level);

	// Onglet de choix des attributs
	var attributesContent = '';
	if (level.attributes.length > 0) {
		attributesContent = $('<ul class="list-group" style="padding-top: 20px; " />');
		level.visibleAttributeIndex.forEach(function(attributeIndex) {
			var attribute = level.attributes[attributeIndex];
			$('<li class="list-group-item active" />').data('attribute', attribute).text(attribute.caption).appendTo(attributesContent);
		});
		level.attributes.forEach(function(attribute, attributeIndex) {
			if (level.visibleAttributeIndex.indexOf(attributeIndex) < 0)
				$('<li class="list-group-item" />').data('attribute', attribute).text(attribute.caption).appendTo(attributesContent);
		});
		attributesContent.children().css('padding', '3px 15px').on('click', function() {
			$(this).toggleClass('active');
		});

		if ($.fn.dndDraggable && $.fn.dndDroppable) {
			attributesContent.dndDraggable({
				type: 'attribute',
				selector: 'li'
			}).dndDroppable({
				accept: ['attribute'],
				selector: 'li',
				drop: function(operation) {
					var drag = $(operation.draggable);
					var drop = $(operation.droppable);
					if (drag.index() < drop.index())
						drag.insertAfter(drop);
					else
						drag.insertBefore(drop);
				}
			});
		}
	}

	// Onglet de modification des filtres
	var filtersPanel = BI.createPopoverFilterPanel(lang, view, level);

	// Action 1 : Cacher le niveau
	function hideLevel() {
		if (options && options.onhidelevel)
			options.onhidelevel(level);
		view.execute({
			operations: ['hideLevel'],
			levelName: level.name,
		});
	}

	// Action 2/3 : Afficher le niveau en ligne ou en colonne
	function showLevel(oldAxe, newAxe) {
		var extraLevelIndex = view.extraLevels.indexOf(level);
		if (extraLevelIndex >= 0)
			view.extraLevels.splice(extraLevelIndex, 1);
		else
			oldAxe.levels.splice(oldAxe.levels.indexOf(level), 1);
		newAxe.levels.unshift(level);
		view.execute({
			operations: (extraLevelIndex >= 0) ? ['changeExtraLevels', 'changeAxeLevels'] : ['changeAxeLevels'],
			extraLevelNames: (extraLevelIndex >= 0) ? view.getNames(view.extraLevels) : null,
			rowLevelNames: view.getNames(view.rowAxe.levels),
			colLevelNames: view.getNames(view.colAxe.levels)
		});
	}
	function showLevelInRows() {
		if (options && options.onshowlevel)
			options.onshowlevel(level, view.rowAxe);
		showLevel(view.colAxe, view.rowAxe);
	}
	function showLevelInCols() {
		if (options && options.onshowlevel)
			options.onshowlevel(level, view.colAxe);
		showLevel(view.rowAxe, view.colAxe);
	}

	// Action 4 : Tri ascendant / descendant
	function changeLevelSort() {
		level.sortAscending = !level.sortAscending;
		if (isRow || isCol) {
			view.execute({
				operations: [isRow ? 'changeRowLevelSort' : 'changeColLevelSort'],
				levelName: level.name
			});
		}
	}

	// Action 5 : Tout déployer / diminuer
	function changeLevelExpanded() {
		level.allExpanded = !level.allExpanded;
		if (isRow || isCol) {
			view.execute({
				operations: [isRow ? 'changeRowLevelExpanded' : 'changeColLevelExpanded'],
				levelName: level.name
			});
		}
	}

	// Fonction principale d'édition du niveau
	function editLevel(done) {
		var caption = inputContent.children('input').val() || level.defaultCaption || '...';
		var visibleAttributeIndex = level.attributes.length === 0 ? [] : attributesContent.children('.active').get().map(function(li) {
			return level.attributes.indexOf($(li).data('attribute'));
		});
		var defaultState = filtersPanel.getDefaultState();
		var states = filtersPanel.getStates(defaultState);
		if (options && options.oneditlevel)
			options.oneditlevel(level, caption, visibleAttributeIndex, defaultState, states);
		level.caption = caption;
		level.visibleAttributeIndex = visibleAttributeIndex;
		level.defaultState = defaultState;
		level.hasCustomStates = states.length > 0;
		view.execute({
			operations: ['renameLevel', 'changeLevelAttributes', 'changeLevelFilter'],
			levelName: level.name,
			caption: level.caption,
			attributeNames: level.visibleAttributeIndex.map(function(i) {
				return level.attributes[i].name;
			}),
			defaultState: defaultState,
			states: states.map(function(entry) {
				// on teste entry.key par rapport à undefined car entry.key peut valoir 0 et dans ce cas
				// le test entry.key tout seul renvoie false. https://support.solvnet.fr:9998/devels/edit/1845
				return (BI.isValue(entry.key) ? level.keyType.formatInternalNotEmpty(entry.key) : '') + '=' + entry.state;
			}).join('||'),
		}, function(_response) {
			// Fermer le popover
			done();
		});
	}

	// Popover
	var tabs = [];
	tabs.push({ caption: lang.popoverTabFilters, content: filtersPanel.content });
	tabs.push({ caption: lang.popoverTabRename, content: inputContent });
	if (attributesContent)
		tabs.push({ caption: lang.popoverTabAttributes, content: attributesContent });

	var buttons = [];
	if (isRow || isCol)
		buttons.push({ title: lang.popoverButtonHide, danger: false, icon: 'visibility_off', onclick: hideLevel });
	if (!isRow)
		buttons.push({ title: lang.popoverButtonShowInRows, danger: false, icon: 'view_headline', onclick: showLevelInRows });
	if (!isCol)
		buttons.push({ title: lang.popoverButtonShowInCols, danger: false, icon: 'view_column', onclick: showLevelInCols });
	buttons.push({ title: level.sortAscending ? lang.popoverButtonSortDescending : lang.popoverButtonSortAscending, danger: false, icon: 'swap_vert', onclick: changeLevelSort });
	buttons.push({ title: level.allExpanded ? lang.popoverButtonCollapseAll : lang.popoverButtonExpandAll, danger: false, icon: 'iso', onclick: changeLevelExpanded });

	return BI.createPopover(view, tabs, buttons, editLevel);
};

/**
 * Cette méthode crée le contenu de l'onglet permettant de gérer les filtres d'un niveau en popover.
 *
 * @param lang l'objet de traduction
 * @param view la vue du rapport
 * @param level le niveau dont on souhaite modifier les filtres
 * @returns le contenu à insérer dans un onglet du popover
 */
BI.createPopoverFilterPanel = function(lang, view, level) {
	var panel = $(''
		+ '<div>'
		+ '  <div>'
		+ '    <input type="checkbox" id="bbm-report-popover-advanced" disabled="disabled"/>'
		+ '    <label for="bbm-report-popover-advanced">' + lang.popoverLevelAdvancedFiltersLabel + '</label>'
		+ '  </div>'
		+ '  <div class="simple-filter">'
		+ '    <input type="checkbox" id="bbm-report-popover-select" disabled="disabled"/>'
		+ '    <label for="bbm-report-popover-select">' + lang.popoverLevelSelectAllMembersTitle + '</label>'
		+ '    <label for="bbm-report-popover-select" style="display: none;" >' + lang.popoverLevelUnselectAllMembersTitle + '</label>'
		+ '  </div>'
		+ '  <div class="complex-filter" style="max-width: 500px; display: none; ">'
		+ '    <div>'
		+ '      <label for="bbm-report-popover-default-state">' + lang.popoverLevelDefaultStateLabel + '</label>'
		+ '      <select id="bbm-report-popover-default-state" style="float: right; ">'
		+ '        <option value="Visible">' + lang.levelFilterStates.Visible + '</option>'
		+ '        <option value="Included">' + lang.levelFilterStates.Included + '</option>'
		+ '        <option value="Filtered">' + lang.levelFilterStates.Filtered + '</option>'
		+ '        <option value="Inheritable">' + lang.levelFilterStates.Inheritable + '</option>'
		+ '      </select>'
		+ '    </div>'
		+ '    <div>'
		+ '      <input type="radio" id="bbm-report-popover-state-action-apply" name="bbm-report-popover-state-action" />'
		+ '      <label for="bbm-report-popover-state-action-apply">' + lang.popoverLevelApplyStateRadio + '</label>'
		+ '      <input type="radio" id="bbm-report-popover-state-action-filter" name="bbm-report-popover-state-action" checked />'
		+ '      <label for="bbm-report-popover-state-action-filter">' + lang.popoverLevelFilterStateRadio + '</label>'
		+ '      <select id="bbm-report-popover-state-action-select" style="float: right; ">'
		+ '        <option value="">-</option>'
		+ '        <option value="Visible">' + lang.levelFilterStates.Visible + '</option>'
		+ '        <option value="Included">' + lang.levelFilterStates.Included + '</option>'
		+ '        <option value="Filtered">' + lang.levelFilterStates.Filtered + '</option>'
		+ '        <option value="Inheritable">' + lang.levelFilterStates.Inheritable + '</option>'
		+ '      </select>'
		+ '    </div>'
		+ '  </div>'
		+ '  <div>'
		+ '    <i class="material-icons material-icons-16" style="color: #888;">search</i>'
		+ '    <input id="bbm-report-popover-search" type="text" class="form-control" placeholder="' + lang.popoverLevelMemberSearchPlaceholder + '" style="display: inline-block; width: calc(100% - 40px); height: auto; " disabled="disabled"/>'
		+ '    <a href="#" id="bbm-report-popover-clear-search"><i class="material-icons material-icons-16">cancel</i></a>'
		+ '  </div>'
		+ '  <div style="max-height: 300px; overflow-y: auto; padding-top: 5px; ">'
		+ '    <ul class="list-group simple-filter" />'
		+ '    <table class="table complex-filter" style="display: none; padding-bottom: 0; white-space: nowrap; " />'
		+ '  </div>'
		+ '</div>'
	);

	// Coche "Recherche avancée"
	var advancedCheckbox = panel.find('#bbm-report-popover-advanced').materialCheckbox({}).on('change', function() {
		var checked = advancedCheckbox.prop('checked');
		panel.find('.simple-filter').toggle(!checked);
		panel.find('.complex-filter').toggle(!!checked);
		if (checked && table.is(':empty'))
			fillTable();
		searchInput.trigger('input');
	});

	// Zone de recherche, visible en mode simple (filtre les "li") ou avancé (filtre les "tr").
	var searchInput = panel.find('#bbm-report-popover-search');

	// Coche "Tout sélectionner" / "Tout désélectionner"
	var selectCheckbox = panel.find('#bbm-report-popover-select').materialCheckbox({}).on('change', function() {
		var checked = selectCheckbox.prop('checked');
		selectCheckbox./*encapsulée par materialCheckbox*/parent().next().toggle(!checked).next().toggle(checked); // inverser le libellé
		ul.children().toggleClass('active', checked);
	}).prop('checked', level.defaultState === 'Visible');

	// Liste simple de sélection
	var ul = panel.find('ul').on('click', 'li', function() {
		$(this).toggleClass('active');
	});

	// Composants des filtres avancés
	var defaultStateSelect = panel.find('#bbm-report-popover-default-state').val(level.defaultState);
	var stateActionApplyRadio = panel.find('#bbm-report-popover-state-action-apply');
	// var stateActionFilterRadio = panel.find('#bbm-report-popover-state-action-filter');
	var stateActionSelect = panel.find('#bbm-report-popover-state-action-select');
	var table = panel.find('table');

	// Filtrer la liste / Affecter le statut
	stateActionSelect.on('change', function() {
		var state = this.value;
		if (stateActionApplyRadio.prop('checked')) {
			if (state)
				table.find('tr:visible > td > select').val(state);
		} else if (!state) {
			table.children().css('display', '');
		} else {
			table.children().each(function() {
				var s = this.childNodes[1].childNodes[0].value;
				this.style.display = (s === state) ? '' : 'none';
			});
		}
	});

	// Zone de recherche dans les filtres avancés
	searchInput.on('input', function() {
		var text = this.value.toLowerCase();
		ul.children().each(function() {
			var caption = this.textContent.toLowerCase();
			this.style.display = (caption.indexOf(text) >= 0) ? '' : 'none';
		});
		table.children().each(function() {
			var caption = this.childNodes[0].textContent.toLowerCase();
			this.style.display = (caption.indexOf(text) >= 0) ? '' : 'none';
		});
	});

	panel.find('#bbm-report-popover-clear-search').on('click', function() {
		searchInput.val('').focus();
		ul.children().css('display', '');
		table.children().css('display', '');
	});

	function memberCaption (level, member, captionWhenUndef) {
		var captionType = level.captionType || level.keyType;
		var caption = level.captionType ? member.caption : member.key;
		if (BI.isValue(caption))
			caption = captionType.formatHeaderNotEmpty(caption, lang, level.decimals, level.format);
		else
			caption = captionWhenUndef;
		if (member.code)
			caption += ' (' + member.code + ')';
		return caption;
	}

	// La table de filtres avancés, qu'on ne remplira que si l'utilisateur passe sur cette partie
	function fillTable() {
		var selectModel = defaultStateSelect.clone().removeAttr('id')[0];
		table.append(members.map(function(member) {
			// key [caption] [code] state visible
			var caption = memberCaption(level, member, lang.popoverLevelEmptyCaption);
			var td1 = document.createElement('td');
			var td2 = document.createElement('td');
			var select = selectModel.cloneNode(true);
			td1.textContent = caption;
			td2.appendChild(select);
			select.value = member.state;
			return BI.buildElement('tr').data('member', member).append(td1).append(td2).toDOM();
		}));
	}

	// Demander les membres au serveur pour compléter la liste
	var members;
	view.execute({
		operations: ['queryMembers'],
		levelName: level.name,
	}, function(response) {
		members = response;
		// Dans les filtres rapides, ...
		ul.append(members.map(function(member) {
			// on cache les éléments inutiles car filtrés par d'autres niveaux
			if (! member.visible)
				return undefined;
			// on ajoute des "li" à activer / désactiver pour choisir les éléments "visibles"
			var caption = memberCaption(level, member, '');
			var li = $('<li class="list-group-item">&nbsp;</i>').data('member', member);
			li.toggleClass('active', member.state === 'Visible');
			if (caption)
				li.text(caption);
			return li[0];
		}));
		ul.children().css('padding', '3px 15px');

		// Réactiver les éléments une fois les données chargées par queryMembers
		// https://support.solvnet.fr:9998/devels/edit/3247
		$('#bbm-report-popover-advanced, #bbm-report-popover-select, #bbm-report-popover-search').removeAttr('disabled');
	});

	return {
		content: panel,
		getDefaultState: function() {
			var advanced = advancedCheckbox.prop('checked');
			if (advanced)
				return defaultStateSelect.val();
			return selectCheckbox.prop('checked') ? 'Visible' : 'Filtered';
		},
		getStates: function(defaultState) {
			var advanced = advancedCheckbox.prop('checked');
			var items, getState;
			if (advanced) {
				items = table.children();
				getState = function(tr) { return tr.find('select').val(); };
			} else {
				items = ul.children();
				getState = function(li) { return li.is('.active') ? 'Visible' : 'Filtered'; };
			}
			return items.map(function() {
				var item = $(this);
				var member = item.data('member');
				var state = getState(item);
				if (state === defaultState)
					// pas besoin de sauvegarder => on le retire de la liste
					return undefined;
				return { key: member.key, state: state };
			}).get();
		}
	};
};

/**
 * Cette méthode crée le contenu d'un popover permettant l'édition d'un attribut.
 *
 * @param view la vue du rapport
 * @param attribute l'attribut à éditer
 * @param level le niveau possédant cet attribut
 * @param _options paramètres optionnels, actuellement inutilisé mais cohérent avec les autres "popover"
 * @returns le contenu à insérer dans un popover
 */
BI.createPopoverForAttribute = function(view, attribute, level, _options) {
	var lang = BI.langs[BI.options.lang];

	// Onglet de renommage de l'attribut
	// NB : a priori le seul onglet
	var inputContent = BI.createPopoverRenameInput(lang, attribute);

	// Action 1 : Cacher l'attribut
	// NB : pour le moment, le seul endroit où on a ce popover est sur un attribut visible
	function hideAttribute() {
		var attributeIndex = level.attributes.indexOf(attribute);
		var indexInVisibleIndex = level.visibleAttributeIndex.indexOf(attributeIndex);
		if (indexInVisibleIndex >= 0) {
			level.visibleAttributeIndex.splice(indexInVisibleIndex, 1);
			view.execute({
				operations: ['hideAttribute'],
				levelName: level.name,
				attributeName: attribute.name,
			});
		}
	}

	// Fonction principale d'édition de l'attribut
	function editAttribute(done) {
		var caption = inputContent.children('input').val() || attribute.defaultCaption || '...';
		attribute.caption = caption;
		view.execute({
			operations: ['renameAttribute'],
			levelName: level.name,
			attributeName: attribute.name,
			caption: attribute.caption
		}, function(_response) {
			// Fermer le popover
			done();
		});
	}

	// Popover
	var tabs = [];
	tabs.push({ caption: lang.popoverTabRename, content: inputContent });
	var buttons = [];
	buttons.push({ title: lang.popoverButtonHide, danger: false, icon: 'visibility_off', onclick: hideAttribute });
	return BI.createPopover(view, tabs, buttons, editAttribute);
};

/**
 * Cette méthode crée le contenu d'un popover permettant l'édition d'une mesure.
 *
 * @param view la vue du rapport
 * @param measure la mesure à éditer
 * @param nodeIndex l'index de la ligne ou de la colonne si on a cliqué dans la grille pour éctiver les action de tri sur mesure
 * @param options paramètres optionnels comme par exemple "oneditmeasure"
 * @returns le contenu à insérer dans un popover
 */
BI.createPopoverForMeasure = function(view, measure, nodeIndex, options) {
	var lang = BI.langs[BI.options.lang];
	var isVisible = view.visibleMeasures.indexOf(measure) >= 0;
	var isNumber = measure.type === BI.types.number;
	var isCalculated = !measure.sourceName;

	// Onglet de renommage de la measure
	var inputContent = BI.createPopoverRenameInput(lang, measure);

	// Onglet de format d'affichage
	var formatContent = '';
	if (isNumber) {
		formatContent = $(''
			+ '<table>'
			+ '  <tr>'
			+ '    <td><label for="popover-decimals" style="margin-bottom: 0; ">' + lang.popoverMeasureDecimalsLabel + '</label></td>'
			+ '    <td><input type="text" class="form-control" id="popover-decimals" style="width: 60px; margin: 0 30px 0 5px; text-align: right; " /></td>'
			+ '    <td style="width: 20px; "></td>'
			+ '    <td><label for="popover-format" style="margin-bottom: 0; ">' + lang.popoverMeasureFormatLabel + '</label></td>'
			+ '    <td><select class="form-control" id="popover-format" style="width: 60px; margin: 0 0 0 5px; text-align: right; ">'
			+ '      <option value="Number">-</option>'
			+ '      <option value="Currency">€</option>'
			+ '      <option value="Percent">%</option>'
			+ '      <option value="Kilograms">kg</option>'
			+ '      <option value="Grams">g</option>'
			+ '      <option value="Meters">m</option>'
			+ '      <option value="Kilometers">km</option>'
			+ '      <option value="Seconds">s</option>'
			+ '    </select></td>'
			+ '  </tr>'
			+ '</table>'
		);
		formatContent.find('input').val((measure.decimals || 0).toString());
		formatContent.find('select').val(measure.format.name);
	}

	// Onglet pour définir des seuils de couleurs
	var colorsContent = '';
	if (isNumber) {
		var addRange = function(h, defaultColor, defaultFontColor) {
			var tr = $(''
				+ '<tr>'
				+ '  <td><span style="display: inline-block; width: 22px; height: 22px; border-radius: 50%; text-align: center; ">T</span></td>'
				+ '  <td style="padding-left: 10px; "><input type="tel" class="form-control min" placeholder="' + lang.popoverMeasureHighlightMinPlaceholder + '" style="height: auto; text-align: right; width: 85px; " /></td>'
				+ '  <td style="padding-left: 10px; "><input type="tel" class="form-control max" placeholder="' + lang.popoverMeasureHighlightMaxPlaceholder + '" style="height: auto; text-align: right; width: 85px; " /></td>'
				+ '  <td style="padding-left: 10px; "><input type="text" class="form-control color" placeholder="' + lang.popoverMeasureHighlightBackgroundColorPlaceHolder + '" style="height: auto; text-align: right; width: 100px; " /></td>'
				+ '  <td style="padding-left: 10px; "><input type="text" class="form-control fontcolor" placeholder="' + lang.popoverMeasureHighlightFontColorPlaceHolder + '" style="height: auto; text-align: right; width: 100px; " /></td>'
				+ '</tr>'
			);
			var previewSpan = tr.find('>td:first-child > span');
			tr.find('input.color').on('change', function(event) {
				var newColorValue = event.target.value || defaultColor;
				previewSpan.css('backgroundColor', newColorValue);
				tr.data('color', newColorValue);
			});
			tr.find('input.fontcolor').on('change', function(event) {
				var newFontColorValue = event.target.value || defaultFontColor;
				previewSpan.css('color', newFontColorValue);
				tr.data('fontcolor', newFontColorValue);
			});
			if (h) {
				tr.find('input.min').val((typeof h.min === 'number') ? h.min.toString() : '');
				tr.find('input.max').val((typeof h.max === 'number') ? h.max.toString() : '');
				tr.find('input.color').val((typeof h.color === 'string' && h.color !== defaultColor) ? h.color : '');
				tr.find('input.fontcolor').val((typeof h.fontColor === 'string' && h.fontColor !== defaultFontColor) ? h.fontColor : '');
			}
			previewSpan
				.css('backgroundColor', (h && h.color) ? h.color : defaultColor)
				.css('color', (h && h.fontColor) ? h.fontColor : defaultFontColor);
			tr.data('color', (h && h.color) ? h.color : defaultColor);
			tr.data('fontcolor', (h && h.fontColor) ? h.fontColor : defaultFontColor);
			tr.appendTo(colorsContent);
		};
		colorsContent = $('<table />');
		var defaultColors = ['#FED64E', '#F37576', '#7FCEEC', '#AED17F'];
		var highlights = measure.highlights || [];
		for (var i = 0; i < defaultColors.length; i++) {
			var h = highlights[i];
			var defaultColor = defaultColors[i];
			var defaultFontColor = '#000000';
			addRange(h, defaultColor, defaultFontColor);
		}
		// Contrôle de saisie des nombres (pavé numérique + vider la valeur si mal saisie)
		colorsContent.find('input.min,input.max').on('change', function() {
			var n = Number(this.value);
			this.value = (!this.value || Number.isNaN(n)) ? '' : n.toString();
		});
		// Contrôle de saisie des couleurs (composant colorpicker si dispo + vider la valeur si mal saisie)
		if ($.fn.colorpicker) {
			colorsContent.find('input.color,input.fontcolor').colorpicker({ format:'hex' }).on('change', function() {
				if (this.value==='#aN') // #aN est généré par le composant colorpicker quand la valeur saisie est incorrecte
					this.value = '';
			});
		}
	}

	// Onglet pour modifier la formule
	var formulaContent = '',
		selectedOperation;
	if (isCalculated) {
		// Contenu de l'onglet
		formulaContent = $(''
			+ '<div style="margin: 10px; ">'
			+ '  <div style="height: 40px; line-height: 40px; margin-bottom: 15px; ">'
			+ '    <label for="mpop_s" style="width: 40%; margin: 0px; vertical-align: middle">' + lang.popoverCalculatedMeasureCalculations + '</label>'
			+ '    <select id="mpop_s" class="form-control" style="display: inline-block; width: 58%; font-size: 13px; vertical-align: middle; " />'
			+ '  </div>'
			+ '  <div style="height: 40px; line-height: 40px;">'
			+ '    <label for="mpop_m" style="width: 40%; margin: 0px; vertical-align: middle">' + lang.popoverCalculatedMeasureMeasures + '</label>'
			+ '    <select id="mpop_m" multiple="multiple" style="display: inline-block; width: 58%; font-size: 13px; vertical-align: middle; " />'
			+ '  </div>'
			+ '  <div style="height: 40px; line-height: 40px;">'
			+ '    <label for="mpop_m1" style="width: 40%; margin: 0px; vertical-align: middle">' + lang.popoverCalculatedMeasureMeasure1 + '</label>'
			+ '    <select id="mpop_m1" class="form-control" style="display: inline-block; width: 58%; font-size: 13px; vertical-align: middle; " />'
			+ '  </div>'
			+ '  <div style="height: 40px; line-height: 40px;">'
			+ '    <label for="mpop_m2" style="width: 40%; margin: 0px; vertical-align: middle">' + lang.popoverCalculatedMeasureMeasure2 + '</label>'
			+ '    <select id="mpop_m2" class="form-control" style="display: inline-block; width: 58%; font-size: 13px; vertical-align: middle; ">'
			+ '      <option value=""></option>'
			+ '    </select>'
			+ '  </div>'
			+ '  <div style="height: 40px; line-height: 40px;">'
			+ '    <label for="pop_v" style="width: 40%; margin: 0px; vertical-align: middle">' + lang.popoverCalculatedMeasureValue + '</label>'
			+ '    <input id="pop_v" type="number" class="form-control" style="display: inline-block; width: 58%; font-size: 13px; vertical-align: middle; " />'
			+ '  </div>'
			+ '  <div style="height: 40px; line-height: 40px;">'
			+ '    <label for="mpop_r" style="width: 40%; margin: 0px; vertical-align: middle; line-height: 18px; ">' + lang.popoverCalculatedMeasureReplaceNullByZero + '</label>'
			+ '    <input id="mpop_r" type="checkbox" style="display: inline-block; font-size: 13px; " />'
			+ '  </div>'
			+ '  <div style="height: 40px; line-height: 40px;">'
			+ '    <textarea rows="2" class="form-control" style="display: inline-block; width: 100%; font-size: 13px; vertical-align: middle; resize: none;" placeholder="' + lang.popoverCalculatedMeasureFormulaPlaceholder + '" />'
			+ '  </div>'
			+ '</div>'
		);

		// Références
		var	$selectOperation = formulaContent.find('#mpop_s'),
			$measures = formulaContent.find('#mpop_m'),
			$measure1 = formulaContent.find('#mpop_m1'),
			$measure2 = formulaContent.find('#mpop_m2'),
			$value = formulaContent.find('#pop_v'),
			$replaceEmpty = formulaContent.find('#mpop_r'),
			$customFormula = formulaContent.find('textarea');

		// Listes des mesures (numériques) pouvant être sélectionnées
		var measureLists = [$measures, $measure1, $measure2];
		view.measures.forEach(function(m) {
			// La formule de "measure" ne peut pas utiliser "measure" elle-même
			// NB: elle ne peut pas non plus utilisée une mesure qui dépend indirectement de "measure".
			// Toutefois, on n'a rien ici pour filtrer à fond donc on délègue au serveur qui sait détecter les références circulaires
			if (m === measure)
				return;
			// Une option par mesure
			$('<option />').text(m.caption).val(m.caption)
				// On marque les mesures numériques car, sauf 3 exceptions, les calculs n'utilisent que des nombres
				.attr('data-numeric', m.type === BI.types.integer || m.type === BI.types.number)
				.appendTo(measureLists);
		});

		// Construction du formulaire
		$measures.multiselect({
			enableFiltering: true,
			enableCaseInsensitiveFiltering: true,
			buttonClass: 'btn btn-link',
			buttonWidth: '58%',
			numberDisplayed: 2,
			nonSelectedText: lang.popoverCalculatedMeasureNoSelection,
			nSelectedText: lang.popoverCalculatedMeasureNSelected,
			includeSelectAllOption: false,
			maxHeight: 300
		});

		// Formules
		var operations = [],
			noNullFunc, // Initialisé avec le retour serveur
			noNullFmt = function(m) {
				if ($replaceEmpty.is(':checked'))
					return noNullFunc + '("' + m + '")';
				return m ? ('"' + m + '"') : '';
			};

		// Nouvelle formule sélectionnée, on met à jour le contenu de l'onglet
		$selectOperation.on('change', function() {
			// Récupérer l'option choisie dans le "select" des calculs possibles
			var $optionSelected = $selectOperation.children('option:selected');
			// Récupérer l'opération assiociée, et la stocker pour la sauvegarde/fermeture de la popin
			selectedOperation = operations[$optionSelected.index()];

			// Affichage du formulaire ne fonction de l'opération
			$measures.parent().toggle(selectedOperation.measures);
			$measure1.parent().toggle(selectedOperation.measure1);
			$measure2.parent().toggle(selectedOperation.measure2);
			$value.val('' + selectedOperation.value).parent().toggle(selectedOperation.value !== '');
			$replaceEmpty.parent().toggle(selectedOperation.replaceEmpty);
			$customFormula.parent().toggle($optionSelected.is(':last-child'));

			// Prise en compte du format demandé par l'opération, si précisé
			if (selectedOperation.defaultFormat !== null)
				formatContent.find('select').val(selectedOperation.defaultFormat);

			// Prise en compte du nombre de décimales demandé par l'opération, si précisé
			if (selectedOperation.defaultDecimals !== null)
				formatContent.find('input').val((selectedOperation.defaultDecimals).toString());

			// Cacher les mesures non numériques si l'opération ne travaille qu'avec les nombres
			if (selectedOperation.numericMeasuresOnly != null)
				formulaContent.find('option[data-numeric="false"]').toggle(!selectedOperation.numericMeasuresOnly);
		});

		// On demande la liste des formules et on les ajoute une fois reçues
		view.execute({
			operations: ['measureSettings']
		}, function(response) {
			function addOperation(caption, measures, measure1, measure2, value, replaceEmpty, defaultFormat, defaultDecimals, numericMeasuresOnly, formula) {
				// Option du SELECT
				$selectOperation.append($('<option />').text(caption));
				// Création/ajout de l'opération
				operations.push({
					caption: caption,
					measures: !!measures,
					measure1: !!measure1,
					measure2: !!measure2,
					value: value == null ? '' : value.toString(),
					replaceEmpty: !!replaceEmpty,
					defaultFormat: defaultFormat,
					defaultDecimals: defaultDecimals,
					numericMeasuresOnly: numericMeasuresOnly,
					getFormula: formula
				});
			}

			// Fonction "Remplacer vide par zéro"
			noNullFunc = response.noNullFunction;

			// Formules de base (+ - * / et pourcentage)
			function addOperatorCalculation(caption, measures, percent, operator, extraValue) {
				var defaultFormat = percent ? 'Percent' : 'Number';
				var defaultDecimals = percent ? 2 : null;
				addOperation(caption, measures, !measures, !measures, extraValue, true, defaultFormat, defaultDecimals, true, function() {
					var parts;
					if (measures) {
						parts = ($measures.val() || []).map(noNullFmt);
						parts.push(parseFloat($value.val()));
					} else {
						parts = [noNullFmt($measure1.val())];
						parts.push($measure2.val() ? noNullFmt($measure2.val()) : parseFloat($value.val()));
					}
					return parts.join(' ' + operator + ' ');
				});
			}
			addOperatorCalculation(lang.popoverCalculatedMeasureAddition, true, false, "+", 0.0);
			addOperatorCalculation(lang.popoverCalculatedMeasureSubstraction, false, false, "-", 0.0);
			addOperatorCalculation(lang.popoverCalculatedMeasureMultiplication, true, false, "*", 1.0);
			addOperatorCalculation(lang.popoverCalculatedMeasureDivision, false, false, "/", 1.0);
			addOperatorCalculation(lang.popoverCalculatedMeasurePercentage, false, true, "/", null);

			// Formule représentant une vue différente d'une mesure, dont la traduction vient du serveur
			function addViewCalculation(name, numeric, percent, decimals) {
				var operationFromServer = response.operations[name];
				var caption = operationFromServer.caption;
				var defaultFormat = percent ? 'Percent' : numeric ? 'Number' : null;
				var defaultDecimals = (typeof decimals === 'number') ? decimals : null;
				addOperation(caption, false, true, false, null, false, defaultFormat, defaultDecimals, numeric, function() {
					return operationFromServer.localeName + '("' + $measure1.val() + '")';
				});
			}
			addViewCalculation('TotalRowPercentage', true, true, 2);
			addViewCalculation('TotalColPercentage', true, true, 2);
			addViewCalculation('ParentRowPercentage', true, true, 2);
			addViewCalculation('ParentColPercentage', true, true, 2);
			addViewCalculation('RankInRow', true, false, 0);
			addViewCalculation('RankInCol', true, false, 0);
			addViewCalculation('CumulativeRowAddition', true, false, null);
			addViewCalculation('CumulativeColAddition', true, false, null);
			addViewCalculation('PreviousRowAddition', true, false, null);
			addViewCalculation('PreviousColAddition', true, false, null);
			addViewCalculation('PreviousRowSubstraction', true, false, null);
			addViewCalculation('PreviousColSubstraction', true, false, null);
			addViewCalculation('PreviousRowEvolution', true, true, 2);
			addViewCalculation('PreviousColEvolution', true, true, 2);
			addViewCalculation('PreviousRowValue', false, false, null);
			addViewCalculation('PreviousColValue', false, false, null);
			addViewCalculation('GrandTotal', false, false, null);

			// Formule personnalisée
			addOperation(lang.popoverCalculatedMeasureFormula, false, false, false, null, false, null, null, null, function() {
				return $customFormula.val();
			});

			// Affichage initial : on affiche la textarea avec la formule
			$customFormula.val(measure.formula || '');
			$selectOperation.children('option:last-child').prop('selected', true);
			$selectOperation.change();
		});
	}

	// Action 1 : Afficher la mesure
	function showMeasure() {
		if (options && options.onshowmeasure)
			options.onshowmeasure(measure);
		view.extraMeasures.splice(view.extraMeasures.indexOf(measure), 1);
		view.visibleMeasures.push(measure);
		view.execute({
			operations: ['changeExtraMeasures', 'changeVisibleMeasures'],
			extraMeasureNames: view.getNames(view.extraMeasures),
			visibleMeasureNames: view.getNames(view.visibleMeasures),
		});
	}

	// Action 2 : Cacher la mesure
	function hideMeasure() {
		if (options && options.onhidemeasure)
			options.onhidemeasure(measure);
		view.execute({
			operations: ['hideMeasure'],
			measureName: measure.name,
		});
	}

	// Action 3 : Changer le tri sur mesure
	function toggleMeasureSort() {
		view.execute({
			operations: ['toggleMeasureSort'],
			measureName: measure.name,
			index: nodeIndex
		});
	}

	// Action 4 : Supprimer la mesure
	function removeMeasure() {
		if (options && options.onremovemeasure)
			options.onremovemeasure(measure);
		view.removeMeasure(measure);
	}

	// Fonction principale d'édition de la mesure
	function editMeasure(done) {
		var caption = inputContent.children('input').val() || measure.defaultCaption || '...';
		var decimals = null, format = null, formula = null, highlights = [], operations = ['renameMeasure'];
		if (formatContent) {
			decimals = Number.parseInt(formatContent.find('input').val() || '0');
			format = formatContent.find('select').val();
			operations.push('formatMeasure');
		}
		if (colorsContent) {
			highlights = colorsContent.children('tr').map(function() {
				var tr = $(this);
				var color = tr.data('color');
				var fontColor = tr.data('fontcolor');
				var min = tr.find('input.min').val();
				var max = tr.find('input.max').val();
				return new BIReportMeasureHighlight(min ? Number.parseFloat(min) : null, max ? Number.parseFloat(max) : null, color, fontColor);
			}).get();
			operations.push('colorMeasure');
		}
		if (formulaContent) {
			// L'opération "changeMeasureFormula" doit être la dernière pour encoder la
			// "response" une fois la mesure définie (caption, format, couleur, formule)
			formula = selectedOperation.getFormula();
			operations.push('changeMeasureFormula');
		}

		if (options && options.oneditmeasure)
			options.oneditmeasure(measure, caption, decimals, format, highlights, formula);
		measure.caption = caption;
		measure.decimals = decimals;
		measure.format = BI.getNumberFormat(format);
		measure.highlights = highlights;
		// pas encore, on le fera dans la callback si la formule est acceptée
		//measure.formula = formula;
		view.execute({
			operations: operations,
			measureName: measure.name,
			caption: caption,
			decimals: decimals,
			format: format,
			measureHighlights: highlights.reduce(function(array, h) { array.push(h.min, h.max, h.color, h.fontColor); return array; }, []),
			formula: formula,
		}, function(response) {
			// Si "response" est un objet, c'est que le serveur accepte la formule et renvoie en échange la mesure, dont certaines propriétés peuvent avoir changées
			// Si "response" est "false", c'est que le serveur refuse la formule. Dans ce cas, on ne ferme pas le popover.
			// Sinon, "response" devrait être indéfini et la mesure n'est pas une mesure calculée. Dans ce cas, pas d'erreur, on peut fermer le popover

			// Quand on change la formule, d'autres infos comme le "type" peuvent changer
			if (typeof response === 'object') {
				measure.type = BI.getType(response.type);
				measure.decimals = response.decimals;
				measure.format = BI.getNumberFormat(response.format || 'Number');
				if (response.highlights) {
					measure.highlights = response.highlights.map(function(h) {
						return new BIReportMeasureHighlight(h.min, h.max, h.color, h.fontColor);
					});
				}
				measure.formula = response.formula;
			}

			// Fermer le popover si la formule est acceptée ou simplement si la mesure n'est pas une mesure calculée.
			if (response !== false)
				done();
			else if (formulaContent)
				formulaContent.addClass('text-danger');
		});
	}

	// Popover
	var tabs = [];
	tabs.push({ caption: lang.popoverTabRename, content: inputContent });
	if (formatContent)
		tabs.push({ caption: lang.popoverTabFormat, content: formatContent });
	if (colorsContent)
		tabs.push({ caption: lang.popoverTabColors, content: colorsContent });
	if (formulaContent)
		tabs.push({ caption: lang.popoverTabFormula, content: formulaContent });
	var buttons = [];
	if (!isVisible)
		buttons.push({ title: lang.popoverButtonShow, danger: false, icon: 'visibility', onclick: showMeasure });
	if (isVisible && view.visibleMeasures.length >= 2)
		buttons.push({ title: lang.popoverButtonHide, danger: false, icon: 'visibility_off', onclick: hideMeasure });
	if (typeof nodeIndex === 'number')
		buttons.push({ title: lang.popoverButtonMeasureSort, danger: false, icon: 'swap_vert', onclick: toggleMeasureSort });
	if (isCalculated)
		buttons.push({ title: lang.popoverButtonDelete, danger: true, icon: 'delete', onclick: removeMeasure });

	return BI.createPopover(view, tabs, buttons, editMeasure);
};

/**
 * Cette méthode crée le contenu d'un popover permettant l'édition d'un groupe de mesures.
 *
 * @param view la vue du rapport
 * @param group le groupe à éditer
 * @param options paramètres optionnels comme par exemple "oneditgroup"
 * @returns le contenu à insérer dans un popover
 */
BI.createPopoverForMeasureGroup = function(view, group, options) {
	var lang = BI.langs[BI.options.lang];

	// Onglet 1 : Renommage du groupe
	// NB : a priori le seul onglet
	var inputContent = BI.createPopoverRenameInput(lang, group);

	// Action 1 : Supprimer le groupe
	// NB : a priori la seule action
	function deleteGroup() {
		if (options && options.ondeletegroup)
			options.ondeletegroup(group);
		view.measureGroups.splice(view.measureGroups.indexOf(group), 1);
		view.execute({
			operations: ['changeMeasureGroups'],
			measureGroups: view.measureGroups
		});
	}

	// Fonction principale d'édition du groupe
	function editGroup(done) {
		var caption = inputContent.children('input').val() || '...';
		if (options && options.oneditgroup)
			options.oneditgroup(group, caption);
		group.caption = caption;
		view.execute({
			operations: ['changeMeasureGroups'],
			measureGroups: view.measureGroups
		}, function(_response) {
			// Fermer le popover
			done();
		});
	}

	// Popover
	var tabs = [];
	tabs.push({ caption: lang.popoverTabRename, content: inputContent });
	var buttons = [];
	buttons.push({ title: lang.popoverButtonDelete, danger: true, icon: 'delete', onclick: deleteGroup });
	return BI.createPopover(view, tabs, buttons, editGroup);
};

BI.createPopoverForMember = function(view, td, target) {
	var nodeIndex = td.data('nodeIndex');
	var isRow = td.closest('div').is('.bbm-report-left');
	var axe = isRow ? view.rowAxe : view.colAxe;
	var node = axe.nodes[nodeIndex];
	var level = axe.levels[node.depth];
	var actions = view.getNodeActions(node, level);
	var menu = BI.buildElement('div').addClass('list-group').addClass('bbm-report-popover-menu');
	var lang = BI.langs[BI.options.lang];
	var hasEntry = false;
	actions.forEach(function(action, index) {
		// si le tableau contient { name: 'separator' }, on ajoute un séparateur
		if (action.name === 'separator') {
			// éviter les séparateurs inutiles
			if (hasEntry && index !== actions.length - 1) {
				BI.buildElement('div').addClass('list-group-item').addClass('separator').appendTo(menu);
				hasEntry = false;
			}
			return;
		}
		// si le tableau contient { name: 'expand' }, on ajoute si possible une entrée pour déployer le noeud
		if (action.name === 'expand') {
			if (!node.expandable || node.expanded)
				return;
			action.caption = lang['popoverNodeExpand'];
			action.icon = 'add_circle';
			action.onclick = function(_node, _level, view, nodeIndex, isRow) {
				view.execute({
					operations: [isRow ? 'changeRowExpanded' : 'changeColExpanded'],
					index: nodeIndex
				});
			};
		}
		// si le tableau contient { name: 'collapse' }, on ajoute si possible une entrée pour diminuer le noeud
		if (action.name === 'collapse') {
			if (!node.expandable || !node.expanded)
				return;
			action.caption = lang['popoverNodeCollapse'];
			action.icon = 'remove_circle';
			action.onclick = function(_node, _level, view, nodeIndex, isRow) {
				view.execute({
					operations: [isRow ? 'changeRowExpanded' : 'changeColExpanded'],
					index: nodeIndex
				});
			};
		}
		// si le tableau contient { name: 'exclude' }, on ajoute une entrée pour passer le membre en "Exclus (modifiable)"
		if (action.name === 'exclude') {
			action.caption = lang['popoverNodeExclude'];
			action.icon = 'visibility_off';
			action.onclick = function(_node, level, view, nodeIndex, _isRow) {
				view.execute({
					operations: ['hideMember'],
					levelName: level.name,
					index: nodeIndex
				});
			};
		}
		// Que l'action soit prédéfinie (ci-dessus) ou personnalisée, on n'a plus qu'à ajouter l'entrée de menu
		var a = BI.buildElement('a').addClass('list-group-item')
			.text(action.caption)
			.prepend(BI.buildElement('i').addClass('material-icons').addClass('material-icons-16').text(action.icon))
			.appendTo(menu);
		if (action.onclick)
			a.attr('href', '#').on('click', function() {
				action.onclick(node, level, view, nodeIndex, isRow);
				target.children('.popover').popover('destroy');
			});
		else
			a.attr('href', action.onurl(node, level, view, nodeIndex, isRow));
		hasEntry = true;
	});
	return menu.toDOM();
};

BaseAPI.registerJQueryPlugin('biGridSearch', BIReportGridSearch);
BaseAPI.registerJQueryPlugin('biGridCustomization', BIReportGridCustomization);
BaseAPI.registerJQueryPlugin('biGrid', BIReportGrid);
BaseAPI.registerJQueryPlugin('biGridConfiguration', BIReportGridConfiguration);
BaseAPI.registerJQueryPlugin('biGridFilters', BIReportGridFilters);

return {
	options: BI.options,
	langs: BI.langs,
	numberFormats: BI.numberFormats,
	getNumberFormat: BI.getNumberFormat,
	getType: BI.getType,

	ReportFilter: BIReportFilter,
	ReportAttribute: BIReportAttribute,
	ReportLevel: BIReportLevel,
	ReportMeasureGroup: BIReportMeasureGroup,
	ReportMeasureSource: BIReportMeasureSource,
	ReportMeasure: BIReportMeasure,
	ReportMeasureHighlight: BIReportMeasureHighlight,
	ReportNode: BIReportNode,
	ReportAxe: BIReportAxe,
	ReportView: BIReportView,
};

})(window.jQuery, window.moment, window.BaseAPI);
